/* --- ITECHVISTA SERP LOGIC v11 (Shopify Liquid Edition) --- */

    const MINIFY_MAP = {
        query: 'q', platform: 'p', theme: 't', browserSkin: 'bs', editorTheme: 'et',
        time: 'tm', battery: 'b', textSize: 'ts', hideExitButton: 'he',
        hideStatusIcons: 'hs', hideTime: 'ht', results: 'r',
        id: 'i', title: 'tt', url: 'u', displayUrl: 'd', desc: 'ds', favicon: 'f',
        sitelinks: 'sl', isSponsored: 'sp', rating: 'rt', reviews: 'rv', date: 'dt', thumbnail: 'tn',
        aiOverview: 'ai', paa: 'paa'
    };

    // ==================== ENHANCED TEMPLATE LIBRARY ====================
    const TEMPLATES = [
        // --- E-COMMERCE (existing, now with multiple results + AI/PAA) ---
        {
            id: 1,
            name: "Amazon Product Page",
            category: "E-Commerce",
            description: "Product listing with reviews, ratings, and buy button",
            /* Tab content. Templates shipped with none of this, so every tab
               other than All opened on defaults no matter which template you
               picked - which made the new surfaces look broken rather than
               empty. */
            products: [
                {id: 101, title: "Apple iPhone 15 Pro Max 256GB - Natural Titanium", price: "$1,099.00",
                 was: "$1,199.00", merchant: "Amazon", rating: 4.7, reviews: "12k+",
                 specs: "6.7\" \u00b7 A17 Pro \u00b7 5x zoom", place: "", sale: true, image: ""},
                {id: 102, title: "Apple iPhone 15 Pro 128GB - Blue Titanium", price: "$899.00",
                 was: "", merchant: "Best Buy", rating: 4.6, reviews: "8k+",
                 specs: "6.1\" \u00b7 A17 Pro \u00b7 3x zoom", place: "", sale: false, image: ""}
            ],
            query: "iPhone 15 Pro Max 256GB",
            theme: "light",
            platform: "mobile",
            browserSkin: "safari-ios",
            aiOverview: { enabled: true, content: "The iPhone 15 Pro Max features a titanium design, A17 Pro chip, and a powerful camera system with 5x optical zoom. It also includes USB-C charging and the Action button." },
            paa: { enabled: true, questions: [
                {id: 101, q: "Is iPhone 15 Pro Max waterproof?", a: "It has an IP68 rating, meaning it can withstand water up to 6 meters for 30 minutes."},
                {id: 102, q: "What colors are available?", a: "Natural Titanium, Blue Titanium, White Titanium, and Black Titanium."}
            ]},
            results: [
                {id: 1, title: "Apple iPhone 15 Pro Max (256GB) - Titanium", url: "https://www.amazon.com/iPhone-15", displayUrl: "amazon.com › iPhone-15-Pro-Max", desc: "$1,199.00 · Free shipping · In stock · Brand: Apple · Storage: 256GB · Color: Natural Titanium", favicon: "https://www.google.com/s2/favicons?domain=amazon.com&sz=64", sitelinks: ["Product Details", "Customer Reviews", "Compare Models"], isSponsored: true, rating: 4.7, reviews: 2450, date: "", thumbnail: ""},
                {id: 2, title: "iPhone 15 Pro Max Clear Case", url: "https://www.amazon.com/iPhone-case", displayUrl: "amazon.com › iPhone-15-case", desc: "$39.99 · Official Apple case with MagSafe · Works with iPhone 15 Pro Max", favicon: "https://www.google.com/s2/favicons?domain=amazon.com&sz=64", sitelinks: [], isSponsored: false, rating: 4.5, reviews: 328, date: "", thumbnail: ""}
            ]
        },
        {
            id: 2,
            name: "Nike Running Shoes",
            category: "E-Commerce",
            description: "Sports product page with sizing and reviews",
            /* Tab content. Templates shipped with none of this, so every tab
               other than All opened on defaults no matter which template you
               picked - which made the new surfaces look broken rather than
               empty. */
            products: [
                {id: 201, title: "Nike Air Zoom Pegasus 41 - Men's Road Running Shoes", price: "$139.99",
                 was: "$160.00", merchant: "Nike", rating: 4.5, reviews: "3k+",
                 specs: "Road \u00b7 Neutral \u00b7 ReactX foam", place: "", sale: true, image: ""},
                {id: 202, title: "Nike Invincible 3 - Men's Road Running Shoes", price: "$180.00",
                 was: "", merchant: "Dick's", rating: 4.4, reviews: "1k+",
                 specs: "Road \u00b7 Max cushioning", place: "", sale: false, image: ""}
            ],
            query: "Nike Air Zoom Pegasus 40",
            theme: "light",
            platform: "desktop",
            browserSkin: "chrome-desktop",
            aiOverview: { enabled: false, content: "" },
            paa: { enabled: false, questions: [] },
            results: [
                {id: 1, title: "Nike Air Zoom Pegasus 40 Men's Running Shoes", url: "https://www.nike.com/t/air-zoom-pegasus", displayUrl: "nike.com › air-zoom-pegasus-40", desc: "$129.97 · 4.7 ★ (1,243 reviews) · Responsive cushioning · Breathable mesh · Secure fit", favicon: "https://www.google.com/s2/favicons?domain=nike.com&sz=64", sitelinks: ["Size Guide", "Reviews", "Return Policy"], isSponsored: true, rating: 4.7, reviews: 1243, date: "", thumbnail: ""},
                {id: 2, title: "Nike Running Socks (3-Pack)", url: "https://www.nike.com/socks", displayUrl: "nike.com › running-socks", desc: "$18.00 · Dri-FIT technology · Cushioned sole · Available in sizes S-XL", favicon: "https://www.google.com/s2/favicons?domain=nike.com&sz=64", sitelinks: [], isSponsored: false, rating: 4.3, reviews: 876, date: "", thumbnail: ""}
            ]
        },
        {
            id: 4,
            name: "Rick Roll Prank",
            category: "Prank",
            description: "A classic bait and switch setup",
            /* Tab content. Templates shipped with none of this, so every tab
               other than All opened on defaults no matter which template you
               picked - which made the new surfaces look broken rather than
               empty. */
            /* The prank template is the one people reach for, and it is a
               video link by nature - so it carries the Videos fields rather
               than falling back to placeholder durations. */
            videoDefaults: true,
            query: "How to get free money",
            theme: "light",
            platform: "mobile",
            browserSkin: "chrome-android",
            aiOverview: { enabled: true, content: "There is no legitimate way to get free money instantly. Be cautious of scams claiming otherwise." },
            paa: { enabled: true, questions: [
                {id: 401, q: "Are government grants real?", a: "Yes, but they require applications and are not instant. Legitimate grants are listed on Grants.gov."},
                {id: 402, q: "What is a common online scam?", a: "Phishing emails promising money in exchange for personal information are very common."}
            ]},
            results: [
                {id: 1, title: "Government Grant Program 2024 - Apply Now", url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", displayUrl: "grants.gov › apply-online", desc: "Official government grant portal. Apply for up to $10,000 in free assistance. No repayment required. Click to verify eligibility.", favicon: "https://www.google.com/s2/favicons?domain=usa.gov&sz=64", date: "New Program", thumbnail: ""},
                {id: 2, title: "Free Money Giveaway - Limited Time", url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", displayUrl: "free-money.com › giveaway", desc: "Enter now to win $5,000! No purchase necessary. Ends soon.", favicon: "https://www.google.com/s2/favicons?domain=free-money.com&sz=64", date: "", thumbnail: ""}
            ]
        },
        {
            id: 5,
            name: "SEO Agency Ranking",
            category: "Business",
            description: "Fake ranking for an agency",
            query: "Best SEO Agency New York",
            theme: "light",
            platform: "desktop",
            browserSkin: "chrome-desktop",
            aiOverview: { enabled: false, content: "" },
            paa: { enabled: false, questions: [] },
            results: [
                {id: 1, title: "Top SEO Company NYC | #1 Rated Digital Agency", url: "https://example-agency.com", displayUrl: "example-agency.com › nyc-seo", desc: "Award-winning SEO services in New York. We help businesses grow their organic traffic by 200%. Call for a free consultation today.", favicon: "", sitelinks: ["Case Studies", "Our Team", "Pricing"], isSponsored: false, rating: 5.0, reviews: 450, thumbnail: ""},
                {id: 2, title: "NYC SEO Services - 50% Off First Month", url: "https://seo-nyc.com", displayUrl: "seo-nyc.com › special-offer", desc: "Limited time offer: get started with a complete SEO audit for just $99. Includes keyword research and competitor analysis.", favicon: "", sitelinks: [], isSponsored: true, rating: 4.8, reviews: 132, date: "", thumbnail: ""}
            ]
        },
        // --- NEW TEMPLATES (each with multiple results and sometimes AI/PAA) ---
        {
            id: 6,
            name: "Local Coffee Shop",
            category: "Local Business",
            description: "Coffee shop with map, hours, and reviews",
            /* Tab content. Templates shipped with none of this, so every tab
               other than All opened on defaults no matter which template you
               picked - which made the new surfaces look broken rather than
               empty. */
            places: [
                {id: 601, name: "Starbucks Coffee - Union Square", rating: 4.2, reviews: "1.2k",
                 price: "$$", category: "Coffee shop", open: "Open", address: "3 Union Square W",
                 tags: "Dine-in \u00b7 Takeout \u00b7 Delivery",
                 note: "Free Wi-Fi and mobile ordering at most locations.",
                 sponsored: false, thumbs: []},
                {id: 602, name: "Blue Bottle Coffee", rating: 4.6, reviews: "820",
                 price: "$$", category: "Coffee shop", open: "Closes 7 PM", address: "1 Rockefeller Plaza",
                 tags: "Dine-in \u00b7 Takeout", note: "Single-origin pour-over and cold brew on tap.",
                 sponsored: false, thumbs: []}
            ],
            query: "Starbucks near me",
            theme: "light",
            platform: "mobile",
            browserSkin: "safari-ios",
            aiOverview: { enabled: true, content: "Starbucks offers a variety of coffee drinks, pastries, and breakfast items. Many locations have free Wi-Fi and mobile ordering." },
            paa: { enabled: true, questions: [
                {id: 601, q: "What are today's hours?", a: "Most locations are open 5:30 AM – 9 PM, but hours vary by store."},
                {id: 602, q: "Do they have dairy-free options?", a: "Yes, oat milk, almond milk, and soy milk are available."}
            ]},
            results: [
                {id: 1, title: "Starbucks Coffee - Union Square", url: "https://starbucks.com/store/123", displayUrl: "starbucks.com › store-locator", desc: "4.2 ★ (1.2k) · $$ · Open until 10 PM · Dine-in, takeout, delivery", favicon: "https://www.google.com/s2/favicons?domain=starbucks.com&sz=64", sitelinks: ["Menu", "Directions", "Reviews"], isSponsored: false, rating: 4.2, reviews: 1243, date: "", thumbnail: ""},
                {id: 2, title: "Starbucks - Financial District", url: "https://starbucks.com/store/456", displayUrl: "starbucks.com › fin-district", desc: "4.0 ★ (850) · Opens 6 AM · Mobile orders accepted", favicon: "https://www.google.com/s2/favicons?domain=starbucks.com&sz=64", sitelinks: [], isSponsored: false, rating: 4.0, reviews: 850, date: "", thumbnail: ""}
            ]
        },
        {
            id: 7,
            name: "Tech News Article",
            category: "News",
            description: "Latest tech news with date and author",
            /* Tab content. Templates shipped with none of this, so every tab
               other than All opened on defaults no matter which template you
               picked - which made the new surfaces look broken rather than
               empty. */
            newsDefaults: true,
            query: "ChatGPT new features",
            theme: "light",
            platform: "desktop",
            browserSkin: "firefox-desktop",
            aiOverview: { enabled: true, content: "OpenAI continues to roll out updates to ChatGPT, including voice conversations, image recognition, and faster response times." },
            paa: { enabled: false, questions: [] },
            results: [
                {id: 1, title: "OpenAI announces ChatGPT voice mode", url: "https://techcrunch.com/2024/chatgpt-voice", displayUrl: "techcrunch.com › 2024/03/15", desc: "New real-time conversations with AI now available to Plus users. The update includes five new voices and improved response times.", favicon: "https://www.google.com/s2/favicons?domain=techcrunch.com&sz=64", sitelinks: [], isSponsored: false, rating: 0, reviews: 0, date: "Mar 15, 2024", thumbnail: ""},
                {id: 2, title: "ChatGPT gets memory feature", url: "https://theverge.com/chatgpt-memory", displayUrl: "theverge.com › 2024/02/20", desc: "Now ChatGPT can remember facts across conversations. You can also ask it to forget specific things.", favicon: "https://www.google.com/s2/favicons?domain=theverge.com&sz=64", sitelinks: [], isSponsored: false, rating: 0, reviews: 0, date: "Feb 20, 2024", thumbnail: ""}
            ]
        },
        {
            id: 8,
            name: "Recipe: Chocolate Cake",
            category: "Food",
            description: "Recipe result with rating and cook time",
            query: "best chocolate cake recipe",
            theme: "light",
            platform: "mobile",
            browserSkin: "safari-ios",
            aiOverview: { enabled: false, content: "" },
            paa: { enabled: true, questions: [
                {id: 801, q: "Can I make it gluten-free?", a: "Yes, substitute all‑purpose flour with a 1:1 gluten-free baking flour."},
                {id: 802, q: "How long does it keep?", a: "Store in an airtight container at room temperature for up to 3 days, or refrigerate for up to a week."}
            ]},
            results: [
                {id: 1, title: "Perfectly Moist Chocolate Cake", url: "https://sallysbakingaddiction.com/chocolate-cake", displayUrl: "sallysbakingaddiction.com › chocolate-cake", desc: "★★★★★ (2.3k) · 1 hr 30 mins · This is the best chocolate cake recipe. It's rich, moist, and covered in creamy chocolate frosting.", favicon: "https://www.google.com/s2/favicons?domain=sallysbakingaddiction.com&sz=64", sitelinks: ["Reviews", "Nutrition"], isSponsored: false, rating: 4.9, reviews: 2340, date: "Feb 2024", thumbnail: ""},
                {id: 2, title: "One-Bowl Chocolate Cake", url: "https://foodnetwork.com/chocolate-cake", displayUrl: "foodnetwork.com › recipes", desc: "★★★★ (890) · 45 mins · Easy, no-mixer recipe from Ina Garten. Uses cocoa powder and hot coffee for depth.", favicon: "https://www.google.com/s2/favicons?domain=foodnetwork.com&sz=64", sitelinks: [], isSponsored: false, rating: 4.4, reviews: 890, date: "", thumbnail: ""}
            ]
        },
        {
            id: 9,
            name: "Job Listing",
            category: "Jobs",
            description: "Software engineer job with salary",
            query: "remote software engineer jobs",
            theme: "light",
            platform: "desktop",
            browserSkin: "edge-desktop",
            aiOverview: { enabled: false, content: "" },
            paa: { enabled: false, questions: [] },
            results: [
                {id: 1, title: "Senior Frontend Engineer (Remote)", url: "https://wellfound.com/jobs/123", displayUrl: "wellfound.com › jobs › frontend", desc: "$140k – $180k · 5+ years React experience · Health insurance, 401k matching, unlimited PTO", favicon: "https://www.google.com/s2/favicons?domain=wellfound.com&sz=64", sitelinks: ["Apply Now", "Company Info"], isSponsored: true, rating: 0, reviews: 0, date: "Posted 2 days ago", thumbnail: ""},
                {id: 2, title: "Backend Engineer (Node.js) - Remote", url: "https://remotive.com/jobs/backend", displayUrl: "remotive.com › backend-jobs", desc: "$120k – $160k · 3+ years Node experience · 100% remote, equity options, wellness stipend", favicon: "https://www.google.com/s2/favicons?domain=remotive.com&sz=64", sitelinks: [], isSponsored: false, rating: 0, reviews: 0, date: "Posted 1 week ago", thumbnail: ""}
            ]
        },
        {
            id: 10,
            name: "Event Tickets",
            category: "Events",
            description: "Concert tickets with date and venue",
            query: "Taylor Swift tickets 2024",
            theme: "dark",
            platform: "mobile",
            browserSkin: "chrome-android",
            aiOverview: { enabled: true, content: "Taylor Swift's Eras Tour continues in 2024 with additional North American and international dates. Tickets are in high demand; check resale platforms." },
            paa: { enabled: true, questions: [
                {id: 1001, q: "Are tickets still available?", a: "Official tickets are sold out, but verified resale tickets are available on Ticketmaster and StubHub."},
                {id: 1002, q: "What is the setlist?", a: "The setlist typically includes songs from all eras, with a rotating 'surprise song' each night."}
            ]},
            results: [
                {id: 1, title: "Taylor Swift | The Eras Tour", url: "https://ticketmaster.com/taylor-swift", displayUrl: "ticketmaster.com › taylor-swift-tickets", desc: "Sat, Aug 17 · 7:30 PM · SoFi Stadium · From $249 · Verified resale tickets available", favicon: "https://www.google.com/s2/favicons?domain=ticketmaster.com&sz=64", sitelinks: ["Buy Tickets", "Seating Chart"], isSponsored: false, rating: 0, reviews: 0, date: "Aug 17, 2024", thumbnail: ""},
                {id: 2, title: "Taylor Swift - Miami Night 1", url: "https://stubhub.com/taylor-swift-miami", displayUrl: "stubhub.com › taylor-swift-miami", desc: "Fri, Oct 25 · 7:00 PM · Hard Rock Stadium · Resale from $320", favicon: "https://www.google.com/s2/favicons?domain=stubhub.com&sz=64", sitelinks: [], isSponsored: true, rating: 0, reviews: 0, date: "Oct 25, 2024", thumbnail: ""}
            ]
        }
,
        // --- BATCH OF 51 NEW TEMPLATES ---

          {
            "id": 8,
            "name": "Premium Tech Launch",
            "category": "E-Commerce",
            "description": "PS5 Pro price and where to buy",
            "query": "buy PS5 Pro",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "The PlayStation 5 Pro sells for $699.99 as a 2TB digital-only console; the detachable Ultra HD Blu-ray drive is a separate $79.99 accessory. It uses a larger GPU, PlayStation Spectral Super Resolution upscaling and hardware ray tracing to run enhanced games at higher resolution while holding 60 fps. Stock is generally available from PlayStation Direct, Best Buy, Target and Walmart, and it is rarely discounted below list outside of bundle promotions."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 801,
                  "q": "Does the PS5 Pro come with a disc drive?",
                  "a": "No. It ships digital-only with a 2TB SSD. The detachable Ultra HD Blu-ray drive sells separately for $79.99 and clips onto the left side."
                },
                {
                  "id": 802,
                  "q": "Is the PS5 Pro worth it over the standard PS5?",
                  "a": "Mainly if you play on a 4K 120Hz display. Enhanced titles look noticeably cleaner and hold 60 fps more often, but load times and the game library are identical."
                },
                {
                  "id": 803,
                  "q": "Do PS5 games work on the Pro?",
                  "a": "Yes, the full PS5 and backward-compatible PS4 library runs on it. Around 100 titles have a specific PS5 Pro Enhanced patch."
                }
              ]
            },
            "products": [
              {
                "id": 8001,
                "title": "PlayStation 5 Pro Console 2TB",
                "price": "$699.99",
                "was": "",
                "merchant": "PlayStation Direct",
                "rating": 4.6,
                "reviews": "2.9k",
                "specs": "2TB SSD · Digital · PS5 Pro Enhanced",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 8002,
                "title": "PS5 Pro + Extra DualSense Bundle",
                "price": "$744.99",
                "was": "$774.98",
                "merchant": "Best Buy",
                "rating": 4.7,
                "reviews": "1.1k",
                "specs": "Console · 2 controllers · Charging dock",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 8003,
                "title": "PS5 Disc Drive for PS5 Pro",
                "price": "$79.99",
                "was": "",
                "merchant": "Target",
                "rating": 4.3,
                "reviews": "860",
                "specs": "Ultra HD Blu-ray · Attaches to console",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 8004,
                "title": "PlayStation 5 Pro Vertical Stand",
                "price": "$29.99",
                "was": "",
                "merchant": "Amazon",
                "rating": 4.4,
                "reviews": "3k+",
                "specs": "Official Sony · Pro models only",
                "place": "",
                "sale": false,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "PlayStation 5 Pro Console 2TB | PlayStation Direct",
                "url": "https://direct.playstation.com/en-us/consoles/console/playstation5-pro-console.3006650",
                "displayUrl": "direct.playstation.com › consoles › ps5-pro",
                "desc": "$699.99 · In stock · Free standard delivery. Includes a DualSense wireless controller, 2TB SSD and Astro's Playroom pre-installed. Disc drive sold separately.",
                "favicon": "https://www.google.com/s2/favicons?domain=playstation.com&sz=64",
                "sitelinks": [
                  "Buy Now",
                  "Accessories",
                  "Compare Consoles"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "$699.99",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Sony PlayStation 5 Pro Console (2TB) - Best Buy",
                "url": "https://www.bestbuy.com/site/sony-playstation-5-pro-console/6603501.p",
                "displayUrl": "bestbuy.com › Video Games › PlayStation 5",
                "desc": "4.6 ★ (2,914) · $699.99 · Pick up today at most stores. My Best Buy Plus members get free next-day shipping and an extra 60 days to return.",
                "favicon": "https://www.google.com/s2/favicons?domain=bestbuy.com&sz=64",
                "sitelinks": [
                  "Bundles",
                  "Store Availability"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "reviews": 2914,
                "price": "$699.99",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "PS5 Pro review: the $700 question",
                "url": "https://www.theverge.com/reviews/playstation-5-pro-review",
                "displayUrl": "theverge.com › reviews › gaming",
                "desc": "Sony's mid-generation refresh gives supported games a visibly cleaner 4K image and steadier frame rates, but $699.99 with no disc drive makes it a hard sell for anyone happy with a base PS5.",
                "favicon": "https://www.google.com/s2/favicons?domain=theverge.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Updated 3 days ago",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 9,
            "name": "Fashion Brand Sale",
            "category": "E-Commerce",
            "description": "Nike men's clearance with real prices",
            "query": "nike shoes sale mens",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Nike's clearance section discounts men's shoes by roughly 25-40%, with lifestyle and road-running models such as the Air Max 90 and Pegasus 41 marked down most often. The deepest cuts land during the end-of-season sale in late June and again over Black Friday week, when select styles reach 50% off. Dick's Sporting Goods, Foot Locker and Nordstrom Rack frequently list the same colorways for less, though popular sizes sell out within a few days."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 901,
                  "q": "How much does Nike take off in a sale?",
                  "a": "Most clearance shoes sit at 25-40% off list. Nike members regularly get an extra 20% on selected styles during promotional weekends."
                },
                {
                  "id": 902,
                  "q": "Can you return Nike sale shoes?",
                  "a": "Yes. Nike accepts returns within 60 days on almost everything, clearance included, as long as the shoes are unworn or faulty."
                },
                {
                  "id": 903,
                  "q": "When is Nike's biggest sale of the year?",
                  "a": "Black Friday week and the end-of-season sale in late June are the deepest, and both usually stack a member code on top of the marked price."
                }
              ]
            },
            "products": [
              {
                "id": 9001,
                "title": "Nike Air Max 90 Men's Shoes",
                "price": "$89.97",
                "was": "$130.00",
                "merchant": "Nike",
                "rating": 4.7,
                "reviews": "5k+",
                "specs": "Lifestyle · Leather and mesh · Sizes 7-15",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 9002,
                "title": "Nike Pegasus 41 Men's Road Running",
                "price": "$104.97",
                "was": "$140.00",
                "merchant": "Dick's Sporting Goods",
                "rating": 4.6,
                "reviews": "2.4k",
                "specs": "Neutral · ReactX foam · Daily trainer",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 9003,
                "title": "Nike Revolution 7 Men's Running Shoes",
                "price": "$52.97",
                "was": "$70.00",
                "merchant": "Foot Locker",
                "rating": 4.4,
                "reviews": "1.8k",
                "specs": "Everyday trainer · Wide sizes · 4E",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 9004,
                "title": "Nike Court Vision Low Next Nature",
                "price": "$54.97",
                "was": "$75.00",
                "merchant": "Nordstrom Rack",
                "rating": 4.5,
                "reviews": "930",
                "specs": "Court style · 20% recycled materials",
                "place": "",
                "sale": true,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Men's Sale Shoes. Nike.com",
                "url": "https://www.nike.com/w/mens-sale-shoes-3yaepznik1zy7ok",
                "displayUrl": "nike.com › Sale › Men's Shoes",
                "desc": "Up to 40% off men's shoes with free shipping for members. Air Max 90 from $89.97, Pegasus 41 from $104.97, Revolution 7 from $52.97. New markdowns added weekly.",
                "favicon": "https://www.google.com/s2/favicons?domain=nike.com&sz=64",
                "sitelinks": [
                  "Running",
                  "Lifestyle",
                  "Basketball",
                  "Under $100"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "From $52.97",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Nike Men's Shoe Clearance | DICK'S Sporting Goods",
                "url": "https://www.dickssportinggoods.com/f/nike-mens-shoes-clearance",
                "displayUrl": "dickssportinggoods.com › Nike › Clearance",
                "desc": "4.5 ★ (11k) · Nike running and training shoes from $52.97. Pegasus 41 now $104.97. Free shipping over $49 for ScoreCard members, free store pickup in an hour.",
                "favicon": "https://www.google.com/s2/favicons?domain=dickssportinggoods.com&sz=64",
                "sitelinks": [
                  "Running Shoes",
                  "Sizes 13+"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "reviews": 11240,
                "price": "From $52.97",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "The 22 best Nike deals to shop this week",
                "url": "https://www.gq.com/story/best-nike-sale-mens-sneaker-deals",
                "displayUrl": "gq.com › Style › Shopping",
                "desc": "We went through every markdown on Nike's clearance page and kept the ones worth buying: the Air Max 90 at $89.97 is the pick, and the Pegasus 41 rarely drops below $105.",
                "favicon": "https://www.google.com/s2/favicons?domain=gq.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "5 days ago",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 10,
            "name": "Cosmetics Product",
            "category": "E-Commerce",
            "description": "Retinol vs vitamin C serum picks",
            "query": "best anti aging serum",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Dermatologists usually recommend two things rather than one product: a vitamin C serum in the morning for antioxidant protection, and a retinoid at night to speed cell turnover and support collagen. Frequently cited picks include SkinCeuticals C E Ferulic at $182.00 and Paula's Choice 1% Retinol Treatment at $64.00, though cheaper formulas such as The Ordinary's Granactive Retinoid 2% at $12.90 use the same active class at lower strength. Studies generally show measurable change in fine lines after 8-12 weeks of consistent use, and any retinoid should be paired with daily SPF."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1001,
                  "q": "Should I use retinol or vitamin C first?",
                  "a": "Use them at different times: vitamin C in the morning under sunscreen, retinol at night. Layering both at once tends to irritate skin and destabilize the vitamin C."
                },
                {
                  "id": 1002,
                  "q": "How long until an anti-aging serum works?",
                  "a": "Texture and hydration usually improve within 2-4 weeks. Fine lines take 8-12 weeks of nightly use, and results fade if you stop."
                },
                {
                  "id": 1003,
                  "q": "Is a $180 serum better than a $13 one?",
                  "a": "Not automatically. Concentration, formulation and packaging matter more than price, and opaque air-tight bottles keep actives stable far longer than clear droppers."
                }
              ]
            },
            "products": [
              {
                "id": 10001,
                "title": "SkinCeuticals C E Ferulic Serum 30ml",
                "price": "$182.00",
                "was": "",
                "merchant": "Dermstore",
                "rating": 4.7,
                "reviews": "6k+",
                "specs": "15% vitamin C · Morning use · Vial",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 10002,
                "title": "Paula's Choice 1% Retinol Treatment",
                "price": "$64.00",
                "was": "$80.00",
                "merchant": "Paula's Choice",
                "rating": 4.5,
                "reviews": "3.2k",
                "specs": "1% retinol · Peptides · Fragrance-free",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 10003,
                "title": "The Ordinary Granactive Retinoid 2%",
                "price": "$12.90",
                "was": "",
                "merchant": "Ulta Beauty",
                "rating": 4.3,
                "reviews": "11k",
                "specs": "Emulsion · Low irritation · 30ml",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 10004,
                "title": "Olay Regenerist Micro-Sculpting Serum",
                "price": "$28.99",
                "was": "$38.99",
                "merchant": "Target",
                "rating": 4.4,
                "reviews": "9k+",
                "specs": "Niacinamide · Peptides · 1.7 fl oz",
                "place": "",
                "sale": true,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "The Best Anti-Aging Serums | Reviews by Wirecutter",
                "url": "https://www.nytimes.com/wirecutter/reviews/best-anti-aging-serum/",
                "displayUrl": "nytimes.com › wirecutter › reviews › skin-care",
                "desc": "We tested 34 serums over six months with three board-certified dermatologists. A 1% retinol treatment at $64.00 gave the best balance of results and irritation for most skin.",
                "favicon": "https://www.google.com/s2/favicons?domain=nytimes.com&sz=64",
                "sitelinks": [
                  "Our Pick",
                  "How We Tested",
                  "The Competition"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Updated 2 weeks ago",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "1% Retinol Treatment | Paula's Choice",
                "url": "https://www.paulaschoice.com/clinical-1pct-retinol-treatment/7710.html",
                "displayUrl": "paulaschoice.com › Clinical › Retinol",
                "desc": "$64.00, was $80.00 · Fragrance-free 1% retinol with peptides and licorice root, in an air-tight opaque bottle. 60-day money-back guarantee and free US shipping over $49.",
                "favicon": "https://www.google.com/s2/favicons?domain=paulaschoice.com&sz=64",
                "sitelinks": [
                  "Ingredients",
                  "Reviews",
                  "Routine Finder"
                ],
                "isSponsored": true,
                "rating": 4.5,
                "reviews": 3218,
                "price": "$64.00",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Face Serums & Treatments | Sephora",
                "url": "https://www.sephora.com/shop/face-serum",
                "displayUrl": "sephora.com › Skincare › Treatments › Serums",
                "desc": "4.4 ★ (18k) · SkinCeuticals C E Ferulic $182.00, Drunk Elephant A-Passioni $74.00. Filter by concern, get two free samples with every order and free returns for 30 days.",
                "favicon": "https://www.google.com/s2/favicons?domain=sephora.com&sz=64",
                "sitelinks": [
                  "Vitamin C",
                  "Retinol",
                  "Under $50"
                ],
                "isSponsored": false,
                "rating": 4.4,
                "reviews": 18420,
                "price": "$182.00",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 11,
            "name": "Subscription Box",
            "category": "E-Commerce",
            "description": "Meal kit comparison, cost per serving",
            "query": "hellofresh vs blue apron",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "HelloFresh is the cheaper of the two at about $9.99 per serving and rotates roughly 45 recipes a week, most designed for 30 minutes or less. Blue Apron offers a shorter weekly menu but a more ambitious one, with Wellness and premium seafood options and wine pairings, and prices from around $11.99 per serving. Both charge delivery on top of the box, discount the first several boxes heavily, and let you skip or cancel from the account page before the weekly cut-off."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1101,
                  "q": "Which is cheaper, HelloFresh or Blue Apron?",
                  "a": "HelloFresh, usually. A three-meal box for four works out at $9.99 a serving against $11.99 at Blue Apron, before introductory discounts."
                },
                {
                  "id": 1102,
                  "q": "Can I cancel after the first box?",
                  "a": "Yes. Both services let you skip a week or cancel entirely from account settings, as long as you do it before the cut-off, normally five days ahead of delivery."
                },
                {
                  "id": 1103,
                  "q": "Do the boxes stay cold on the doorstep?",
                  "a": "They ship with insulated liners and gel packs and hold temperature for several hours, but meat and fish should go in the fridge as soon as you get in."
                }
              ]
            },
            "products": [
              {
                "id": 11001,
                "title": "HelloFresh 3 meals for 4 people",
                "price": "$119.88",
                "was": "$179.88",
                "merchant": "HelloFresh",
                "rating": 4.4,
                "reviews": "22k",
                "specs": "$9.99/serving · 45+ recipes weekly",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 11002,
                "title": "Blue Apron Signature 3 meals for 2",
                "price": "$71.94",
                "was": "",
                "merchant": "Blue Apron",
                "rating": 4.2,
                "reviews": "8.6k",
                "specs": "$11.99/serving · Wine add-on available",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 11003,
                "title": "Home Chef Family Plan 4 meals for 2",
                "price": "$79.92",
                "was": "$99.92",
                "merchant": "Kroger",
                "rating": 4.3,
                "reviews": "5k+",
                "specs": "$9.99/serving · Oven-ready options",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 11004,
                "title": "EveryPlate 3 meals for 2",
                "price": "$29.94",
                "was": "",
                "merchant": "EveryPlate",
                "rating": 4.1,
                "reviews": "3.4k",
                "specs": "$4.99/serving · Budget kit",
                "place": "",
                "sale": false,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "HelloFresh vs. Blue Apron: I cooked 18 meals from both",
                "url": "https://www.cnet.com/home/kitchen-and-household/hellofresh-vs-blue-apron/",
                "displayUrl": "cnet.com › Home › Kitchen & Household",
                "desc": "Nine dinners from each service over three weeks. HelloFresh won on price and prep time at $9.99 a serving; Blue Apron's $11.99 recipes tasted better but took closer to 45 minutes.",
                "favicon": "https://www.google.com/s2/favicons?domain=cnet.com&sz=64",
                "sitelinks": [
                  "Price per serving",
                  "Taste test",
                  "Verdict"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Updated 3 days ago",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "HelloFresh Official Site | Meal Kit Delivery",
                "url": "https://www.hellofresh.com/plans",
                "displayUrl": "hellofresh.com › plans",
                "desc": "From $9.99 per serving. Choose from 45+ recipes a week, skip any week free. New customers get 10 free meals across the first nine boxes plus free shipping on box one.",
                "favicon": "https://www.google.com/s2/favicons?domain=hellofresh.com&sz=64",
                "sitelinks": [
                  "This Week's Menu",
                  "Pricing",
                  "How It Works"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "From $9.99",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Meal Kit Delivery Service | Blue Apron",
                "url": "https://www.blueapron.com/pages/meal-delivery",
                "displayUrl": "blueapron.com › pages › meal-delivery",
                "desc": "4.2 ★ (8.6k) · From $11.99 per serving. Chef-designed recipes with Wellness, vegetarian and premium seafood options, plus wine pairings shipped with your box.",
                "favicon": "https://www.google.com/s2/favicons?domain=blueapron.com&sz=64",
                "sitelinks": [
                  "Menu",
                  "Plans & Pricing"
                ],
                "isSponsored": false,
                "rating": 4.2,
                "reviews": 8630,
                "price": "From $11.99",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 4,
                "title": "HelloFresh vs Blue Apron - which did you keep?",
                "url": "https://www.reddit.com/r/mealkits/comments/1f2k9qz/hellofresh_vs_blue_apron/",
                "displayUrl": "reddit.com › r/mealkits",
                "desc": "214 votes · 87 comments · Top comment: \"Blue Apron for flavor, HelloFresh when I'm tired. Both get expensive the moment the intro discount runs out.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=reddit.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "1 month ago",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 12,
            "name": "Luxury Watch",
            "category": "E-Commerce",
            "description": "Submariner list price vs resale market",
            "query": "rolex submariner price",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Rolex lists the Submariner Date (ref. 126610LN) at $10,250 and the no-date 124060 at $9,100, but authorized dealers hold little stock and most buyers go on a waiting list. On the secondary market the same references trade at roughly $12,400 to $15,500 depending on condition, year, and whether the box and papers are included. Secondary prices peaked in early 2022 and have drifted down since, so a dealer quote from two years ago is no longer a useful guide."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1201,
                  "q": "Why can't I just buy one at retail?",
                  "a": "Rolex makes far fewer steel sports models than there is demand for, so dealers allocate them to established customers. Waits of two years or more are common."
                },
                {
                  "id": 1202,
                  "q": "What is the difference between the 126610LN and 124060?",
                  "a": "The 126610LN has a date window and Cyclops lens and lists about $1,150 higher; the 124060 is the no-date version with a cleaner dial. Both share the 41mm case."
                },
                {
                  "id": 1203,
                  "q": "Do Submariners hold their value?",
                  "a": "Historically they have traded above list, though secondary prices fell around 30% from the 2022 peak. They hold value better than most luxury watches, but that is not the same as an investment."
                }
              ]
            },
            "products": [
              {
                "id": 12001,
                "title": "Rolex Submariner Date 126610LN 41mm",
                "price": "$14,200",
                "was": "$14,800",
                "merchant": "Bob's Watches",
                "rating": 4.9,
                "reviews": "6.2k",
                "specs": "2023 · Box & papers · Unworn",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 12002,
                "title": "Rolex Submariner No-Date 124060",
                "price": "$12,450",
                "was": "",
                "merchant": "Chrono24",
                "rating": 4.8,
                "reviews": "138k",
                "specs": "2022 · Full set · Verified dealer",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 12003,
                "title": "Rolex Submariner 126610LV \"Starbucks\"",
                "price": "$16,750",
                "was": "",
                "merchant": "Crown & Caliber",
                "rating": 4.7,
                "reviews": "2.1k",
                "specs": "Green bezel · Black dial · 41mm",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 12004,
                "title": "Rolex Submariner \"Hulk\" 116610LV",
                "price": "$19,900",
                "was": "$21,400",
                "merchant": "WatchBox",
                "rating": 4.6,
                "reviews": "980",
                "specs": "Discontinued · 40mm · Green dial",
                "place": "",
                "sale": true,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Submariner - Rolex Watches",
                "url": "https://www.rolex.com/watches/submariner",
                "displayUrl": "rolex.com › Watches › Submariner",
                "desc": "The reference among divers' watches. Oystersteel case, unidirectional Cerachrom bezel and 300 metre water resistance. Contact an Official Rolex Retailer for availability and price.",
                "favicon": "https://www.google.com/s2/favicons?domain=rolex.com&sz=64",
                "sitelinks": [
                  "Find a Retailer",
                  "All Models",
                  "Compare"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Rolex Submariner Price Guide & Market Data",
                "url": "https://www.bobswatches.com/rolex-submariner-prices",
                "displayUrl": "bobswatches.com › rolex › submariner",
                "desc": "The 126610LN currently trades at $14,200 against a $10,250 list price, down 4% over 90 days. Live market chart, past sale records and an instant buy-back quote.",
                "favicon": "https://www.google.com/s2/favicons?domain=bobswatches.com&sz=64",
                "sitelinks": [
                  "Price Chart",
                  "Sell Yours",
                  "Buying Guide"
                ],
                "isSponsored": false,
                "rating": 4.9,
                "reviews": 6210,
                "price": "$14,200",
                "date": "Updated daily",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Rolex Submariner Date 126610LN for sale | Chrono24",
                "url": "https://www.chrono24.com/rolex/submariner--mod2.htm",
                "displayUrl": "chrono24.com › Rolex › Submariner",
                "desc": "4.8 ★ (138k) · 1,840 listings from $13,650. Buyer protection, authenticity check by a watchmaker and 14-day returns on every purchase from a verified dealer.",
                "favicon": "https://www.google.com/s2/favicons?domain=chrono24.com&sz=64",
                "sitelinks": [
                  "New Listings",
                  "Under $15,000"
                ],
                "isSponsored": true,
                "rating": 4.8,
                "reviews": 138420,
                "price": "From $13,650",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 13,
            "name": "Fitness Equipment",
            "category": "E-Commerce",
            "description": "Bike+ sale price and membership cost",
            "query": "peloton bike+ sale",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Peloton lists the Bike+ at $2,495.00 and discounts it to about $1,995.00 during its seasonal sales, which usually land around the New Year, Memorial Day, Labor Day and Black Friday. Certified refurbished units start near $1,795.00 and carry the same 12-month warranty and delivery. The All-Access Membership is a separate $44 a month and is required for the class library; without it the bike drops to a basic Just Ride mode that only shows your own metrics."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1301,
                  "q": "Is the Bike+ worth the extra over the standard Bike?",
                  "a": "The Bike+ adds a rotating 24-inch screen, Apple GymKit and auto-follow resistance during classes. If you only ever cycle, the $1,445.00 standard Bike runs the same workouts."
                },
                {
                  "id": 1302,
                  "q": "Do you need the membership?",
                  "a": "For classes, yes: $44 a month covers the whole household. Without it you keep Just Ride mode, and the $12.99 App One plan works on a non-Peloton bike."
                },
                {
                  "id": 1303,
                  "q": "How often does Peloton discount the Bike+?",
                  "a": "Roughly four times a year, typically $300-$500 off and often bundled with shoes, weights and a mat rather than a deeper price cut."
                }
              ]
            },
            "products": [
              {
                "id": 13001,
                "title": "Peloton Bike+ Indoor Exercise Bike",
                "price": "$1,995.00",
                "was": "$2,495.00",
                "merchant": "Peloton",
                "rating": 4.7,
                "reviews": "12k",
                "specs": "24\" rotating screen · Auto resistance",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 13002,
                "title": "Peloton Bike+ Certified Refurbished",
                "price": "$1,795.00",
                "was": "$2,495.00",
                "merchant": "Peloton",
                "rating": 4.5,
                "reviews": "1.4k",
                "specs": "12-month warranty · Free delivery",
                "place": "",
                "sale": true,
                "image": ""
              },
              {
                "id": 13003,
                "title": "Peloton Bike+ Ultimate Bundle",
                "price": "$2,195.00",
                "was": "",
                "merchant": "Amazon",
                "rating": 4.6,
                "reviews": "3.4k",
                "specs": "Bike · Shoes · Dumbbells · Mat",
                "place": "",
                "sale": false,
                "image": ""
              },
              {
                "id": 13004,
                "title": "Peloton Bike (original 22\" screen)",
                "price": "$1,145.00",
                "was": "$1,445.00",
                "merchant": "Dick's Sporting Goods",
                "rating": 4.4,
                "reviews": "2.6k",
                "specs": "Fixed screen · Entry model",
                "place": "",
                "sale": true,
                "image": ""
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Peloton Bike+ | Save $500 Through Sunday",
                "url": "https://www.onepeloton.com/shop/bike-plus",
                "displayUrl": "onepeloton.com › Shop › Bike+",
                "desc": "$1,995.00, was $2,495.00 · Rotating 24-inch HD touchscreen, auto-follow resistance and Apple GymKit. Free delivery and setup, 30-day home trial. Membership $44/mo, sold separately.",
                "favicon": "https://www.google.com/s2/favicons?domain=onepeloton.com&sz=64",
                "sitelinks": [
                  "Compare Bikes",
                  "Financing",
                  "Refurbished",
                  "Classes"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "$1,995.00",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Peloton Bike+ Ultimate Bundle - Amazon.com",
                "url": "https://www.amazon.com/Peloton-Bike-Plus-Ultimate-Bundle/dp/B08N5LKPQ3",
                "displayUrl": "amazon.com › Sports & Outdoors › Exercise Bikes",
                "desc": "4.6 ★ (3,412) · $2,195.00 · Bike+ with cycling shoes, dumbbells and a mat. Free delivery and expert assembly. All-Access Membership $44/month sold separately.",
                "favicon": "https://www.google.com/s2/favicons?domain=amazon.com&sz=64",
                "sitelinks": [
                  "Customer Reviews",
                  "Q&A"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "reviews": 3412,
                "price": "$2,195.00",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Peloton Bike+ review: brilliant bike, brutal math",
                "url": "https://www.cnet.com/health/fitness/peloton-bike-plus-review/",
                "displayUrl": "cnet.com › Wellness › Fitness",
                "desc": "Two months of daily rides in, the Bike+ still has the best instructors on the market and the worst value case: $1,995.00 up front and $528 a year to keep the classes.",
                "favicon": "https://www.google.com/s2/favicons?domain=cnet.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Updated 6 days ago",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 14,
            "name": "Local Plumber",
            "category": "Local Business",
            "description": "Emergency plumber, local pack + rates",
            "query": "emergency plumber chicago",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Emergency plumbers in Chicago typically charge $150-$450 for a call-out and diagnosis, with nights, weekends and holidays running roughly double the standard rate. Illinois requires plumbers to hold a state licence issued by the Department of Public Health, and most reputable shops will give you the licence number over the phone. For a burst pipe or an active leak, shut off the main valve before the truck arrives — several Chicago companies advertise a 60 to 90 minute response window inside the city limits."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1401,
                  "q": "How much does an emergency plumber cost in Chicago?",
                  "a": "Expect $150-$450 for the call-out and first hour, plus parts. After 6 PM and on Sundays most shops charge time-and-a-half or double."
                },
                {
                  "id": 1402,
                  "q": "Is a burst pipe covered by homeowners insurance?",
                  "a": "Sudden pipe bursts and the resulting water damage are usually covered, but the slow leak that caused it often is not. The pipe repair itself is typically excluded."
                },
                {
                  "id": 1403,
                  "q": "What counts as a plumbing emergency?",
                  "a": "No water in the house, sewage backing up into a drain, a burst or frozen pipe, or a gas smell near a water heater. A slow drip can normally wait for a scheduled visit."
                }
              ]
            },
            "places": [
              {
                "id": 1411,
                "name": "J. Blanton Plumbing",
                "rating": 4.8,
                "reviews": "3.1k",
                "price": "$$",
                "category": "Plumber",
                "open": "Open 24 hours",
                "address": "5126 N Ravenswood Ave",
                "tags": "24/7 · Onsite services · Free estimates",
                "note": "Licensed, bonded and insured; sewer camera inspection included on drain calls.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 1412,
                "name": "Rescue Plumbing",
                "rating": 4.7,
                "reviews": "1.4k",
                "price": "$$",
                "category": "Plumber",
                "open": "Open 24 hours",
                "address": "1808 W Belmont Ave",
                "tags": "24/7 · Emergency · Same-day",
                "note": "Flat-rate quote before work starts; no overtime charge on weekends.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1413,
                "name": "Roto-Rooter Plumbing & Water Cleanup",
                "rating": 4.4,
                "reviews": "5.8k",
                "price": "$$$",
                "category": "Plumber",
                "open": "Open 24 hours",
                "address": "2500 W Bradley Pl",
                "tags": "24/7 · Drain cleaning · Water damage",
                "note": "Nationwide chain with its own water-extraction crews for flooded basements.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "24/7 Emergency Plumbing in Chicago | J. Blanton",
                "url": "https://www.jblantonplumbing.com/emergency-plumbing/",
                "displayUrl": "jblantonplumbing.com › emergency-plumbing",
                "desc": "Burst pipes, sewer backups and water heater failures answered around the clock across Chicago and the North Shore. Licensed Illinois plumbers, upfront flat-rate pricing, typical arrival within 90 minutes.",
                "favicon": "https://www.google.com/s2/favicons?domain=jblantonplumbing.com&sz=64",
                "sitelinks": [
                  "Sewer Repair",
                  "Water Heaters",
                  "Service Area",
                  "Financing"
                ],
                "isSponsored": true,
                "rating": 4.8,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 3104
              },
              {
                "id": 2,
                "title": "The 10 Best Emergency Plumbers in Chicago, IL",
                "url": "https://www.yelp.com/search?find_desc=emergency+plumber&find_loc=Chicago%2C+IL",
                "displayUrl": "yelp.com › Home Services › Plumbing",
                "desc": "Top emergency plumbers in Chicago, IL - Rescue Plumbing, J. Blanton Plumbing, Chicago Sewer Experts. \"Came out at 11pm on a Saturday for a backed-up main and had it cleared in an hour.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open Now",
                  "Highest Rated",
                  "Free Estimates"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "How Much Does an Emergency Plumber Cost? (2026)",
                "url": "https://www.angi.com/articles/how-much-does-emergency-plumber-cost.htm",
                "displayUrl": "angi.com › articles › plumbing",
                "desc": "Emergency plumbing calls average $170 to $450 nationally, with after-hours and holiday rates running 1.5x to 2x. We break down what drives the bill and when the charge is worth paying.",
                "favicon": "https://www.google.com/s2/favicons?domain=angi.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jan 14, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 15,
            "name": "Auto Repair Shop",
            "category": "Local Business",
            "description": "Oil change shops, prices and wait times",
            "query": "best oil change chicago",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "A conventional oil change in Chicago runs about $45-$70, while full synthetic is closer to $85-$125 depending on how much oil the engine takes. Quick-lube chains such as Valvoline and Jiffy Lube do not require an appointment and generally finish in 15 to 20 minutes; independent shops are usually cheaper but book a day or two out. Most manufacturers now specify 7,500 to 10,000 miles between changes on synthetic oil, so the 3,000-mile sticker on your windshield is often conservative."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1501,
                  "q": "How much is a synthetic oil change in Chicago?",
                  "a": "Roughly $85-$125 at a quick-lube chain, or $70-$95 at most independent shops. Vehicles taking 7+ quarts, like a Tahoe or an F-150, sit at the top of that range."
                },
                {
                  "id": 1502,
                  "q": "Do I really need an oil change every 3,000 miles?",
                  "a": "Not on a modern engine running synthetic. Check the owner's manual — most now specify 7,500 to 10,000 miles, or follow the car's oil-life monitor."
                },
                {
                  "id": 1503,
                  "q": "Is a dealership oil change worth the extra cost?",
                  "a": "It gets you the manufacturer's spec oil and a logged service history, which helps at resale. For an out-of-warranty car, a good independent shop does the same job for less."
                }
              ]
            },
            "places": [
              {
                "id": 1511,
                "name": "Valvoline Instant Oil Change - Lincoln Ave",
                "rating": 4.6,
                "reviews": "1.9k",
                "price": "$$",
                "category": "Oil change service",
                "open": "Closes 7 PM",
                "address": "3550 N Lincoln Ave",
                "tags": "Stay-in-your-car · No appointment · 15 min",
                "note": "Drive-through bays; techs show you the dipstick before and after.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1512,
                "name": "Jiffy Lube Multicare",
                "rating": 4.3,
                "reviews": "980",
                "price": "$$",
                "category": "Oil change service",
                "open": "Closes 6 PM",
                "address": "1601 N Elston Ave",
                "tags": "Walk-in · Tires · Brakes",
                "note": "Coupons on the app usually knock $15-$20 off a synthetic change.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1513,
                "name": "Ashland Tire & Auto",
                "rating": 4.9,
                "reviews": "412",
                "price": "$",
                "category": "Auto repair shop",
                "open": "Closed · Opens 7 AM Mon",
                "address": "2410 S Ashland Ave",
                "tags": "Appointment required · Family owned",
                "note": "Independent shop; cheaper on synthetic but usually books two days out.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Oil Change Near Me in Chicago, IL | Valvoline",
                "url": "https://store.vioc.com/il/chicago",
                "displayUrl": "store.vioc.com › il › chicago",
                "desc": "Find a Valvoline Instant Oil Change in Chicago. Stay in your car, 15-minute service, no appointment needed. Conventional, high mileage and full synthetic with a free 18-point check.",
                "favicon": "https://www.google.com/s2/favicons?domain=vioc.com&sz=64",
                "sitelinks": [
                  "Coupons",
                  "Store Hours",
                  "Services",
                  "Book Ahead"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "From $59.99",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Best Oil Change in Chicago, IL - Updated 2026",
                "url": "https://www.yelp.com/search?find_desc=Oil+Change&find_loc=Chicago%2C+IL",
                "displayUrl": "yelp.com › Automotive › Oil Change Stations",
                "desc": "Reviews on Oil Change in Chicago, IL - Ashland Tire & Auto, Valvoline Instant Oil Change, Midtown Auto. \"Charged me $68 for full synthetic when the dealer quoted $130. No upsell at all.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open Now",
                  "Price: $",
                  "By Neighborhood"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Oil Change Cost Guide: What You Should Pay",
                "url": "https://www.consumerreports.org/cars/car-maintenance/oil-change-cost-guide-a1093847/",
                "displayUrl": "consumerreports.org › cars › car-maintenance",
                "desc": "We priced conventional, blend and full synthetic changes at dealers, chains and independents in ten metros. Synthetic averaged $96 at chains and $79 at independent shops.",
                "favicon": "https://www.google.com/s2/favicons?domain=consumerreports.org&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Feb 3, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 16,
            "name": "Dentist",
            "category": "Local Business",
            "description": "Cosmetic dentists, whitening pricing",
            "query": "best teeth whitening nyc",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "In-office whitening in Manhattan generally costs $500-$1,200 per session, with Zoom and KoR being the systems most practices advertise. Dentist-supplied custom take-home trays run $250-$500 and tend to produce a more gradual result that lasts longer. Results usually hold for one to three years depending on coffee, tea and red wine intake, and whitening does not change the colour of crowns, veneers or composite fillings — those may need replacing to match."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1601,
                  "q": "How much does professional teeth whitening cost in NYC?",
                  "a": "In-office sessions are typically $500-$1,200; custom take-home trays from a dentist are $250-$500. Most practices bundle a cleaning into the first visit."
                },
                {
                  "id": 1602,
                  "q": "Is in-office whitening better than strips?",
                  "a": "It works faster and goes several shades lighter in one visit, because the gel is far stronger and the gums are shielded. Strips are cheaper but plateau after a few shades."
                },
                {
                  "id": 1603,
                  "q": "Does whitening damage enamel?",
                  "a": "Peroxide whitening does not remove enamel, but it can cause temporary sensitivity for a day or two. Dentists usually recommend a potassium nitrate gel afterwards."
                }
              ]
            },
            "places": [
              {
                "id": 1611,
                "name": "NYC Smile Design",
                "rating": 4.9,
                "reviews": "740",
                "price": "$$$$",
                "category": "Cosmetic dentist",
                "open": "Closes 6 PM",
                "address": "12 E 46th St, Suite 402",
                "tags": "Appointment required · Zoom whitening · Veneers",
                "note": "Midtown practice; whitening usually bundled with a hygiene visit.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1612,
                "name": "Gallery 57 Dental",
                "rating": 4.7,
                "reviews": "2.1k",
                "price": "$$$",
                "category": "Dentist",
                "open": "Open · Closes 7 PM",
                "address": "24 W 57th St, Suite 701",
                "tags": "Evenings · Insurance accepted · Emergency",
                "note": "Takes most PPO plans and runs late appointments through the week.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1613,
                "name": "Brooklyn Heights Dental Studio",
                "rating": 4.8,
                "reviews": "530",
                "price": "$$$",
                "category": "Cosmetic dentist",
                "open": "Closed · Opens 9 AM Tue",
                "address": "142 Montague St",
                "tags": "KoR whitening · Take-home trays",
                "note": "Take-home tray kits from $320 including impressions.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Professional Teeth Whitening in Manhattan | NYC Smile Design",
                "url": "https://www.nycsmiledesign.com/services/teeth-whitening/",
                "displayUrl": "nycsmiledesign.com › services › teeth-whitening",
                "desc": "In-office Zoom whitening in a single 90-minute visit, or custom take-home trays fitted from digital impressions. Shade assessment and gum shielding included; financing available.",
                "favicon": "https://www.google.com/s2/favicons?domain=nycsmiledesign.com&sz=64",
                "sitelinks": [
                  "Before & After",
                  "Pricing",
                  "Book a Consult",
                  "Veneers"
                ],
                "isSponsored": true,
                "rating": 4.9,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 742
              },
              {
                "id": 2,
                "title": "Teeth Whitening in New York, NY - Best Dentists",
                "url": "https://www.yelp.com/search?find_desc=teeth+whitening&find_loc=New+York%2C+NY",
                "displayUrl": "yelp.com › Health & Medical › Dentists",
                "desc": "Reviews on teeth whitening in New York, NY - Gallery 57 Dental, NYC Smile Design, Brooklyn Heights Dental Studio. \"Four shades lighter in one visit and barely any sensitivity afterwards.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open Now",
                  "Accepts Insurance",
                  "Price: $$"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Whitening Treatments - American Dental Association",
                "url": "https://www.ada.org/resources/ada-library/oral-health-topics/whitening",
                "displayUrl": "ada.org › oral-health-topics › whitening",
                "desc": "How peroxide-based bleaching works, the difference between in-office and dispensed take-home products, and why crowns, veneers and composite restorations will not change shade.",
                "favicon": "https://www.google.com/s2/favicons?domain=ada.org&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Nov 2, 2025",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 17,
            "name": "Veterinarian",
            "category": "Local Business",
            "description": "24/7 emergency vet, exam fees",
            "query": "24/7 animal hospital austin",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Austin has several veterinary hospitals staffed overnight, including emergency and specialty centres in North Austin, South Austin and Round Rock. The emergency exam fee is usually $135-$210 before any diagnostics, and cases are triaged by severity rather than arrival time, so a stable pet may wait two hours or more. Calling ahead lets the team prepare for you and, in a poisoning case, gives them time to consult the ASPCA Animal Poison Control line before you arrive."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1701,
                  "q": "How much does an emergency vet visit cost in Austin?",
                  "a": "The after-hours exam alone is around $135-$210. With bloodwork, x-rays and overnight fluids, most visits land between $600 and $2,500."
                },
                {
                  "id": 1702,
                  "q": "When should I take my dog to an emergency vet?",
                  "a": "Trouble breathing, repeated vomiting, a bloated hard abdomen, seizures, suspected poisoning, or any trauma. A bloated, retching large-breed dog is a same-hour emergency."
                },
                {
                  "id": 1703,
                  "q": "Do emergency vets require payment upfront?",
                  "a": "Most ask for a deposit covering the estimate before admitting a pet. CareCredit and Scratchpay are widely accepted at Austin emergency hospitals."
                }
              ]
            },
            "places": [
              {
                "id": 1711,
                "name": "Austin Veterinary Emergency & Specialty",
                "rating": 4.5,
                "reviews": "1.6k",
                "price": "$$$",
                "category": "Emergency veterinarian service",
                "open": "Open 24 hours",
                "address": "7101 W Highway 71",
                "tags": "24/7 · Walk-ins · Specialty referral",
                "note": "Board-certified criticalists on site; surgery and internal medicine referrals.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1712,
                "name": "BluePearl Pet Hospital - Austin Central",
                "rating": 4.2,
                "reviews": "2.3k",
                "price": "$$$",
                "category": "Animal hospital",
                "open": "Open 24 hours",
                "address": "8106 Brodie Ln",
                "tags": "24/7 · Emergency · CareCredit",
                "note": "Triage by severity; call ahead so the team can prep for arrival.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 1713,
                "name": "Heart of Texas Veterinary Specialty Center",
                "rating": 4.6,
                "reviews": "890",
                "price": "$$$",
                "category": "Emergency veterinarian service",
                "open": "Open 24 hours",
                "address": "1301 Wells Branch Pkwy, Round Rock",
                "tags": "24/7 · Onsite imaging · Overnight care",
                "note": "CT and ultrasound in house, so nothing needs sending out overnight.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "24/7 Emergency Vet in Austin | AVES",
                "url": "https://www.austinvethospital.com/emergency/",
                "displayUrl": "austinvethospital.com › emergency",
                "desc": "Open every hour of the year, including holidays. Walk-in emergency care with board-certified criticalists, in-house lab, CT and ultrasound. Call ahead and we will be ready when you arrive.",
                "favicon": "https://www.google.com/s2/favicons?domain=austinvethospital.com&sz=64",
                "sitelinks": [
                  "What to Expect",
                  "Directions",
                  "Payment Options",
                  "Specialties"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 1618
              },
              {
                "id": 2,
                "title": "Emergency Vets Open Now in Austin, TX",
                "url": "https://www.yelp.com/search?find_desc=24+hour+emergency+vet&find_loc=Austin%2C+TX",
                "displayUrl": "yelp.com › Pets › Emergency Pet Hospital",
                "desc": "Best 24 hour emergency vet in Austin, TX - BluePearl Brodie Lane, Austin Vet Emergency & Specialty, Heart of Texas. \"Got us in at 3am for bloat surgery. He walked out two days later.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open Now",
                  "Accepts Pet Insurance"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Animal Poison Control Center Hotline (888) 426-4435",
                "url": "https://www.aspca.org/pet-care/animal-poison-control",
                "displayUrl": "aspca.org › pet-care › animal-poison-control",
                "desc": "Staffed 24 hours a day, every day. A $95 consultation fee may apply. Have the product packaging and your pet's weight to hand before you call, and do not induce vomiting unless told to.",
                "favicon": "https://www.google.com/s2/favicons?domain=aspca.org&sz=64",
                "sitelinks": [
                  "Toxic Plants",
                  "People Foods to Avoid"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 18,
            "name": "Landscaping Service",
            "category": "Local Business",
            "description": "Lawn care quotes and yard sizes",
            "query": "lawn care service miami",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Weekly mowing in Miami-Dade runs about $35-$70 for a typical quarter-acre lot, and most crews cut year round because St. Augustine and Zoysia keep growing through the winter. Full-service plans that add edging, blowing, hedge trimming and fertiliser are usually $120-$250 a month. Chinch bugs and brown patch are the two problems homeowners here call about most, and treatment for either is normally quoted separately from the mowing contract."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1801,
                  "q": "How much is lawn care per month in Miami?",
                  "a": "Weekly mowing on an average lot works out to roughly $140-$260 a month. Adding fertilisation and pest treatment usually pushes it past $300."
                },
                {
                  "id": 1802,
                  "q": "How often should St. Augustine grass be cut in Florida?",
                  "a": "Weekly from March through November, dropping to every other week in the cooler months. Keep the blade at 3.5 to 4 inches to shade out weeds."
                },
                {
                  "id": 1803,
                  "q": "What is eating my grass in Miami?",
                  "a": "Chinch bugs are the usual culprit in St. Augustine — look for yellowing patches in the sunniest, driest part of the yard that spread outward."
                }
              ]
            },
            "places": [
              {
                "id": 1811,
                "name": "Bloom Landscaping & Lawn Care",
                "rating": 4.8,
                "reviews": "610",
                "price": "$$",
                "category": "Lawn care service",
                "open": "Closes 5 PM",
                "address": "9550 SW 40th St",
                "tags": "Onsite estimates · Weekly service · Licensed",
                "note": "Free walk-round quote; weekly cut, edge and blow from $45.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1812,
                "name": "TruGreen Lawn Care - Miami",
                "rating": 4.1,
                "reviews": "3.4k",
                "price": "$$",
                "category": "Lawn care service",
                "open": "Closes 6 PM",
                "address": "7950 NW 53rd St",
                "tags": "Fertilisation · Pest control · Annual plans",
                "note": "Treatment plans only — they fertilise and spray but do not mow.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 1813,
                "name": "Coral Gables Yard Crew",
                "rating": 4.9,
                "reviews": "185",
                "price": "$",
                "category": "Landscaper",
                "open": "Closed · Opens 7 AM Mon",
                "address": "245 Miracle Mile",
                "tags": "Family owned · Hedge trimming · Cash or Zelle",
                "note": "Small local crew; hedges and palms as well as the weekly cut.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Lawn Mowing Service in Miami, FL | LawnStarter",
                "url": "https://www.lawnstarter.com/miami-fl-lawn-care",
                "displayUrl": "lawnstarter.com › miami-fl-lawn-care",
                "desc": "Get a price in two minutes and book a vetted local crew. Weekly, biweekly or one-off cuts across Miami-Dade, including edging, trimming and blowing. Reschedule free in the app.",
                "favicon": "https://www.google.com/s2/favicons?domain=lawnstarter.com&sz=64",
                "sitelinks": [
                  "Get a Quote",
                  "Pricing",
                  "Areas Served"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "From $39",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Lawn Care Services Near Miami, FL - Compare Pros",
                "url": "https://www.thumbtack.com/fl/miami/lawn-care/",
                "displayUrl": "thumbtack.com › fl › miami › lawn-care",
                "desc": "See profiles, photos and ratings for 240+ lawn care pros in Miami. Most respond within an hour and quote from a photo of the yard. Average cost for a standard cut: $45.",
                "favicon": "https://www.google.com/s2/favicons?domain=thumbtack.com&sz=64",
                "sitelinks": [
                  "Top Pros",
                  "Cost Estimator",
                  "Reviews"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Chinch Bug Management in St. Augustinegrass",
                "url": "https://edis.ifas.ufl.edu/publication/IN1027",
                "displayUrl": "edis.ifas.ufl.edu › publication › IN1027",
                "desc": "University of Florida IFAS Extension guidance on identifying southern chinch bug damage, when to treat, and why over-fertilising and drought stress make infestations worse.",
                "favicon": "https://www.google.com/s2/favicons?domain=ufl.edu&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Apr 9, 2025",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 19,
            "name": "Locksmith",
            "category": "Local Business",
            "description": "Lockout call-outs and scam warnings",
            "query": "locked out of house locksmith",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "A residential lockout normally costs $80-$180 during business hours and $150-$300 after 8 PM, and a competent locksmith can pick or bypass most standard cylinders without damaging the door. Ask for the total price on the phone before dispatch: lockout scams are common, where a $19 advert becomes a several-hundred-dollar bill on arrival and the tech insists on drilling the lock. A legitimate locksmith will arrive in a marked vehicle, give a company name, and ask for ID proving you live there."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 1901,
                  "q": "How much does a locksmith charge to unlock a house door?",
                  "a": "Typically $80-$180 in normal hours, rising to $150-$300 late at night or on holidays. Drilling and replacing the cylinder adds $50-$150 in parts."
                },
                {
                  "id": 1902,
                  "q": "How do I avoid a locksmith scam?",
                  "a": "Get the full price and the company's legal name before they dispatch, and refuse anyone who says the lock must be drilled without trying to pick it first."
                },
                {
                  "id": 1903,
                  "q": "Will a locksmith unlock my door without ID?",
                  "a": "No. A reputable locksmith will ask for photo ID plus something tying you to the address, such as a lease, a utility bill or mail."
                }
              ]
            },
            "places": [
              {
                "id": 1911,
                "name": "Pop-A-Lock",
                "rating": 4.6,
                "reviews": "2.7k",
                "price": "$$",
                "category": "Locksmith",
                "open": "Open 24 hours",
                "address": "1450 Commerce Dr",
                "tags": "24/7 · Onsite services · Marked vans",
                "note": "National franchise; quotes the full price by phone before dispatch.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 1912,
                "name": "Anderson Lock & Key",
                "rating": 4.9,
                "reviews": "430",
                "price": "$$",
                "category": "Locksmith",
                "open": "Open · Closes 9 PM",
                "address": "208 N Main St",
                "tags": "Family owned · Rekeying · Emergency",
                "note": "Bonded and insured; picks rather than drills on standard cylinders.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 1913,
                "name": "Metro 24hr Lockout Service",
                "rating": 3.9,
                "reviews": "1.1k",
                "price": "$",
                "category": "Locksmith",
                "open": "Open 24 hours",
                "address": "Service area · no storefront",
                "tags": "24/7 · Mobile only",
                "note": "Dispatch-only operator — several reviews mention quotes changing on arrival.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "24 Hour Emergency Lockout Service | Pop-A-Lock",
                "url": "https://www.popalock.com/services/residential-lockout/",
                "displayUrl": "popalock.com › services › residential-lockout",
                "desc": "Locked out of your house? Licensed, bonded and insured technicians in marked vehicles, typically on site within 30 minutes. Non-destructive entry on most residential locks, price quoted upfront.",
                "favicon": "https://www.google.com/s2/favicons?domain=popalock.com&sz=64",
                "sitelinks": [
                  "Car Lockout",
                  "Rekeying",
                  "Find a Location",
                  "Pricing"
                ],
                "isSponsored": true,
                "rating": 4.6,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 2704
              },
              {
                "id": 2,
                "title": "Locksmith Scams: How to Spot One Before You Call",
                "url": "https://www.bbb.org/article/scams/locksmith-scams",
                "displayUrl": "bbb.org › article › scams › locksmith-scams",
                "desc": "Fake listings advertise a $19 service call, then quote hundreds on the doorstep and insist the lock has to be drilled. Verify the business name, get the total in writing, and pay by card.",
                "favicon": "https://www.google.com/s2/favicons?domain=bbb.org&sz=64",
                "sitelinks": [
                  "Find Accredited Locksmiths",
                  "Report a Scam"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Aug 21, 2025",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Find a Locksmith Near You - 24/7 Emergency",
                "url": "https://www.angi.com/companylist/us/locksmiths.htm",
                "displayUrl": "angi.com › companylist › locksmiths",
                "desc": "Background-checked locksmiths with verified reviews. Compare hourly rates, emergency availability and rekeying prices in your area. Most lockouts are quoted at $95 to $175.",
                "favicon": "https://www.google.com/s2/favicons?domain=angi.com&sz=64",
                "sitelinks": [
                  "Emergency",
                  "Rekey a Lock",
                  "Cost Guide"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 20,
            "name": "Local Gym",
            "category": "Local Business",
            "description": "24 hour gyms, dues and contracts",
            "query": "24 hour fitness near me",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Most 24-hour gyms are either chains like Anytime Fitness and Snap Fitness, which use keyfob entry outside staffed hours, or Planet Fitness locations that run round the clock Monday to Friday but close over the weekend. Monthly dues generally sit between $15 and $60, with an enrolment fee of $0-$99 and an annual maintenance charge many people miss in the paperwork. Check the cancellation terms before signing — several chains still require written notice or an in-person visit, and month-to-month plans usually cost about $10 more a month than a 12-month commitment."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2001,
                  "q": "Which gyms are actually open 24 hours?",
                  "a": "Anytime Fitness and Snap Fitness give members keyfob access around the clock. Planet Fitness is 24/7 on weekdays at most clubs but closes Saturday evening through Sunday."
                },
                {
                  "id": 2002,
                  "q": "How much does a 24 hour gym membership cost?",
                  "a": "Around $15-$30 a month for a budget chain and $40-$60 for a full-service club, plus an enrolment fee and often a $49 annual maintenance charge."
                },
                {
                  "id": 2003,
                  "q": "Is it safe to work out at a gym at 3am?",
                  "a": "Unstaffed hours rely on keyfob entry, cameras and a panic button. Most clubs recommend telling someone you are there and skipping heavy free weights without a spotter."
                }
              ]
            },
            "places": [
              {
                "id": 2011,
                "name": "Anytime Fitness",
                "rating": 4.6,
                "reviews": "540",
                "price": "$$",
                "category": "Gym",
                "open": "Open 24 hours",
                "address": "1122 Market St",
                "tags": "24/7 keyfob · Worldwide access · Free trial",
                "note": "Membership works at any of the 5,000+ clubs worldwide.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2012,
                "name": "Planet Fitness",
                "rating": 4.3,
                "reviews": "2.8k",
                "price": "$",
                "category": "Gym",
                "open": "Open 24 hours · Closes Sat 7 PM",
                "address": "480 Grand Ave",
                "tags": "24/5 · $15 Classic · No contract",
                "note": "Black Card adds guest privileges and any-location access for $24.99.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 2013,
                "name": "Ironline Strength Co.",
                "rating": 4.9,
                "reviews": "310",
                "price": "$$$",
                "category": "Gym",
                "open": "Open 24 hours",
                "address": "77 Warehouse Row",
                "tags": "24/7 · Powerlifting · Chalk allowed",
                "note": "Independent barbell gym; platforms, bumper plates and no lunk alarm.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Gyms Near Me - Open 24/7 | Anytime Fitness",
                "url": "https://www.anytimefitness.com/find-gym/",
                "displayUrl": "anytimefitness.com › find-gym",
                "desc": "Find your nearest club and train whenever it suits you. Keyfob access 24 hours a day, coaching included with membership, and your card works at more than 5,000 gyms worldwide.",
                "favicon": "https://www.google.com/s2/favicons?domain=anytimefitness.com&sz=64",
                "sitelinks": [
                  "Free Day Pass",
                  "Membership Options",
                  "Locations",
                  "Personal Training"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "From $41.99/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Best 24 Hour Gyms Near You - Updated 2026",
                "url": "https://www.yelp.com/search?find_desc=24+hour+gym",
                "displayUrl": "yelp.com › Active Life › Gyms",
                "desc": "Reviews on 24 hour gym - Anytime Fitness, Planet Fitness, Ironline Strength Co. \"Been going at 5am for a year and there are never more than four people in there. Squat racks always free.\"",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open Now",
                  "Free Wi-Fi",
                  "Offers Classes"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Gym Contracts: What to Read Before You Sign",
                "url": "https://consumer.ftc.gov/articles/gym-and-fitness-club-memberships",
                "displayUrl": "consumer.ftc.gov › articles › gym-memberships",
                "desc": "Enrolment fees, annual maintenance charges and automatic renewal are where most complaints start. Know your state's cooling-off period and get any cancellation in writing.",
                "favicon": "https://www.google.com/s2/favicons?domain=ftc.gov&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jun 5, 2025",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 21,
            "name": "High-End Restaurant",
            "category": "Food & Hospitality",
            "description": "Michelin-starred fine dining, SF",
            "query": "michelin star restaurants san francisco",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "San Francisco holds around 30 Michelin-starred restaurants, including three-star Quince and Atelier Crenn and two-star Benu and Birdsong. Most serve a single tasting menu priced roughly $250-$450 per person before wine pairings. Reservations typically open 30 to 60 days ahead on Tock or Resy and are often gone within minutes, though bar seats and cancellations reappear closer to the date."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2101,
                  "q": "How far in advance should I book a Michelin star restaurant in SF?",
                  "a": "Most release reservations on a rolling 30-60 day window at 9 AM Pacific. Quince and Atelier Crenn usually sell out the same morning."
                },
                {
                  "id": 2102,
                  "q": "Is there a dress code?",
                  "a": "Smart casual is accepted almost everywhere; jackets are suggested but not required at Quince and the Ritz-Carlton dining room. No shorts or athletic wear."
                },
                {
                  "id": 2103,
                  "q": "Can they handle dietary restrictions?",
                  "a": "Yes, if you note them when booking. Vegetarian tasting menus are standard, and most kitchens will work around allergies given 48 hours' notice."
                }
              ]
            },
            "places": [
              {
                "id": 2111,
                "name": "Benu",
                "rating": 4.7,
                "reviews": "1.1k",
                "price": "$$$$",
                "category": "Fine dining restaurant",
                "open": "Opens 5:30 PM",
                "address": "22 Hawthorne St",
                "tags": "Dine-in · Tasting menu · Reservations required",
                "note": "Three-star Korean-American tasting menu from chef Corey Lee.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2112,
                "name": "Atelier Crenn",
                "rating": 4.6,
                "reviews": "890",
                "price": "$$$$",
                "category": "French restaurant",
                "open": "Closed · Opens Wed",
                "address": "3127 Fillmore St",
                "tags": "Dine-in · Tasting menu · Wine pairing",
                "note": "Seafood and vegetable menu written as a poem; no meat served.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2113,
                "name": "Quince",
                "rating": 4.5,
                "reviews": "1.4k",
                "price": "$$$$",
                "category": "Italian restaurant",
                "open": "Opens 5:00 PM",
                "address": "470 Pacific Ave",
                "tags": "Dine-in · Tasting menu · Private dining",
                "note": "Produce comes from the restaurant's own farm in Sonoma.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "The MICHELIN Guide San Francisco - Starred Restaurants",
                "url": "https://guide.michelin.com/us/en/california/san-francisco/restaurants/1-star-michelin",
                "displayUrl": "guide.michelin.com › california › san-francisco",
                "desc": "The full 2025 selection for San Francisco: three-star Quince and Atelier Crenn, two-star Benu and Birdsong, plus 20 one-star addresses with inspector notes.",
                "favicon": "https://www.google.com/s2/favicons?domain=guide.michelin.com&sz=64",
                "sitelinks": [
                  "Three Stars",
                  "Bib Gourmand",
                  "New This Year",
                  "Book a Table"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Benu | Three Michelin Star Restaurant in SoMa",
                "url": "https://www.benusf.com/reservations",
                "displayUrl": "benusf.com › reservations",
                "desc": "Tasting menu $420 per guest, service included. Seatings Wednesday through Saturday from 5:30 PM. Reservations open 60 days out at 10 AM Pacific via Tock.",
                "favicon": "https://www.google.com/s2/favicons?domain=benusf.com&sz=64",
                "sitelinks": [
                  "Menu",
                  "Wine List",
                  "Private Dining",
                  "Directions"
                ],
                "isSponsored": false,
                "rating": 4.7,
                "reviews": 1104,
                "price": "$$$$",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Every Michelin-Starred Restaurant in the Bay Area",
                "url": "https://sf.eater.com/maps/best-michelin-star-restaurants-san-francisco-bay-area",
                "displayUrl": "sf.eater.com › maps › michelin-star-restaurants",
                "desc": "Updated for the 2025 guide. Where to spend $400 and where a one-star meal still lands under $150, with notes on which rooms take walk-ins at the bar.",
                "favicon": "https://www.google.com/s2/favicons?domain=eater.com&sz=64",
                "sitelinks": [
                  "The Map",
                  "New Additions",
                  "Bib Gourmand Picks"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Jun 12, 2025",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 22,
            "name": "Pizza Delivery",
            "category": "Food & Hospitality",
            "description": "Domino's delivery, tracker and deals",
            "query": "dominos pizza delivery near me",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Domino's delivers from more than 6,700 US stores, with most orders quoted at 25 to 40 minutes depending on distance and time of day. Carryout is usually 15 to 20 minutes and avoids the delivery fee, which typically runs $3.99 to $5.99 and does not go to the driver. The Mix & Match deal covers two or more items at $6.99 each, and the Emergency Pizza offer adds a free medium two-topping pizza on qualifying orders."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2201,
                  "q": "How long does Domino's delivery usually take?",
                  "a": "Most stores quote 25-40 minutes. Friday and Saturday between 6 and 8 PM runs longest; carryout is generally ready in about 15."
                },
                {
                  "id": 2202,
                  "q": "Is the delivery fee a tip for the driver?",
                  "a": "No. The delivery fee goes to the store to cover vehicle and insurance costs. Drivers are tipped separately."
                },
                {
                  "id": 2203,
                  "q": "What is the cheapest way to order?",
                  "a": "Mix & Match at $6.99 per item with two or more items, ordered for carryout, is usually the lowest price per pizza."
                }
              ]
            },
            "places": [
              {
                "id": 2211,
                "name": "Domino's Pizza - Lincoln Park",
                "rating": 3.9,
                "reviews": "612",
                "price": "$",
                "category": "Pizza delivery",
                "open": "Open · Closes 12 AM",
                "address": "2465 N Lincoln Ave",
                "tags": "Delivery · Takeout · No dine-in",
                "note": "Quoting about 30 min for delivery right now.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2212,
                "name": "Domino's Pizza - West Loop",
                "rating": 4.1,
                "reviews": "438",
                "price": "$",
                "category": "Pizza delivery",
                "open": "Open 24 hours",
                "address": "1130 W Randolph St",
                "tags": "Delivery · Takeout · Curbside",
                "note": "One of the few late-night stores in the area.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2213,
                "name": "Papa Johns Pizza",
                "rating": 3.7,
                "reviews": "295",
                "price": "$",
                "category": "Pizza delivery",
                "open": "Open · Closes 11 PM",
                "address": "820 W Belmont Ave",
                "tags": "Delivery · Takeout",
                "note": "Carryout special runs $9.99 for a large any-topping.",
                "sponsored": true,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Domino's Pizza Delivery & Carryout - Order Online",
                "url": "https://www.dominos.com/en/pages/order/",
                "displayUrl": "dominos.com › order",
                "desc": "Order pizza, pasta, sandwiches and wings for delivery or carryout. Mix & Match 2 or more items at $6.99 each. Track your order from prep to the door.",
                "favicon": "https://www.google.com/s2/favicons?domain=dominos.com&sz=64",
                "sitelinks": [
                  "Deals & Coupons",
                  "Menu",
                  "Store Locator",
                  "Track My Order"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Domino's Tracker - See Where Your Order Is",
                "url": "https://www.dominos.com/en/pages/tracker/",
                "displayUrl": "dominos.com › pages › tracker",
                "desc": "Enter your phone number or order number to follow each stage: order placed, prep, oven, quality check and out for delivery. Updates roughly every 30 seconds.",
                "favicon": "https://www.google.com/s2/favicons?domain=dominos.com&sz=64",
                "sitelinks": [
                  "Track by Phone",
                  "Order History"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Domino's Pizza Delivery - Order on DoorDash",
                "url": "https://www.doordash.com/store/dominos-pizza-chicago-24418/",
                "displayUrl": "doordash.com › store › dominos-pizza",
                "desc": "4.4 ★ (2,100+ ratings) · $ · 25-35 min · $2.99 delivery fee. Menu prices on DoorDash run higher than ordering direct, and store coupons do not apply.",
                "favicon": "https://www.google.com/s2/favicons?domain=doordash.com&sz=64",
                "sitelinks": [
                  "Popular Items",
                  "Reviews",
                  "Group Order"
                ],
                "isSponsored": false,
                "rating": 4.4,
                "reviews": 2137,
                "price": "$",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 23,
            "name": "Recipe Blog",
            "category": "Food & Hospitality",
            "description": "Chocolate chip cookie recipe results",
            "query": "best chocolate chip cookie recipe",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Most highly rated chocolate chip cookie recipes agree on a few things: brown butter or melted butter for a chewier crumb, a higher ratio of brown sugar to white for moisture, and resting the dough 24 to 72 hours so the flour hydrates and the flavour deepens. Baking at 350°F for 10 to 12 minutes and pulling the trays while the centres still look underdone gives a soft middle with crisp edges. Most recipes yield 18 to 24 cookies from about 2¼ cups of flour."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2301,
                  "q": "Why chill chocolate chip cookie dough?",
                  "a": "Chilling firms the fat so cookies spread less, and a 24-72 hour rest lets the flour hydrate, which deepens the toffee flavour."
                },
                {
                  "id": 2302,
                  "q": "Should I use melted or softened butter?",
                  "a": "Melted butter gives a denser, chewier cookie; creamed softened butter traps air and bakes up cakier and taller."
                },
                {
                  "id": 2303,
                  "q": "How do I stop my cookies going flat?",
                  "a": "Usually butter that is too warm or over-creamed. Chill the dough 30 minutes, check your baking soda is in date, and measure flour by weight."
                }
              ]
            },
            "places": [
              {
                "id": 2311,
                "name": "Levain Bakery",
                "rating": 4.6,
                "reviews": "9.8k",
                "price": "$$",
                "category": "Bakery",
                "open": "Open · Closes 8 PM",
                "address": "167 W 74th St",
                "tags": "Takeout · Dine-in · No delivery",
                "note": "Six-ounce chocolate chip walnut cookies, baked all day.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2312,
                "name": "Chip City Cookies",
                "rating": 4.4,
                "reviews": "1.6k",
                "price": "$",
                "category": "Cookie shop",
                "open": "Open · Closes 10 PM",
                "address": "40 W 8th St",
                "tags": "Takeout · Delivery · Rotating weekly flavors",
                "note": "Flavor list changes every Monday; classic chip is permanent.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "The Food Lab's Chocolate Chip Cookies Recipe",
                "url": "https://www.seriouseats.com/the-food-lab-the-best-chocolate-chip-cookies",
                "displayUrl": "seriouseats.com › recipes › cookies",
                "desc": "4.7 ★ (1,240) · 45 min active, 24 hr rest · Makes 24. Browned butter, a 2:1 brown-to-white sugar ratio and a long chill produce a chewy centre and crisp rim.",
                "favicon": "https://www.google.com/s2/favicons?domain=seriouseats.com&sz=64",
                "sitelinks": [
                  "Jump to Recipe",
                  "Why It Works",
                  "Equipment",
                  "Reviews"
                ],
                "isSponsored": false,
                "rating": 4.7,
                "reviews": 1240,
                "price": "",
                "date": "Aug 2, 2024",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "BA's Best Chocolate Chip Cookies",
                "url": "https://www.bonappetit.com/recipe/bas-best-chocolate-chip-cookies",
                "displayUrl": "bonappetit.com › recipe › chocolate-chip-cookies",
                "desc": "Total time 1 hr 10 min · Makes about 18. Chopped chocolate bars instead of chips give layered pools rather than dots, and a flaky salt finish before baking.",
                "favicon": "https://www.google.com/s2/favicons?domain=bonappetit.com&sz=64",
                "sitelinks": [
                  "Ingredients",
                  "Preparation",
                  "Comments"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "reviews": 862,
                "price": "",
                "date": "Mar 18, 2023",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Best Chocolate Chip Cookies - Allrecipes",
                "url": "https://www.allrecipes.com/recipe/10813/best-chocolate-chip-cookies/",
                "displayUrl": "allrecipes.com › Desserts › Cookies",
                "desc": "4.6 ★ (19,000+ ratings) · Prep 20 min, bake 10 min · Serves 24. The classic creamed-butter version with 2¼ cups flour, no chilling required before baking.",
                "favicon": "https://www.google.com/s2/favicons?domain=allrecipes.com&sz=64",
                "sitelinks": [
                  "Ingredients",
                  "Directions",
                  "Nutrition Facts",
                  "19,241 Reviews"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "reviews": 19241,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 24,
            "name": "Hotel Booking",
            "category": "Food & Hospitality",
            "description": "Luxury palace hotels in Paris",
            "query": "luxury hotels in paris",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Paris has twelve hotels holding the official Palace distinction, including the Ritz Paris, Le Bristol, Le Meurice, Plaza Athénée and Four Seasons George V. Entry-level rooms generally start around €1,200 to €1,800 a night, rising sharply in June, September and during fashion weeks. The 1st and 8th arrondissements hold most of them; the 6th offers quieter five-star options such as Lutetia at somewhat lower rates. Booking direct often includes breakfast and a room-category upgrade that third-party rates do not."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2401,
                  "q": "What is a Palace hotel in France?",
                  "a": "A distinction awarded by Atout France above the five-star rating. Twelve Paris hotels currently hold it, judged on service, history and location."
                },
                {
                  "id": 2402,
                  "q": "Which arrondissement is best for a luxury stay?",
                  "a": "The 1st for the Louvre and Ritz, the 8th for the Champs-Élysées palaces, and the 6th if you want quieter streets and easier walking."
                },
                {
                  "id": 2403,
                  "q": "When are rates lowest?",
                  "a": "Mid-January to early March and August, when business travel drops. Rates can fall 30-40% from the September and fashion-week peaks."
                }
              ]
            },
            "places": [
              {
                "id": 2411,
                "name": "Le Bristol Paris",
                "rating": 4.8,
                "reviews": "3.2k",
                "price": "$$$$",
                "category": "5-star hotel",
                "open": "Open 24 hours",
                "address": "112 Rue du Faubourg Saint-Honoré, 8th",
                "tags": "Free Wi-Fi · Pool · Spa · Michelin restaurant",
                "note": "Rooftop pool and a courtyard garden rare for central Paris.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2412,
                "name": "Hôtel Plaza Athénée",
                "rating": 4.7,
                "reviews": "2.6k",
                "price": "$$$$",
                "category": "5-star hotel",
                "open": "Open 24 hours",
                "address": "25 Av. Montaigne, 8th",
                "tags": "Free Wi-Fi · Spa · Bar · Eiffel Tower views",
                "note": "Red geraniums on the Montaigne façade from May to October.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2413,
                "name": "Ritz Paris",
                "rating": 4.8,
                "reviews": "4.1k",
                "price": "$$$$",
                "category": "5-star hotel",
                "open": "Open 24 hours",
                "address": "15 Place Vendôme, 1st",
                "tags": "Free Wi-Fi · Pool · Spa · Bar Hemingway",
                "note": "Reopened in 2016 after a four-year restoration.",
                "sponsored": true,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "The 10 Best Luxury Hotels in Paris, France",
                "url": "https://www.booking.com/luxury/city/fr/paris.en-gb.html",
                "displayUrl": "booking.com › luxury › france › paris",
                "desc": "Compare 240 five-star properties in Paris with free cancellation on most rates. Filter by arrondissement, spa, pool or Michelin dining. Prices from €680 a night.",
                "favicon": "https://www.google.com/s2/favicons?domain=booking.com&sz=64",
                "sitelinks": [
                  "Le Bristol",
                  "Ritz Paris",
                  "Deals This Week",
                  "Map View"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "from €680",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Ritz Paris - Palace Hotel on Place Vendôme",
                "url": "https://www.ritzparis.com/en-GB/rooms-suites",
                "displayUrl": "ritzparis.com › rooms-suites",
                "desc": "142 rooms and suites overlooking Place Vendôme or the interior gardens. Direct bookings include breakfast for two and access to the Ritz Club pool and spa.",
                "favicon": "https://www.google.com/s2/favicons?domain=ritzparis.com&sz=64",
                "sitelinks": [
                  "Rooms & Suites",
                  "Bar Hemingway",
                  "Spa",
                  "Offers"
                ],
                "isSponsored": false,
                "rating": 4.8,
                "reviews": 4118,
                "price": "$$$$",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "THE 10 BEST Luxury Hotels in Paris (2025) - Tripadvisor",
                "url": "https://www.tripadvisor.com/Hotels-g187147-zff31-Paris_Ile_de_France-Hotels.html",
                "displayUrl": "tripadvisor.com › Europe › France › Paris",
                "desc": "Ranked from 187,000 traveller reviews. Le Bristol and Shangri-La take the top spots for service; several reviewers note the smallest rooms at the Ritz.",
                "favicon": "https://www.google.com/s2/favicons?domain=tripadvisor.com&sz=64",
                "sitelinks": [
                  "Traveller Ranked",
                  "Best Value",
                  "Near the Louvre"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "reviews": 18742,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 25,
            "name": "Flight Search",
            "category": "Food & Hospitality",
            "description": "Cheap flights to London comparison",
            "query": "cheap flights to london",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Round-trip fares from the US East Coast to London typically run $420 to $700 in economy, dropping to around $350 in late January and November and peaking above $900 from mid-June to August. Heathrow carries the most direct routes, while Gatwick and Stansted often price lower on Norse Atlantic and PLAY. Booking two to four months ahead usually lands near the low, and Tuesday and Wednesday departures average $60 to $100 less than weekend ones."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2501,
                  "q": "When is the cheapest time to fly to London?",
                  "a": "Mid-January through early March and the first half of November. Avoid mid-June to August and the two weeks around Christmas."
                },
                {
                  "id": 2502,
                  "q": "Is it cheaper to fly into Gatwick than Heathrow?",
                  "a": "Often by $50-$120, since low-cost long-haul carriers use Gatwick and Stansted. Factor in the longer, pricier train into central London."
                },
                {
                  "id": 2503,
                  "q": "How far ahead should I book?",
                  "a": "Two to four months for economy. Fares usually rise sharply inside 21 days, and last-minute drops on transatlantic routes are rare."
                }
              ]
            },
            "places": [
              {
                "id": 2511,
                "name": "Heathrow Airport (LHR)",
                "rating": 4,
                "reviews": "84k",
                "price": "",
                "category": "International airport",
                "open": "Open 24 hours",
                "address": "Longford TW6 1AP, United Kingdom",
                "tags": "Piccadilly line · Heathrow Express · 5 terminals",
                "note": "Express train reaches Paddington in 15 minutes.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2512,
                "name": "Gatwick Airport (LGW)",
                "rating": 3.9,
                "reviews": "52k",
                "price": "",
                "category": "International airport",
                "open": "Open 24 hours",
                "address": "Horley, Gatwick RH6 0NP, United Kingdom",
                "tags": "Gatwick Express · 2 terminals · Long-stay parking",
                "note": "About 30 minutes by train to London Victoria.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2513,
                "name": "Stansted Airport (STN)",
                "rating": 3.6,
                "reviews": "38k",
                "price": "",
                "category": "International airport",
                "open": "Open 24 hours",
                "address": "Bassingbourn Rd, Stansted CM24 1QW, United Kingdom",
                "tags": "Stansted Express · 1 terminal · Low-cost carriers",
                "note": "Cheapest fares, but 47 minutes from Liverpool Street.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Cheap Flights to London from $389 - Google Flights",
                "url": "https://www.google.com/travel/flights/flights-to-london.html",
                "displayUrl": "google.com › travel › flights › london",
                "desc": "Track prices across Heathrow, Gatwick and Stansted. The date grid shows the cheapest departures in the next six months and flags fares below the usual range.",
                "favicon": "https://www.google.com/s2/favicons?domain=google.com&sz=64",
                "sitelinks": [
                  "Price Graph",
                  "Date Grid",
                  "Track Prices",
                  "Explore"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "from $389",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Flights to London (LON) - Skyscanner",
                "url": "https://www.skyscanner.net/routes/us/lond/flights-to-london.html",
                "displayUrl": "skyscanner.net › routes › flights-to-london",
                "desc": "Compare 1,200+ airlines and agents. Whole Month search shows January at $362 return from New York; direct-only filter adds roughly $75 on most dates.",
                "favicon": "https://www.google.com/s2/favicons?domain=skyscanner.net&sz=64",
                "sitelinks": [
                  "Whole Month",
                  "Direct Flights",
                  "Price Alerts",
                  "Hotels"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "from $362",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "British Airways - Book Flights to London Heathrow",
                "url": "https://www.britishairways.com/travel/fx/public/en_us",
                "displayUrl": "britishairways.com › book › flights",
                "desc": "Direct daily services to Heathrow from 25 US cities. Economy fares include a checked bag on transatlantic routes; hand-baggage-only Basic fares sit about $60 lower.",
                "favicon": "https://www.google.com/s2/favicons?domain=britishairways.com&sz=64",
                "sitelinks": [
                  "Manage My Booking",
                  "Baggage Allowance",
                  "Check-in",
                  "Executive Club"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 26,
            "name": "Coffee Roaster",
            "category": "Food & Hospitality",
            "description": "Specialty coffee beans, buy online",
            "query": "buy specialty coffee beans online",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Specialty coffee is graded 80 points or above by a certified Q grader, and reputable roasters print the roast date rather than a best-before date. A 12 oz bag typically costs $18 to $26, with single-origin lots and competition micro-lots running higher. Beans are at their best roughly 5 to 21 days after roasting, so most roasters ship within 48 hours of the roast and recommend buying only two to three weeks' worth at a time."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2601,
                  "q": "How long do roasted coffee beans stay fresh?",
                  "a": "Peak flavour is about 5-21 days after roasting. Sealed in a valve bag away from light they stay decent for around six weeks."
                },
                {
                  "id": 2602,
                  "q": "Should I freeze coffee beans?",
                  "a": "Only in sealed single-dose portions you never refreeze. Repeated thawing pulls condensation into the beans and dulls the cup."
                },
                {
                  "id": 2603,
                  "q": "What makes coffee 'specialty' rather than commodity?",
                  "a": "A cupping score of 80+ on the SCA 100-point scale, traceable to a single farm or co-op, with defect counts below a set threshold."
                }
              ]
            },
            "places": [
              {
                "id": 2611,
                "name": "Blue Bottle Coffee",
                "rating": 4.5,
                "reviews": "1.9k",
                "price": "$$",
                "category": "Coffee roasters",
                "open": "Open · Closes 6 PM",
                "address": "1 Ferry Building #7",
                "tags": "Dine-in · Takeout · Beans to go",
                "note": "Whole bean bags roasted within the last week on the shelf.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 2612,
                "name": "Ritual Coffee Roasters",
                "rating": 4.4,
                "reviews": "1.3k",
                "price": "$$",
                "category": "Coffee roasters",
                "open": "Open · Closes 5 PM",
                "address": "1026 Valencia St",
                "tags": "Dine-in · Takeout · Free brew guides",
                "note": "Staff will grind for your brewer at the counter.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Specialty Coffee Beans - Roasted to Order | Counter Culture",
                "url": "https://counterculturecoffee.com/collections/coffee",
                "displayUrl": "counterculturecoffee.com › collections › coffee",
                "desc": "Single origins and blends roasted Monday to Thursday and shipped the same day. 12 oz bags from $18.50, with subscriptions saving 10% and shipping free over $40.",
                "favicon": "https://www.google.com/s2/favicons?domain=counterculturecoffee.com&sz=64",
                "sitelinks": [
                  "Single Origin",
                  "Subscriptions",
                  "Brew Guides",
                  "Wholesale"
                ],
                "isSponsored": true,
                "rating": 4.8,
                "reviews": 2431,
                "price": "from $18.50",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Coffee Beans & Whole Bean Coffee - Blue Bottle",
                "url": "https://bluebottlecoffee.com/us/eng/store/whole-bean",
                "displayUrl": "bluebottlecoffee.com › store › whole-bean",
                "desc": "Every bag ships within 24 hours of roasting with the roast date printed on the side. Bella Donovan blend $22 for 12 oz; Ethiopian single origins from $26.",
                "favicon": "https://www.google.com/s2/favicons?domain=bluebottlecoffee.com&sz=64",
                "sitelinks": [
                  "Blends",
                  "Single Origin",
                  "Subscribe & Save",
                  "Instant"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "reviews": 3890,
                "price": "from $22.00",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "The Best Coffee Beans, Tested by Our Editors",
                "url": "https://www.seriouseats.com/best-coffee-beans-8419920",
                "displayUrl": "seriouseats.com › Drinks › Coffee",
                "desc": "We brewed 24 bags side by side on a V60 and an espresso machine. Roast date, not price, predicted the cup most reliably, and two supermarket bags beat $30 lots.",
                "favicon": "https://www.google.com/s2/favicons?domain=seriouseats.com&sz=64",
                "sitelinks": [
                  "How We Tested",
                  "Our Favorites",
                  "What to Look For"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Feb 4, 2025",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 27,
            "name": "Project Management",
            "category": "SaaS & Tech Tools",
            "description": "Monday vs Asana head-to-head",
            "query": "Monday.com vs Asana",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Monday.com and Asana are both work management platforms, but they price and scale differently. Monday.com bills in seat blocks starting at 3 seats, with Basic around $9 per seat/month billed annually and Standard around $12, and its board view is closer to a spreadsheet. Asana has a free tier for up to 10 collaborators and starts at roughly $10.99 per user/month annually, with stronger task dependencies and portfolio reporting on higher plans. Teams that want custom dashboards and automations at a lower tier tend to pick Monday.com; teams tracking cross-project dependencies tend to pick Asana."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2701,
                  "q": "Is Monday.com cheaper than Asana?",
                  "a": "Per seat, yes at the entry tier, but Monday.com requires a minimum of 3 seats and bills in blocks of 5, so a 6-person team often pays for 10."
                },
                {
                  "id": 2702,
                  "q": "Does Asana have a free plan?",
                  "a": "Yes. Asana's free Personal plan covers up to 10 collaborators with unlimited tasks and projects, but no timeline view, custom fields or reporting dashboards."
                },
                {
                  "id": 2703,
                  "q": "Which one is better for Gantt charts?",
                  "a": "Asana's Timeline is included from the Starter plan; Monday.com puts its Gantt view on Standard and above."
                },
                {
                  "id": 2704,
                  "q": "Can you migrate from Asana to Monday.com?",
                  "a": "Monday.com has a built-in Asana importer that maps projects to boards and tasks to items. Subtasks and comment history usually come across; custom rules do not."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Monday.com vs Asana: Which Is Better in 2026?",
                "url": "https://www.pcmag.com/comparisons/mondaycom-vs-asana",
                "displayUrl": "pcmag.com › comparisons › project-management",
                "desc": "We ran both platforms with a 12-person team for six weeks. Monday.com wins on dashboards and automation limits; Asana wins on dependencies, workload view and search.",
                "favicon": "https://www.google.com/s2/favicons?domain=pcmag.com&sz=64",
                "sitelinks": [
                  "Pricing compared",
                  "Automations",
                  "Verdict"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Feb 18, 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Compare monday.com vs Asana - G2",
                "url": "https://www.g2.com/compare/monday-com-vs-asana",
                "displayUrl": "g2.com › compare › monday-com-vs-asana",
                "desc": "monday.com rated 4.7/5 from 12,480 reviews; Asana rated 4.4/5 from 10,960 reviews. Side-by-side scores for ease of setup, quality of support and meets requirements.",
                "favicon": "https://www.google.com/s2/favicons?domain=g2.com&sz=64",
                "sitelinks": [
                  "Pricing",
                  "Reviews",
                  "Alternatives"
                ],
                "isSponsored": false,
                "rating": 4.7,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 12480
              },
              {
                "id": 3,
                "title": "Pricing - monday.com work management",
                "url": "https://monday.com/pricing",
                "displayUrl": "monday.com › pricing",
                "desc": "Free for up to 2 seats. Basic $9/seat/month billed annually, Standard $12, Pro $19. Minimum 3 seats on paid plans. 14-day trial, no card required.",
                "favicon": "https://www.google.com/s2/favicons?domain=monday.com&sz=64",
                "sitelinks": [
                  "Compare plans",
                  "Enterprise",
                  "Start free trial"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "From $9/seat/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 4,
                "title": "Asana Pricing - Free, Starter and Advanced Plans",
                "url": "https://asana.com/pricing",
                "displayUrl": "asana.com › pricing",
                "desc": "Personal is free for up to 10 collaborators. Starter is $10.99 per user/month billed annually and adds Timeline, custom fields and 25,000 automations a month.",
                "favicon": "https://www.google.com/s2/favicons?domain=asana.com&sz=64",
                "sitelinks": [
                  "Starter",
                  "Advanced",
                  "Compare plans"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "From $10.99/user/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 28,
            "name": "CRM Software",
            "category": "SaaS & Tech Tools",
            "description": "Best CRM for a small team",
            "query": "Best CRM for small business",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "For small businesses, the usual shortlist is HubSpot, Zoho CRM and Pipedrive. HubSpot's CRM is free for unlimited users with a 1,000,000 contact limit, and its paid Starter tier is about $15 per seat/month annually. Zoho CRM Standard runs roughly $14 per user/month and is the cheapest way to get workflow automation and custom modules. Pipedrive at about $14 per seat/month is the most sales-pipeline focused of the three. Reviewers generally suggest picking on how much of your process is email marketing versus deal tracking, since migrating later is the expensive part."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2801,
                  "q": "Is HubSpot CRM really free forever?",
                  "a": "The core CRM is, with unlimited users and up to 1,000,000 contacts. Email sequences, reporting dashboards beyond 3, and removing HubSpot branding all require a paid Starter seat."
                },
                {
                  "id": 2802,
                  "q": "How much should a small business spend on a CRM?",
                  "a": "Most 5-15 person teams land between $60 and $300 a month total. Anything above that usually means you are paying for marketing automation, not the CRM itself."
                },
                {
                  "id": 2803,
                  "q": "What is the easiest CRM to set up?",
                  "a": "Pipedrive is consistently rated fastest, with most teams importing contacts and running a live pipeline within a day. Zoho takes longer but is more configurable."
                },
                {
                  "id": 2804,
                  "q": "Do I need a CRM if I only have 200 customers?",
                  "a": "Probably not a paid one. A free HubSpot or Zoho Bigin account handles that volume, and spreadsheets stop working somewhere around the point where two people need to update the same record."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Pipedrive CRM - Built for Small Sales Teams",
                "url": "https://www.pipedrive.com/en/lp/small-business-crm",
                "displayUrl": "pipedrive.com › small-business-crm",
                "desc": "Set up your pipeline in under 10 minutes. From $14 per seat/month billed annually. 14-day free trial, no credit card. Rated 4.5 on G2 from 2,100+ reviews.",
                "favicon": "https://www.google.com/s2/favicons?domain=pipedrive.com&sz=64",
                "sitelinks": [
                  "Pricing",
                  "Free trial",
                  "Integrations"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "$14/seat/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "The 8 Best CRMs for Small Business in 2026",
                "url": "https://www.pcmag.com/picks/the-best-crm-software-for-small-business",
                "displayUrl": "pcmag.com › picks › best-crm-software",
                "desc": "We tested 14 CRMs on a 6-seat account. Zoho CRM takes Editors' Choice on value at $14/user/month; HubSpot wins if you need the free tier to carry you past year one.",
                "favicon": "https://www.google.com/s2/favicons?domain=pcmag.com&sz=64",
                "sitelinks": [
                  "Zoho CRM",
                  "HubSpot",
                  "How we test"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jan 9, 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Best CRM Software for Small Business 2026 | Capterra",
                "url": "https://www.capterra.com/crm-software/s/small-business/",
                "displayUrl": "capterra.com › crm-software › small-business",
                "desc": "Compare 640+ CRM products filtered for businesses under 50 employees. Verified reviews, pricing, and free-trial availability. HubSpot 4.5 (4,300), Zoho CRM 4.3 (6,900).",
                "favicon": "https://www.google.com/s2/favicons?domain=capterra.com&sz=64",
                "sitelinks": [
                  "Free CRMs",
                  "Compare",
                  "Buyers guide"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 4300
              },
              {
                "id": 4,
                "title": "Free CRM Software for Small Business | HubSpot",
                "url": "https://www.hubspot.com/products/crm",
                "displayUrl": "hubspot.com › products › crm",
                "desc": "Unlimited users, up to 1,000,000 contacts, no expiry date. Deal pipelines, email tracking and meeting scheduling included. Starter seats from $15/month when you need more.",
                "favicon": "https://www.google.com/s2/favicons?domain=hubspot.com&sz=64",
                "sitelinks": [
                  "Get free CRM",
                  "Pricing",
                  "Sales Hub"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "Free",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 29,
            "name": "Web Hosting",
            "category": "SaaS & Tech Tools",
            "description": "Bluehost reviews and renewal costs",
            "query": "Bluehost reviews",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Bluehost is a shared hosting provider owned by Newfold Digital and one of three hosts officially recommended by WordPress.org. Reviews are mixed: the introductory price of around $1.99/month is widely praised, but the renewal rate jumps to roughly $11.99/month on the Basic plan, and that gap is the most common complaint. Independent uptime monitoring generally puts it in the 99.95-99.98% range, with support quality described as inconsistent since the 2022 outsourcing changes. It suits a first WordPress site; reviewers tend to steer higher-traffic sites toward managed hosts."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 2901,
                  "q": "Why does Bluehost get bad reviews?",
                  "a": "Almost all of it is the renewal price. A 36-month term at $1.99/month renews near $11.99/month, and the discount only applies to the first term."
                },
                {
                  "id": 2902,
                  "q": "Is Bluehost good for WordPress?",
                  "a": "It is one of three hosts WordPress.org recommends, and WordPress comes preinstalled. It handles a typical blog or brochure site fine; heavy WooCommerce stores tend to outgrow the Basic plan."
                },
                {
                  "id": 2903,
                  "q": "Can I get a refund from Bluehost?",
                  "a": "Yes, within 30 days of purchase for hosting fees. Domain registration fees are non-refundable and are deducted from the refund, usually around $17."
                },
                {
                  "id": 2904,
                  "q": "What is a good Bluehost alternative?",
                  "a": "SiteGround and Hostinger are the usual comparisons at a similar price; Cloudways or Kinsta if you want managed WordPress and can spend $30+ a month."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Bluehost Review 2026: Pros, Cons and Real Renewal Costs",
                "url": "https://www.techradar.com/reviews/bluehost",
                "displayUrl": "techradar.com › reviews › hosting",
                "desc": "Rated 3.5/5. We hosted a test site for 9 months and logged 99.97% uptime. Cheap to start, but the Basic plan renews at $11.99/month and backups cost extra.",
                "favicon": "https://www.google.com/s2/favicons?domain=techradar.com&sz=64",
                "sitelinks": [
                  "Pricing",
                  "Uptime results",
                  "Verdict"
                ],
                "isSponsored": false,
                "rating": 3.5,
                "price": "",
                "date": "Mar 4, 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Bluehost Reviews 2026 - Verified User Ratings | Trustpilot",
                "url": "https://www.trustpilot.com/review/bluehost.com",
                "displayUrl": "trustpilot.com › review › bluehost.com",
                "desc": "3.9 out of 5 based on 41,208 reviews. Most recent 5-star reviews mention migration help; 1-star reviews cluster around renewal billing and refund timing.",
                "favicon": "https://www.google.com/s2/favicons?domain=trustpilot.com&sz=64",
                "sitelinks": [
                  "1-star reviews",
                  "Company replies"
                ],
                "isSponsored": false,
                "rating": 3.9,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 41208
              },
              {
                "id": 3,
                "title": "Web Hosting - Bluehost Plans from $1.99/mo",
                "url": "https://www.bluehost.com/hosting/shared",
                "displayUrl": "bluehost.com › hosting › shared",
                "desc": "Basic $1.99/mo for a 36-month term, renews at $11.99/mo. Free domain for year one, free SSL, 10 GB SSD storage and a 30-day money-back guarantee.",
                "favicon": "https://www.google.com/s2/favicons?domain=bluehost.com&sz=64",
                "sitelinks": [
                  "Compare plans",
                  "WordPress hosting",
                  "Domains"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "From $1.99/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 30,
            "name": "VPN Service",
            "category": "SaaS & Tech Tools",
            "description": "NordVPN deals and coupon codes",
            "query": "NordVPN discount code",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "NordVPN's largest discounts come from its own two-year plans rather than from coupon codes. The two-year Basic plan is usually around $3.39/month billed upfront, roughly 70% off the monthly rate of $12.99, and Plus and Complete tiers add Threat Protection Pro and 1 TB of encrypted storage. Third-party codes on coupon sites mostly duplicate the on-site offer or add a few extra months rather than cutting the rate further. All plans carry a 30-day money-back guarantee, which is the usual way reviewers suggest testing it."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3001,
                  "q": "Do NordVPN coupon codes actually work?",
                  "a": "Most stack an extra 3-6 months onto a 2-year plan rather than lowering the price. The advertised rate on NordVPN's own deal page is usually already applied at checkout."
                },
                {
                  "id": 3002,
                  "q": "How much is NordVPN per month?",
                  "a": "$12.99 month-to-month, or about $3.39/month on a two-year Basic plan paid upfront. The two-year term renews at the one-year rate, not the discounted one."
                },
                {
                  "id": 3003,
                  "q": "Can I get NordVPN free?",
                  "a": "There is no free tier, but the 30-day money-back guarantee is a full refund and NordVPN honours it through live chat. Mobile app-store purchases refund through Apple or Google instead."
                },
                {
                  "id": 3004,
                  "q": "What is the difference between Plus and Complete?",
                  "a": "Plus adds NordPass password manager and Threat Protection Pro. Complete adds 1 TB of NordLocker encrypted cloud storage on top."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "NordVPN Deal - Up to 72% Off 2-Year Plans",
                "url": "https://nordvpn.com/offer/deal/",
                "displayUrl": "nordvpn.com › offer › deal",
                "desc": "Basic from $3.39/mo on a 2-year plan, plus 3 extra months. Includes 10 devices, Threat Protection and a 30-day money-back guarantee. Discount applied at checkout.",
                "favicon": "https://www.google.com/s2/favicons?domain=nordvpn.com&sz=64",
                "sitelinks": [
                  "Pricing",
                  "Plus vs Complete",
                  "Free trial"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "$3.39/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "NordVPN Coupons & Promo Codes - Verified March 2026",
                "url": "https://www.retailmenot.com/view/nordvpn.com",
                "displayUrl": "retailmenot.com › view › nordvpn.com",
                "desc": "9 active offers, last verified 2 days ago. Best code adds 3 months free to any 2-year plan. Sitewide 72% off does not require a code and applies automatically.",
                "favicon": "https://www.google.com/s2/favicons?domain=retailmenot.com&sz=64",
                "sitelinks": [
                  "All codes",
                  "Student discount"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "NordVPN Review: Still the Fastest VPN We've Tested",
                "url": "https://www.techradar.com/reviews/nordvpn",
                "displayUrl": "techradar.com › reviews › vpn",
                "desc": "Rated 4.5/5. NordLynx held 92% of our base speed on a UK-to-US route. 7,400+ servers in 118 countries. Audited no-logs policy, but the renewal price is a step up.",
                "favicon": "https://www.google.com/s2/favicons?domain=techradar.com&sz=64",
                "sitelinks": [
                  "Speed tests",
                  "Pricing",
                  "Alternatives"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "price": "",
                "date": "Feb 26, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 31,
            "name": "Cybersecurity",
            "category": "SaaS & Tech Tools",
            "description": "Antivirus suites compared",
            "query": "Best antivirus software",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Independent lab testing from AV-TEST and AV-Comparatives consistently puts Bitdefender, Kaspersky and Norton at or near 100% detection of zero-day and widespread malware. Bitdefender Total Security is the most common Editors' Choice pick at around $49.99 for the first year across 5 devices, renewing near $99.99. Norton 360 Deluxe is priced similarly and bundles 50 GB of cloud backup and a VPN. For most Windows users, Microsoft Defender is now rated adequate on its own, so the case for paying is usually the extra features rather than the detection engine."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3101,
                  "q": "Is Windows Defender enough in 2026?",
                  "a": "For a patched machine with cautious browsing habits, generally yes. AV-TEST scores it at or near 6/6 for protection. Paid suites add ransomware rollback, VPN and identity monitoring, not much extra detection."
                },
                {
                  "id": 3102,
                  "q": "Which antivirus is best for the money?",
                  "a": "Bitdefender Total Security at about $49.99 for 5 devices in year one is the usual value pick. Watch the renewal, which roughly doubles."
                },
                {
                  "id": 3103,
                  "q": "Does antivirus slow down your PC?",
                  "a": "AV-Comparatives measures a 3-8% performance impact on typical suites. Full scans are noticeable; real-time protection on a modern SSD generally is not."
                },
                {
                  "id": 3104,
                  "q": "Do Macs need antivirus?",
                  "a": "Less than Windows, but Macs are not immune. Most Mac-specific detections are adware and browser hijackers rather than ransomware."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "The Best Antivirus Software for 2026 - PCMag",
                "url": "https://www.pcmag.com/picks/the-best-antivirus-protection",
                "displayUrl": "pcmag.com › picks › best-antivirus-protection",
                "desc": "Bitdefender and Norton share Editors' Choice. We scored 22 products against live malware, phishing URLs and lab results from AV-Test and AV-Comparatives.",
                "favicon": "https://www.google.com/s2/favicons?domain=pcmag.com&sz=64",
                "sitelinks": [
                  "Bitdefender",
                  "Norton 360",
                  "Free antivirus"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jan 22, 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Test antivirus software for Windows 11 - AV-TEST",
                "url": "https://www.av-test.org/en/antivirus/home-windows/",
                "displayUrl": "av-test.org › antivirus › home-windows",
                "desc": "Latest results: 18 security products tested over two months against 17,000+ malware samples. Protection, performance and usability scored out of 6 points each.",
                "favicon": "https://www.google.com/s2/favicons?domain=av-test.org&sz=64",
                "sitelinks": [
                  "Latest results",
                  "Test methodology"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Feb 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Bitdefender Total Security - 5 Devices, 1 Year",
                "url": "https://www.bitdefender.com/solutions/total-security.html",
                "displayUrl": "bitdefender.com › solutions › total-security",
                "desc": "$49.99 for the first year, covering 5 devices on Windows, macOS, Android and iOS. Includes ransomware remediation and a 200 MB/day VPN. Renews at $99.99.",
                "favicon": "https://www.google.com/s2/favicons?domain=bitdefender.com&sz=64",
                "sitelinks": [
                  "Buy now",
                  "Free trial",
                  "Compare plans"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "price": "$49.99/yr",
                "date": "",
                "thumbnail": "",
                "reviews": 2870
              }
            ]
          },
          {
            "id": 32,
            "name": "AI Tools",
            "category": "SaaS & Tech Tools",
            "description": "ChatGPT Plus vs Claude Pro",
            "query": "ChatGPT Plus vs Claude Pro",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "ChatGPT Plus and Claude Pro are both $20 a month, and the choice usually comes down to breadth versus writing. Plus bundles image generation, voice mode, web browsing and a code interpreter into one subscription, so it covers more tasks without extra tools. Claude Pro is more often preferred for long-document work and drafting, with a larger context window and roughly 5x the free plan's usage. Both throttle heavy use on rolling windows rather than hard monthly caps, so power users on either side report hitting limits during long sessions."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3201,
                  "q": "Is Claude Pro better than ChatGPT Plus for writing?",
                  "a": "Most side-by-side reviews say yes for long-form drafting and editing, largely because of the bigger context window. ChatGPT stays ahead on tasks needing images, voice or code execution."
                },
                {
                  "id": 3202,
                  "q": "What are the usage limits on each?",
                  "a": "Both use rolling windows rather than monthly quotas. Claude Pro is advertised at about 5x free usage; ChatGPT Plus caps its top reasoning models per few hours."
                },
                {
                  "id": 3203,
                  "q": "Can I use both for $40 a month?",
                  "a": "Yes, and a fair number of heavy users do exactly that, switching when one hits a limit. Both bill monthly with no contract."
                },
                {
                  "id": 3204,
                  "q": "Is there an annual discount?",
                  "a": "Claude Pro offers an annual plan at roughly $17/month billed yearly. ChatGPT Plus is month-to-month only for individuals."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "ChatGPT Plus vs Claude Pro: Which $20 Plan Wins?",
                "url": "https://www.tomsguide.com/ai/chatgpt-plus-vs-claude-pro",
                "displayUrl": "tomsguide.com › ai › chatbots",
                "desc": "We ran 20 identical prompts through both. Claude took writing and long-document analysis; ChatGPT took image generation, data analysis and anything needing the web.",
                "favicon": "https://www.google.com/s2/favicons?domain=tomsguide.com&sz=64",
                "sitelinks": [
                  "The prompts",
                  "Verdict",
                  "Free tiers"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Mar 1, 2026",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Pricing - Claude plans for individuals and teams",
                "url": "https://www.anthropic.com/pricing",
                "displayUrl": "anthropic.com › pricing",
                "desc": "Pro is $20/month, or $17/month billed annually. Around 5x more usage than Free, access to Projects, and higher limits during peak hours. Team plans from 5 seats.",
                "favicon": "https://www.google.com/s2/favicons?domain=anthropic.com&sz=64",
                "sitelinks": [
                  "Pro",
                  "Max",
                  "Team"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "$20/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "ChatGPT Pricing - Free, Plus, Pro and Team",
                "url": "https://openai.com/chatgpt/pricing/",
                "displayUrl": "openai.com › chatgpt › pricing",
                "desc": "Plus is $20/month and includes extended messaging, image generation, advanced voice, file uploads and custom GPTs. Team starts at $25 per user/month billed annually.",
                "favicon": "https://www.google.com/s2/favicons?domain=openai.com&sz=64",
                "sitelinks": [
                  "Plus",
                  "Pro",
                  "Team"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "$20/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 33,
            "name": "Online Pharmacy",
            "category": "Medical",
            "description": "Supplement shop with testing seals",
            "query": "Buy supplements online",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "In the U.S. dietary supplements are regulated more like food than like drugs, so manufacturers do not have to prove a product works before selling it. Independent seals such as USP, NSF Certified for Sport or ConsumerLab indicate a batch was tested for identity, potency and contaminants, though not for effectiveness. Some supplements interact with prescription medicines, so it is worth checking with a pharmacist or your doctor before starting one."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3301,
                  "q": "Are supplements approved by the FDA?",
                  "a": "No. The FDA does not review supplements for safety or effectiveness before they go on sale, though it can act against a product after problems are reported."
                },
                {
                  "id": 3302,
                  "q": "What does a USP verified seal mean?",
                  "a": "It means an independent lab confirmed the product contains the listed ingredients in the stated amounts and passed contaminant testing. It is not a claim that the supplement works."
                },
                {
                  "id": 3303,
                  "q": "Can supplements interact with prescription drugs?",
                  "a": "Some can — St John's wort, vitamin K and high-dose fish oil are common examples. Show a pharmacist your full medication list before adding anything new."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Vitamins & Supplements | Shop 30,000+ Products",
                "url": "https://www.iherb.com/c/supplements",
                "displayUrl": "iherb.com › c › supplements",
                "desc": "Browse vitamins, minerals, probiotics and protein by brand or ingredient. Filters for third-party tested, vegan and non-GMO. Ships to over 180 countries.",
                "favicon": "https://www.google.com/s2/favicons?domain=iherb.com&sz=64",
                "sitelinks": [
                  "Vitamins",
                  "Best Sellers",
                  "Brands A-Z",
                  "Deals"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Dietary Supplements: What You Need to Know",
                "url": "https://ods.od.nih.gov/factsheets/WYNTK-Consumer/",
                "displayUrl": "ods.od.nih.gov › factsheets › WYNTK-Consumer",
                "desc": "Fact sheet from the NIH Office of Dietary Supplements covering how supplements are regulated, when they help, safety concerns at high doses, and what to tell your healthcare provider.",
                "favicon": "https://www.google.com/s2/favicons?domain=nih.gov&sz=64",
                "sitelinks": [
                  "Fact Sheets",
                  "Safety Information"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "How to Choose a Supplement Brand You Can Trust",
                "url": "https://www.healthline.com/nutrition/choosing-supplement-brands",
                "displayUrl": "healthline.com › nutrition › supplements",
                "desc": "What third-party testing actually verifies, why label amounts can differ from what is in the bottle, and the claims that are a red flag on a product page.",
                "favicon": "https://www.google.com/s2/favicons?domain=healthline.com&sz=64",
                "sitelinks": [
                  "Third-party testing",
                  "Reading labels"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Jan 22, 2026",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 34,
            "name": "Mental Health App",
            "category": "Medical",
            "description": "Therapy app reviews and pricing",
            "query": "BetterHelp reviews",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "BetterHelp is a subscription counseling service that matches users with licensed therapists for messaging, phone and video sessions. Plans are billed every four weeks and typically work out to roughly $70-$100 per week depending on location and therapist availability; insurance is generally not accepted, though financial aid is offered to some users. Therapists on the platform cannot prescribe medication, and the service is not intended for emergencies or crisis care."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3401,
                  "q": "How much does BetterHelp cost?",
                  "a": "Subscriptions are billed every four weeks and usually come to about $70-$100 per week, covering one live session plus messaging. The exact rate varies by region and therapist."
                },
                {
                  "id": 3402,
                  "q": "Are BetterHelp therapists licensed?",
                  "a": "The platform states its counselors hold state licenses such as LMFT, LCSW or LPC, or a doctorate in psychology. You can ask any therapist for their license type and number."
                },
                {
                  "id": 3403,
                  "q": "Can BetterHelp prescribe medication?",
                  "a": "No. Its counselors are therapists, not prescribers, so medication would need to come from a psychiatrist or your primary care doctor."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Talk to a Licensed Therapist Online | BetterHelp",
                "url": "https://www.betterhelp.com/",
                "displayUrl": "betterhelp.com",
                "desc": "Fill in a short questionnaire and get matched with a counselor, usually within 48 hours. Message any time, plus one live session a week. Switch therapists at no extra cost.",
                "favicon": "https://www.google.com/s2/favicons?domain=betterhelp.com&sz=64",
                "sitelinks": [
                  "How It Works",
                  "Pricing",
                  "FAQ",
                  "Get Started"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "BetterHelp Review 2026: Cost, Therapists, Cancelling",
                "url": "https://www.verywellmind.com/betterhelp-review-5087615",
                "displayUrl": "verywellmind.com › online-therapy › reviews",
                "desc": "Our testers signed up, switched counselors and cancelled to see how each step works. Strongest on scheduling flexibility and messaging; weaker if you need a specialist, insurance billing or medication management.",
                "favicon": "https://www.google.com/s2/favicons?domain=verywellmind.com&sz=64",
                "sitelinks": [
                  "What we liked",
                  "Cost breakdown",
                  "Alternatives"
                ],
                "isSponsored": false,
                "rating": 4,
                "reviews": 0,
                "price": "",
                "date": "Feb 11, 2026",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Has anyone actually stuck with BetterHelp? : r/therapy",
                "url": "https://www.reddit.com/r/therapy/comments/1c8k2xr/",
                "displayUrl": "reddit.com › r/therapy › comments",
                "desc": "218 comments — \"Third therapist was the right fit, so don't judge it on the first match.\" Others found the weekly session length shorter than expected and note that cancelling has to be done in account settings.",
                "favicon": "https://www.google.com/s2/favicons?domain=reddit.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Dec 3, 2025",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 35,
            "name": "Weight Loss Clinic",
            "category": "Medical",
            "description": "GLP-1 clinics with map results",
            "query": "Semaglutide near me",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "places": [
              {
                "id": 3501,
                "name": "Lakeshore Weight & Metabolic Health",
                "rating": 4.7,
                "reviews": "312",
                "price": "$$",
                "category": "Weight loss service",
                "open": "Open",
                "address": "1440 N Wells St",
                "tags": "In-person · Telehealth",
                "note": "Physician-supervised GLP-1 program with monthly check-ins.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3502,
                "name": "Northside Endocrinology & Metabolic Clinic",
                "rating": 4.5,
                "reviews": "186",
                "price": "$$$",
                "category": "Endocrinologist",
                "open": "Closes 5 PM",
                "address": "2201 W Belmont Ave",
                "tags": "In-person · Referral preferred",
                "note": "Accepts most major insurance; wait times run 3-4 weeks.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3503,
                "name": "Meridian Metabolic Care",
                "rating": 4.2,
                "reviews": "94",
                "price": "$$",
                "category": "Telehealth clinic",
                "open": "Open 24 hours",
                "address": "Online consultations",
                "tags": "Telehealth · Prescription if eligible",
                "note": "Video visit and eligibility screening before anything is prescribed.",
                "sponsored": true,
                "thumbs": []
              }
            ],
            "aiOverview": {
              "enabled": true,
              "content": "Semaglutide is a prescription GLP-1 receptor agonist sold as Wegovy for weight management and Ozempic for type 2 diabetes. It is a weekly injection used alongside a reduced-calorie diet and more physical activity; in the main clinical trial adults on Wegovy lost about 15% of their body weight on average over 68 weeks, though individual results varied widely. Nausea, diarrhea, vomiting and constipation are the most common side effects, and it is not suitable for everyone, so a clinician needs to review your medical history first."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3501,
                  "q": "Do I need a prescription for semaglutide?",
                  "a": "Yes, it is prescription-only in the U.S. A clinician will usually check your BMI, other conditions and any personal or family history of thyroid or pancreatic problems before prescribing."
                },
                {
                  "id": 3502,
                  "q": "How much does it cost without insurance?",
                  "a": "List prices run to several hundred dollars a month, though manufacturer savings programs and some clinic plans bring that down. Coverage for weight management specifically varies a lot between insurers."
                },
                {
                  "id": 3503,
                  "q": "Is compounded semaglutide the same thing?",
                  "a": "No. Compounded versions are not FDA-approved, and the agency has warned about dosing errors and products using different salt forms. Ask a clinic exactly what it is prescribing."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Wegovy® (semaglutide) 2.4 mg for Weight Management",
                "url": "https://www.wegovy.com/about-wegovy/what-is-wegovy.html",
                "displayUrl": "wegovy.com › about-wegovy",
                "desc": "Prescription medicine for adults with obesity or excess weight and a weight-related condition, used with a reduced-calorie diet and increased activity. Includes dosing schedule, side effects and savings information.",
                "favicon": "https://www.google.com/s2/favicons?domain=wegovy.com&sz=64",
                "sitelinks": [
                  "How it works",
                  "Side effects",
                  "Savings",
                  "Find a provider"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Semaglutide (Subcutaneous Route) - Side Effects, Dosing",
                "url": "https://www.mayoclinic.org/drugs-supplements/semaglutide-subcutaneous-route/description/drg-20406730",
                "displayUrl": "mayoclinic.org › drugs-supplements › semaglutide",
                "desc": "Proper use, dose escalation over roughly 16 weeks, precautions during pregnancy, and the side effects that warrant calling your doctor. Reviewed by Mayo Clinic pharmacists.",
                "favicon": "https://www.google.com/s2/favicons?domain=mayoclinic.org&sz=64",
                "sitelinks": [
                  "Precautions",
                  "Side effects"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Weight Loss Doctors Near You - Book Online | Zocdoc",
                "url": "https://www.zocdoc.com/search?specialty=weight-loss",
                "displayUrl": "zocdoc.com › search › weight-loss",
                "desc": "Filter by insurance, next available appointment and in-person or video visit. Patient ratings and verified reviews for bariatric physicians, endocrinologists and primary care providers.",
                "favicon": "https://www.google.com/s2/favicons?domain=zocdoc.com&sz=64",
                "sitelinks": [
                  "Today",
                  "Accepts my insurance",
                  "Video visits"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 36,
            "name": "Chiropractor",
            "category": "Medical",
            "description": "Back pain clinics with map pack",
            "query": "Back pain relief clinic",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "places": [
              {
                "id": 3601,
                "name": "Cedar Ridge Chiropractic & Wellness",
                "rating": 4.8,
                "reviews": "418",
                "price": "$$",
                "category": "Chiropractor",
                "open": "Open",
                "address": "118 E Oak St",
                "tags": "In-person · Same-day appointments",
                "note": "New-patient exam and history review before any adjustment.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3602,
                "name": "Riverside Spine & Sports Therapy",
                "rating": 4.6,
                "reviews": "231",
                "price": "$$",
                "category": "Physical therapy clinic",
                "open": "Closes 6 PM",
                "address": "740 Maple Ave",
                "tags": "In-person · Insurance billed",
                "note": "Exercise-based programs for disc and sciatica cases.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3603,
                "name": "Hillcrest Family Chiropractic",
                "rating": 4.4,
                "reviews": "96",
                "price": "$",
                "category": "Chiropractor",
                "open": "Closed · Opens 8 AM Mon",
                "address": "55 Grand Blvd",
                "tags": "In-person · Walk-ins welcome",
                "note": "Evening hours Tuesday and Thursday.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "aiOverview": {
              "enabled": true,
              "content": "Most acute low back pain improves within a few weeks without imaging or surgery. Guidelines from the American College of Physicians suggest starting with non-drug options such as staying active, heat, massage, acupuncture or spinal manipulation before moving to medication. Get medical advice promptly if the pain follows a fall or injury, or comes with fever, unexplained weight loss, leg weakness, numbness, or loss of bladder or bowel control."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3601,
                  "q": "Should I see a chiropractor or a physical therapist?",
                  "a": "Both are used for ordinary mechanical back pain. Chiropractors focus on spinal manipulation, physical therapists on graded exercise and movement retraining; some people are referred to both."
                },
                {
                  "id": 3602,
                  "q": "Does insurance cover chiropractic care?",
                  "a": "Many plans cover a set number of visits a year, often with a copay and sometimes a referral requirement. Check the annual visit limit before committing to a package of sessions."
                },
                {
                  "id": 3603,
                  "q": "Is a chiropractic adjustment safe?",
                  "a": "For most people side effects are mild and short-lived, usually a day or two of soreness. Serious complications are rare, but tell the clinician first about osteoporosis, recent surgery, or numbness and weakness in a limb."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Cedar Ridge Chiropractic - Same-Day Back Pain Visits",
                "url": "https://www.cedarridgechiro.com/back-pain",
                "displayUrl": "cedarridgechiro.com › back-pain",
                "desc": "Exam, movement screen and treatment plan on your first visit. Most major insurance accepted, with self-pay rates listed on the site. Evening appointments available.",
                "favicon": "https://www.google.com/s2/favicons?domain=cedarridgechiro.com&sz=64",
                "sitelinks": [
                  "New patients",
                  "Insurance",
                  "Book online",
                  "Our team"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Back Pain - Diagnosis and Treatment",
                "url": "https://www.mayoclinic.org/diseases-conditions/back-pain/diagnosis-treatment/drc-20369911",
                "displayUrl": "mayoclinic.org › back-pain › diagnosis-treatment",
                "desc": "When imaging is and is not useful, which medications are typically tried first, and the role of physical therapy, manipulation and, rarely, surgery. Includes symptoms that need urgent care.",
                "favicon": "https://www.google.com/s2/favicons?domain=mayoclinic.org&sz=64",
                "sitelinks": [
                  "Symptoms",
                  "Self care",
                  "Preparing for your appointment"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Chiropractors Near You - Read Reviews & Book",
                "url": "https://www.zocdoc.com/chiropractors",
                "displayUrl": "zocdoc.com › chiropractors",
                "desc": "Verified patient reviews, accepted insurance plans and next available openings. Filter by condition, including lower back pain, sciatica and neck pain.",
                "favicon": "https://www.google.com/s2/favicons?domain=zocdoc.com&sz=64",
                "sitelinks": [
                  "Accepts my insurance",
                  "Available today"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 37,
            "name": "Yoga Studio",
            "category": "Medical",
            "description": "Hot yoga studios in Los Angeles",
            "query": "Hot yoga classes LA",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "places": [
              {
                "id": 3701,
                "name": "CorePower Yoga - Hollywood",
                "rating": 4.5,
                "reviews": "640",
                "price": "$$",
                "category": "Yoga studio",
                "open": "Open",
                "address": "6555 Hollywood Blvd",
                "tags": "Hot Power · Sculpt · Drop-in",
                "note": "Heated classes at about 93°F; mat and towel rental at the desk.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3702,
                "name": "Hot 8 Yoga - Santa Monica",
                "rating": 4.6,
                "reviews": "1.1k",
                "price": "$$",
                "category": "Yoga studio",
                "open": "Closes 9 PM",
                "address": "1422 2nd St",
                "tags": "Hot 26 · Hot Vinyasa · Showers",
                "note": "Runs a fixed-sequence class at roughly 105°F for experienced students.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 3703,
                "name": "Modo Yoga LA - Silver Lake",
                "rating": 4.7,
                "reviews": "385",
                "price": "$$",
                "category": "Yoga studio",
                "open": "Open",
                "address": "3245 Sunset Blvd",
                "tags": "Hot · Beginner-friendly · Community classes",
                "note": "Weekly by-donation class; first-timers advised to take breaks.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "aiOverview": {
              "enabled": true,
              "content": "Hot yoga is practiced in a room heated to roughly 90-105°F, which loosens muscles but also raises the risk of dehydration and overheating. Bikram-style classes follow a fixed 90-minute sequence of 26 postures at about 105°F, while hot vinyasa and hot power classes are usually 45-60 minutes and vary by teacher. Most Los Angeles studios rent mats and towels and offer an intro rate for new students; bring water, and check with your doctor first if you are pregnant or have heart or blood-pressure problems."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3701,
                  "q": "How hot is a hot yoga room?",
                  "a": "Usually 90-105°F. Bikram studios run at about 105°F with 40% humidity, while hot vinyasa is often closer to 90-95°F."
                },
                {
                  "id": 3702,
                  "q": "What should I bring to a hot yoga class?",
                  "a": "Water, a towel for your mat and a change of clothes. Most studios rent mats and towels for a few dollars if you would rather travel light."
                },
                {
                  "id": 3703,
                  "q": "Is hot yoga safe for beginners?",
                  "a": "Many studios run a beginner-friendly heated class. Take breaks whenever you need to and sit down if you feel dizzy or nauseated; talk to your doctor first if you are pregnant or have a heart condition."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Hot Yoga Classes in Los Angeles | CorePower Yoga",
                "url": "https://www.corepoweryoga.com/yoga-studios/california/los-angeles",
                "displayUrl": "corepoweryoga.com › yoga-studios › los-angeles",
                "desc": "Heated Yoga Sculpt and Hot Power Fusion classes across LA studios. Intro offer for new students at participating locations. Book from the schedule or the app.",
                "favicon": "https://www.google.com/s2/favicons?domain=corepoweryoga.com&sz=64",
                "sitelinks": [
                  "Class schedule",
                  "Class types",
                  "Memberships",
                  "Locations"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "The Best 10 Hot Yoga Studios near Los Angeles, CA",
                "url": "https://www.yelp.com/search?find_desc=Hot+Yoga&find_loc=Los+Angeles%2C+CA",
                "displayUrl": "yelp.com › search › hot yoga",
                "desc": "\"Room was a real 105 and the teacher kept an eye on the new people.\" Sortable by rating, distance and price, with photos of the studios and current class schedules.",
                "favicon": "https://www.google.com/s2/favicons?domain=yelp.com&sz=64",
                "sitelinks": [
                  "Open now",
                  "Highest rated"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "reviews": 0,
                "price": "$$",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "The 12 best yoga studios in Los Angeles",
                "url": "https://www.timeout.com/los-angeles/health-and-beauty/best-yoga-studios-in-los-angeles",
                "displayUrl": "timeout.com › los-angeles › health and beauty",
                "desc": "From donation-based classes in Silver Lake to heated sequences in Santa Monica, with drop-in prices, what each room is heated to and which ones suit a first-timer.",
                "favicon": "https://www.google.com/s2/favicons?domain=timeout.com&sz=64",
                "sitelinks": [
                  "Silver Lake",
                  "Santa Monica",
                  "Downtown"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Mar 4, 2026",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 38,
            "name": "Personal Injury Lawyer",
            "category": "Finance & Legal",
            "description": "Car accident lawyer, contingency fees",
            "query": "Houston car accident lawyer",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Most Houston car accident lawyers work on contingency, taking roughly 33% of a settlement reached before a lawsuit is filed and about 40% if the case goes into litigation. Case expenses such as filing fees, records requests and expert witnesses are usually deducted separately, so ask whether the percentage is calculated before or after those costs. Texas generally allows two years from the date of the crash to file a personal injury claim, and the state's modified comparative fault rule bars recovery if you are found more than 51% at fault."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3801,
                  "q": "How much does a car accident lawyer cost in Texas?",
                  "a": "Most work on contingency at 33-40% of the recovery, with no hourly fee. You typically pay nothing if the case is lost, though some firms still bill case expenses."
                },
                {
                  "id": 3802,
                  "q": "How long do I have to file a claim after a crash in Texas?",
                  "a": "Two years from the date of the accident in most personal injury cases. Claims against a government entity can require written notice within as little as 90 days."
                },
                {
                  "id": 3803,
                  "q": "Do I need a lawyer for a minor accident?",
                  "a": "Not always. For property damage only, or clear injuries under a few thousand dollars, many people settle directly with the insurer."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Houston Car Accident Lawyers | Free Case Review",
                "url": "https://www.ramirezhalelaw.com/houston/car-accident/",
                "displayUrl": "ramirezhalelaw.com › houston › car-accident",
                "desc": "Contingency fee of 33.3% before suit is filed, 40% after. No fee unless we recover. Offices in the Galleria and Clear Lake, consultations in English and Spanish.",
                "favicon": "https://www.google.com/s2/favicons?domain=ramirezhalelaw.com&sz=64",
                "sitelinks": [
                  "Our Fees",
                  "Case Results",
                  "Contact"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Top Car Accident Lawyers in Houston, TX",
                "url": "https://www.avvo.com/car-accident-lawyer/tx/houston.html",
                "displayUrl": "avvo.com › car-accident-lawyer › tx › houston",
                "desc": "412 attorneys listed with client reviews, peer endorsements and disciplinary history. Filter by years in practice, fee structure and free consultation availability.",
                "favicon": "https://www.google.com/s2/favicons?domain=avvo.com&sz=64",
                "sitelinks": [
                  "Reviews",
                  "Free Consultation",
                  "Ask a Lawyer"
                ],
                "isSponsored": false,
                "rating": 4.5,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 1870
              },
              {
                "id": 3,
                "title": "Texas Car Accident Laws and Time Limits",
                "url": "https://www.findlaw.com/injury/car-accidents/texas-car-accident-laws.html",
                "displayUrl": "findlaw.com › injury › car-accidents",
                "desc": "Texas uses a two-year statute of limitations and a modified comparative fault rule: recovery is reduced by your share of blame and barred entirely above 51%.",
                "favicon": "https://www.google.com/s2/favicons?domain=findlaw.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Mar 4, 2024",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 39,
            "name": "Divorce Attorney",
            "category": "Finance & Legal",
            "description": "Boston family law, rates and filing fees",
            "query": "Family law attorney Boston",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Family law attorneys in the Boston area generally bill $250 to $450 an hour, with an upfront retainer of roughly $3,500 to $7,500 that the hourly rate is drawn against. An uncontested joint petition filed in Suffolk Probate and Family Court costs $215 in court fees, while a contested divorce more often runs into five figures once discovery and hearings are involved. Some firms offer flat-fee packages for uncontested filings or mediation, which is usually the cheaper route when both parties already agree on assets and parenting time."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 3901,
                  "q": "How much does a divorce cost in Massachusetts?",
                  "a": "An uncontested joint petition costs $215 in court fees plus any attorney time, often a flat fee of $1,500-$3,500. Contested cases commonly reach $15,000 or more per side."
                },
                {
                  "id": 3902,
                  "q": "How long does a divorce take in Massachusetts?",
                  "a": "A joint 1A petition becomes final about 120 days after the judgment enters. Contested 1B cases typically take 12 to 18 months."
                },
                {
                  "id": 3903,
                  "q": "Is Massachusetts a 50/50 state?",
                  "a": "No. It is an equitable distribution state, so a judge divides marital property fairly based on factors like length of marriage and each spouse's contribution, which is not always an even split."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Boston Divorce & Family Law Attorneys",
                "url": "https://www.claflinbeckett.com/practice-areas/divorce/",
                "displayUrl": "claflinbeckett.com › practice-areas › divorce",
                "desc": "Hourly rates from $325 with a $5,000 retainer, and flat-fee uncontested filings from $2,200. Mediation and collaborative divorce also available. Downtown Crossing office.",
                "favicon": "https://www.google.com/s2/favicons?domain=claflinbeckett.com&sz=64",
                "sitelinks": [
                  "Fees & Retainers",
                  "Mediation",
                  "Attorneys"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Best Boston, MA Divorce Lawyers | Ratings & Reviews",
                "url": "https://www.avvo.com/divorce-lawyer/ma/boston.html",
                "displayUrl": "avvo.com › divorce-lawyer › ma › boston",
                "desc": "268 Boston divorce attorneys with ratings, client reviews and fee information. Many list free 30-minute consultations and flat-rate uncontested packages.",
                "favicon": "https://www.google.com/s2/favicons?domain=avvo.com&sz=64",
                "sitelinks": [
                  "Reviews",
                  "Cost Guide",
                  "Free Consultation"
                ],
                "isSponsored": false,
                "rating": 4.4,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 2140
              },
              {
                "id": 3,
                "title": "Filing for Divorce in Massachusetts - Court Fees",
                "url": "https://www.mass.gov/info-details/filing-for-divorce",
                "displayUrl": "mass.gov › info-details › filing-for-divorce",
                "desc": "The Probate and Family Court charges a $200 filing fee plus a $15 surcharge and $5 summons. Fee waivers are available if you receive public assistance or show financial hardship.",
                "favicon": "https://www.google.com/s2/favicons?domain=mass.gov&sz=64",
                "sitelinks": [
                  "1A vs 1B",
                  "Fee Waivers",
                  "Find Your Court"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 40,
            "name": "Credit Card",
            "category": "Finance & Legal",
            "description": "Travel card comparison, fees and APRs",
            "query": "Best travel credit cards 2024",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Travel cards fall into roughly three tiers: no annual fee cards earning about 1.5x back, mid-tier cards at $95 a year with 2x-3x on travel and dining, and premium cards at $395 to $695 that offset the fee with airline or hotel credits and lounge access. Ongoing APRs on these cards were commonly quoted in the 20% to 30% variable range through 2024, so the rewards rarely outweigh the interest if a balance is carried. Comparison sites also weight foreign transaction fees, which are 0% on most travel cards but around 3% on general-purpose ones."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4001,
                  "q": "Is a $95 annual fee travel card worth it?",
                  "a": "It depends on spending. A card earning 3x on travel and dining generally needs about $3,000-$4,000 a year in those categories before the extra rewards cover the fee."
                },
                {
                  "id": 4002,
                  "q": "What credit score do travel credit cards require?",
                  "a": "Most issuers look for good to excellent credit, roughly a FICO score of 690 or above. Approval also depends on income, existing balances and recent applications."
                },
                {
                  "id": 4003,
                  "q": "Do travel credit cards charge foreign transaction fees?",
                  "a": "Most do not. General-purpose cards typically add about 3% on purchases made abroad or in a foreign currency."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Best Travel Credit Cards of 2024 - Compared",
                "url": "https://www.nerdwallet.com/best/credit-cards/travel",
                "displayUrl": "nerdwallet.com › best › credit-cards › travel",
                "desc": "23 cards compared on annual fee, rewards rate and redemption value. Annual fees range from $0 to $695; ongoing APRs quoted between 20.24% and 29.99% variable.",
                "favicon": "https://www.google.com/s2/favicons?domain=nerdwallet.com&sz=64",
                "sitelinks": [
                  "No Annual Fee",
                  "Airline Cards",
                  "Hotel Cards",
                  "How We Rate"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Updated Nov 2024",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Travel Rewards Cards: Fees, APRs and Redemption",
                "url": "https://www.bankrate.com/credit-cards/travel/",
                "displayUrl": "bankrate.com › credit-cards › travel",
                "desc": "Breaks down what a point is actually worth by issuer, typically 1.0 to 1.5 cents when redeemed for travel, and flags cards where transfer partners change the maths.",
                "favicon": "https://www.google.com/s2/favicons?domain=bankrate.com&sz=64",
                "sitelinks": [
                  "Point Values",
                  "Card Reviews",
                  "Calculator"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Compare Travel Credit Cards - Rates & Terms",
                "url": "https://creditcards.chase.com/travel-credit-cards",
                "displayUrl": "creditcards.chase.com › travel-credit-cards",
                "desc": "Side-by-side view of annual fees, earn rates and the full rates and fees disclosure for each card. Terms apply; APR varies with the market and your creditworthiness.",
                "favicon": "https://www.google.com/s2/favicons?domain=chase.com&sz=64",
                "sitelinks": [
                  "Rates & Fees",
                  "Compare Cards"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 41,
            "name": "Mortgage Lender",
            "category": "Finance & Legal",
            "description": "Today's mortgage rates by loan term",
            "query": "Current mortgage rates",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Quoted 30-year fixed rates for a conforming loan have recently sat around 6.7%, with 15-year fixed roughly three quarters of a point lower near 5.9%. The rate an individual borrower is offered depends on credit score, down payment, loan size and whether discount points are paid, so the advertised figure usually assumes strong credit and a 20% down payment. Rates published by different sources differ because some report a weekly survey average and others update daily from live lender quotes."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4101,
                  "q": "What is the difference between the rate and the APR?",
                  "a": "The rate is the cost of borrowing alone; the APR folds in points, origination and other lender fees, so it is usually a few tenths of a point higher."
                },
                {
                  "id": 4102,
                  "q": "What credit score do I need for the best mortgage rate?",
                  "a": "Conventional lenders generally reserve their lowest pricing for scores of 760 and above. Below about 680, pricing adjustments start adding meaningfully to the rate."
                },
                {
                  "id": 4103,
                  "q": "Are discount points worth paying?",
                  "a": "One point costs 1% of the loan and typically cuts the rate by around 0.25%. It usually pays off only if you keep the loan past the five-to-seven-year break-even."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Today's Mortgage Rates - 30 Year & 15 Year",
                "url": "https://www.bankrate.com/mortgages/mortgage-rates/",
                "displayUrl": "bankrate.com › mortgages › mortgage-rates",
                "desc": "Daily national averages by loan type, plus a table of lender quotes filtered by state, loan amount and credit band. Includes APR alongside each rate.",
                "favicon": "https://www.google.com/s2/favicons?domain=bankrate.com&sz=64",
                "sitelinks": [
                  "Refinance Rates",
                  "Calculator",
                  "Compare Lenders"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Updated today",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Primary Mortgage Market Survey - Freddie Mac",
                "url": "https://www.freddiemac.com/pmms",
                "displayUrl": "freddiemac.com › pmms",
                "desc": "Weekly survey average for the 30-year and 15-year fixed-rate mortgage, published each Thursday with archive data going back to 1971.",
                "favicon": "https://www.google.com/s2/favicons?domain=freddiemac.com&sz=64",
                "sitelinks": [
                  "Archive",
                  "Methodology"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Thu",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Mortgage Rates Today: What Moved Them This Week",
                "url": "https://www.nerdwallet.com/mortgages/mortgage-rates",
                "displayUrl": "nerdwallet.com › mortgages › mortgage-rates",
                "desc": "Explains why daily quotes and weekly survey averages diverge, and how points included in an advertised rate can understate what a borrower actually pays.",
                "favicon": "https://www.google.com/s2/favicons?domain=nerdwallet.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "2 days ago",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 42,
            "name": "Crypto Exchange",
            "category": "Finance & Legal",
            "description": "Buying Bitcoin: fees and settlement",
            "query": "Buy Bitcoin instantly",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Instant Bitcoin purchases are usually made by debit card or a linked bank account on a regulated exchange, and the convenience is priced in: card purchases commonly carry fees around 2% to 4%, while an ACH transfer costs less but can take three to five business days to clear before funds are withdrawable. Exchanges also add a spread of roughly 0.5% to the quoted price, which is separate from the stated fee. Bitcoin's price is volatile and holdings on an exchange are not insured against market loss, so the amount received can be worth materially more or less shortly after purchase."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4201,
                  "q": "What is the cheapest way to buy Bitcoin?",
                  "a": "A bank transfer on an exchange's advanced trading interface is usually cheapest, often 0.4% or less, but it settles in days rather than instantly."
                },
                {
                  "id": 4202,
                  "q": "How long does a Bitcoin purchase take to settle?",
                  "a": "Card purchases are typically credited within minutes. Bank transfers usually take three to five business days before the funds can be withdrawn."
                },
                {
                  "id": 4203,
                  "q": "Is Bitcoin bought on an exchange insured?",
                  "a": "No. US dollar balances may be eligible for FDIC pass-through coverage at some exchanges, but the crypto itself is not insured against price falls or loss."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Buy Bitcoin (BTC) - Coinbase",
                "url": "https://www.coinbase.com/price/bitcoin",
                "displayUrl": "coinbase.com › price › bitcoin",
                "desc": "Live BTC price, order form and fee schedule. Debit card purchases are credited immediately; ACH transfers clear in three to five business days. Available in 100+ countries.",
                "favicon": "https://www.google.com/s2/favicons?domain=coinbase.com&sz=64",
                "sitelinks": [
                  "Fees",
                  "How It Works",
                  "Sign In"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Kraken Fee Schedule - Maker and Taker Rates",
                "url": "https://www.kraken.com/features/fee-schedule",
                "displayUrl": "kraken.com › features › fee-schedule",
                "desc": "Spot trading starts at 0.25% maker and 0.40% taker and falls with 30-day volume. Instant Buy is priced separately at a higher flat rate plus payment processing.",
                "favicon": "https://www.google.com/s2/favicons?domain=kraken.com&sz=64",
                "sitelinks": [
                  "Funding Fees",
                  "Volume Tiers"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "How to Buy Bitcoin: What the Fees Actually Cost",
                "url": "https://www.investopedia.com/articles/investing/082914/basics-buying-and-investing-bitcoin.asp",
                "displayUrl": "investopedia.com › articles › investing",
                "desc": "Compares exchange spreads, card surcharges and network withdrawal fees, and explains why the advertised rate is rarely the full cost of a small instant purchase.",
                "favicon": "https://www.google.com/s2/favicons?domain=investopedia.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jun 12, 2024",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 43,
            "name": "Tax Prep Service",
            "category": "Finance & Legal",
            "description": "TurboTax sign-in and account recovery",
            "query": "TurboTax login",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "TurboTax accounts sign in through Intuit's shared account system, so the same user ID works for TurboTax, QuickBooks and Credit Karma. If you cannot get in, account recovery uses the phone number or email on file rather than a password reset link alone, and two-factor verification is required on new devices. Returns from prior years stay in the account for seven years and can be downloaded as PDFs from the tax home page."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4301,
                  "q": "How do I recover my TurboTax user ID?",
                  "a": "Use the account recovery page with the email or phone number on the account. Intuit sends a verification code rather than emailing the user ID directly."
                },
                {
                  "id": 4302,
                  "q": "Where do I find last year's tax return?",
                  "a": "Sign in and open Your tax returns and documents on the tax home page. Returns filed with TurboTax are available for seven years as downloadable PDFs."
                },
                {
                  "id": 4303,
                  "q": "Is there a free way to file federal taxes?",
                  "a": "IRS Free File offers guided software at no cost to taxpayers under an adjusted gross income threshold, which was $84,000 for the 2024 tax year."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Sign in to TurboTax Online",
                "url": "https://accounts.intuit.com/app/sign-in?app_group=TTO",
                "displayUrl": "accounts.intuit.com › app › sign-in",
                "desc": "One Intuit account signs in to TurboTax, QuickBooks and Credit Karma. New devices require a verification code sent to the phone number or email on file.",
                "favicon": "https://www.google.com/s2/favicons?domain=intuit.com&sz=64",
                "sitelinks": [
                  "Forgot User ID",
                  "Reset Password",
                  "Create Account"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Can't sign in to my TurboTax account - Support",
                "url": "https://ttlc.intuit.com/community/account-management/help/account-recovery/00/26501",
                "displayUrl": "ttlc.intuit.com › community › account-management",
                "desc": "Covers account recovery when the phone number on file has changed, why a second account is often created by accident, and how to merge prior-year returns.",
                "favicon": "https://www.google.com/s2/favicons?domain=intuit.com&sz=64",
                "sitelinks": [
                  "Account Recovery",
                  "Contact Support"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "IRS Free File: Guided Tax Software",
                "url": "https://www.irs.gov/filing/free-file-do-your-federal-taxes-for-free",
                "displayUrl": "irs.gov › filing › free-file",
                "desc": "Free guided preparation for taxpayers with adjusted gross income at or below $84,000 for the 2024 tax year. Free Fillable Forms are available at any income level.",
                "favicon": "https://www.google.com/s2/favicons?domain=irs.gov&sz=64",
                "sitelinks": [
                  "Find a Provider",
                  "Fillable Forms",
                  "Who Qualifies"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 44,
            "name": "Homes for Sale",
            "category": "Real Estate",
            "description": "Orlando listings with prices and days on market",
            "query": "houses for sale Orlando FL",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "The median list price for a single-family home in Orlando is around $419,000, down roughly 2% year over year as inventory has climbed. Homes are taking about 52 days to go under contract, compared with 31 days two years ago, which has given buyers more room to negotiate repairs and closing costs. Prices vary sharply by area: Lake Nona and Baldwin Park generally run above $500,000, while parts of Pine Hills and south Semoran still list in the $270,000s. Buyers should budget for Florida homeowners insurance, which now averages roughly $3,600 a year statewide."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4401,
                  "q": "Is it a buyer's or seller's market in Orlando right now?",
                  "a": "It leans toward buyers. Active inventory is at about a five-month supply and roughly a third of listings have taken at least one price cut."
                },
                {
                  "id": 4402,
                  "q": "What are property taxes on a $400,000 house in Orange County?",
                  "a": "Expect around $4,000-$4,600 a year at the current millage. Florida's homestead exemption takes $50,000 off the assessed value if it's your primary residence."
                },
                {
                  "id": 4403,
                  "q": "Which Orlando suburbs have the best schools?",
                  "a": "Winter Park, Windermere, Oviedo and Lake Nona consistently rate highest, though home prices in those zones run 15-30% above the metro median."
                }
              ]
            },
            "places": [
              {
                "id": 4411,
                "name": "Cypress Landing at Lake Nona",
                "rating": 4.5,
                "reviews": "212",
                "price": "$$$",
                "category": "New home community",
                "open": "Model home open",
                "address": "1450 Cypress Landing Blvd",
                "tags": "3-5 bed · 2,140-3,380 sq ft",
                "note": "From $438k. Quick move-ins available; HOA $164/mo covers lawn and the pool.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 4412,
                "name": "Magnolia Trace",
                "rating": 4.2,
                "reviews": "96",
                "price": "$$",
                "category": "New home community",
                "open": "Closes 6 PM",
                "address": "820 Magnolia Trace Way, Winter Garden",
                "tags": "3-4 bed · From $362k",
                "note": "Townhome plans on 40-ft lots, about 25 minutes from downtown Orlando.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 4413,
                "name": "Heron Row – Baldwin Park",
                "rating": 4.7,
                "reviews": "58",
                "price": "$$$",
                "category": "Condo building",
                "open": "Open house Sun 1-3 PM",
                "address": "300 Heron Row Ct",
                "tags": "2 bed · 1,310 sq ft · $529k",
                "note": "Resale units only; 18 days on market average over the past year.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Orlando, FL Real Estate - 2,914 Homes For Sale",
                "url": "https://www.zillow.com/orlando-fl/",
                "displayUrl": "zillow.com › FL › Orlando",
                "desc": "Zillow has 2,914 homes for sale in Orlando FL. View listing photos, review sales history, and use our detailed real estate filters to find the perfect place.",
                "favicon": "https://www.google.com/s2/favicons?domain=zillow.com&sz=64",
                "sitelinks": [
                  "Houses",
                  "New Construction",
                  "Price Cuts",
                  "Open Houses"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Orlando, FL Homes for Sale & Real Estate",
                "url": "https://www.redfin.com/city/13655/FL/Orlando",
                "displayUrl": "redfin.com › city › FL › Orlando",
                "desc": "Median list price $419K, down 1.8% from last year. Homes sell in about 52 days. Browse 2,700+ Orlando listings with photos, floor plans and 3D walkthroughs.",
                "favicon": "https://www.google.com/s2/favicons?domain=redfin.com&sz=64",
                "sitelinks": [
                  "Newest Listings",
                  "Open Houses",
                  "Sold Homes",
                  "Market Insights"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "$419,000",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "Orlando home prices slip as listings hit a 5-year high",
                "url": "https://www.orlandosentinel.com/2026/08/21/orlando-housing-inventory-prices/",
                "displayUrl": "orlandosentinel.com › business › real-estate",
                "desc": "Sellers cut asking prices on 34% of Orange County listings in July, the highest share since 2019, as insurance costs and condo assessments pushed buyers to negotiate.",
                "favicon": "https://www.google.com/s2/favicons?domain=orlandosentinel.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Aug 21, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 45,
            "name": "Apartment Rentals",
            "category": "Real Estate",
            "description": "NYC one-bedroom rents, fees and income rules",
            "query": "1 bedroom apartments NYC",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "The median asking rent for a one-bedroom in Manhattan is about $4,300 a month, against roughly $3,450 in Brooklyn and $3,050 in Queens. Most landlords want annual household income of 40 times the monthly rent, so a $3,500 apartment generally needs about $140,000 a year or a guarantor earning 80 times. Listings marked no-fee cover the broker commission themselves; where a fee applies it is typically 12-15% of the first year's rent, due at lease signing. Inventory usually peaks between June and August and is thinnest in December."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4501,
                  "q": "How much do I need to earn to rent a 1 bedroom in NYC?",
                  "a": "Most buildings apply a 40x rule, so roughly $138,000 a year for a $3,450 apartment. A guarantor is usually accepted if they earn 80x and live in the tri-state area."
                },
                {
                  "id": 4502,
                  "q": "What is a broker fee and can I avoid it?",
                  "a": "It's a one-time commission of about 12-15% of annual rent. Since the FARE Act took effect, the party who hires the broker pays it, so most listings are now advertised no-fee."
                },
                {
                  "id": 4503,
                  "q": "Which neighborhoods have the cheapest one-bedrooms?",
                  "a": "Inwood, Bay Ridge, Ridgewood and Sunset Park still list one-bedrooms in the $2,300-$2,700 range, generally 40-55 minutes from Midtown."
                }
              ]
            },
            "places": [
              {
                "id": 4511,
                "name": "The Halstead",
                "rating": 4.2,
                "reviews": "412",
                "price": "$$$",
                "category": "Apartment building",
                "open": "Tours 10 AM-6 PM",
                "address": "610 W 52nd St, Hell's Kitchen",
                "tags": "1 bed · 620 sq ft · $3,995/mo",
                "note": "Doorman, roof deck, in-unit washer/dryer. No fee, 12-month lease, 1 month free.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 4512,
                "name": "Rivet House",
                "rating": 4,
                "reviews": "268",
                "price": "$$",
                "category": "Apartment building",
                "open": "Tours by appointment",
                "address": "18 Borden Ave, Long Island City",
                "tags": "1 bed · 585 sq ft · $3,300/mo",
                "note": "Two stops to Midtown on the 7. Gym and package room; cats and dogs under 40 lb.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 4513,
                "name": "Clarion West",
                "rating": 3.9,
                "reviews": "141",
                "price": "$$",
                "category": "Apartment building",
                "open": "Open house Sat 12-2 PM",
                "address": "255 Clarion Ave, Prospect Lefferts Gardens",
                "tags": "1 bed · 540 sq ft · $2,750/mo",
                "note": "Prewar walk-up, elevator, no laundry in building. Board approval not required.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "1 Bedroom Apartments for Rent in New York, NY",
                "url": "https://www.apartments.com/new-york-ny/1-bedrooms/",
                "displayUrl": "apartments.com › new-york-ny › 1-bedrooms",
                "desc": "See 4,180 one-bedroom rentals in New York with HD photos, floor plans and 3D tours. Filter by no-fee, pet-friendly, laundry in unit and move-in date.",
                "favicon": "https://www.google.com/s2/favicons?domain=apartments.com&sz=64",
                "sitelinks": [
                  "No-Fee Rentals",
                  "Pet Friendly",
                  "Under $3,000",
                  "Luxury"
                ],
                "isSponsored": true,
                "rating": 0,
                "price": "From $2,650/mo",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "NYC 1 Bedroom Apartments for Rent | StreetEasy",
                "url": "https://streeteasy.com/1-bedroom-apartments-for-rent/nyc",
                "displayUrl": "streeteasy.com › for-rent › nyc",
                "desc": "3,612 one-bedroom rentals across Manhattan, Brooklyn and Queens, listed direct by landlords and agents. Median asking rent $3,450, up 2.1% from last year.",
                "favicon": "https://www.google.com/s2/favicons?domain=streeteasy.com&sz=64",
                "sitelinks": [
                  "No Fee",
                  "Manhattan",
                  "Brooklyn",
                  "Rent vs Buy"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "$3,450 median",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 3,
                "title": "New York, NY Apartments for Rent - 1 Bedroom",
                "url": "https://www.zillow.com/new-york-ny/rentals/1-bedrooms/",
                "displayUrl": "zillow.com › new-york-ny › rentals",
                "desc": "Apply to multiple listings with one Zillow application for $35, good for 30 days. Includes credit report, background check and income verification.",
                "favicon": "https://www.google.com/s2/favicons?domain=zillow.com&sz=64",
                "sitelinks": [
                  "Cheap Apartments",
                  "Studios",
                  "Rent Calculator"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 4,
                "title": "What the FARE Act actually changed for NYC renters",
                "url": "https://www.curbed.com/article/nyc-broker-fee-rules-renters-guide.html",
                "displayUrl": "curbed.com › article › nyc-broker-fee-rules",
                "desc": "Tenants no longer pay a commission to a broker they didn't hire. Landlords have responded by folding some of the cost into asking rents, so compare net effective prices.",
                "favicon": "https://www.google.com/s2/favicons?domain=curbed.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Jul 9, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 46,
            "name": "Real Estate Agent",
            "category": "Real Estate",
            "description": "Dallas brokerages, ratings and commission rates",
            "query": "best realtor in Dallas",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Dallas listing agents typically charge 2.5-3% of the sale price, with buyer-side compensation now negotiated separately and written into a buyer representation agreement before the first showing. When comparing agents, the numbers that matter are list-to-sale-price ratio, median days on market and how many closings they have handled in your specific ZIP code, rather than total career volume. Large brokerages such as Compass, Ebby Halliday and Keller Williams dominate the Dallas market, but the individual agent's recent record in your price band is a better signal than the brand on the sign."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4601,
                  "q": "What commission do realtors charge in Dallas?",
                  "a": "Listing agreements usually run 2.5-3%. Since the 2024 NAR settlement, what the buyer's agent earns is negotiated separately and is no longer set by the listing."
                },
                {
                  "id": 4602,
                  "q": "How do I check an agent's license in Texas?",
                  "a": "Search their name on the TREC License Holder Lookup at trec.texas.gov. It shows the license status, expiry date and any disciplinary history."
                },
                {
                  "id": 4603,
                  "q": "Should I pick a big brokerage or a solo agent?",
                  "a": "Brokerage size mainly affects marketing reach. Ask any agent for their last ten closings in your ZIP code and price range, then compare list-to-sale ratios."
                }
              ]
            },
            "places": [
              {
                "id": 4611,
                "name": "Compass – Dallas Uptown",
                "rating": 4.7,
                "reviews": "318",
                "price": "",
                "category": "Real estate agency",
                "open": "Closes 6 PM",
                "address": "2100 McKinney Ave, Suite 700",
                "tags": "Buyer's agent · Listing agent · Relocation",
                "note": "Strongest in Park Cities and Preston Hollow; median sale $915k over the past year.",
                "sponsored": true,
                "thumbs": []
              },
              {
                "id": 4612,
                "name": "Ebby Halliday Realtors – Lakewood",
                "rating": 4.8,
                "reviews": "204",
                "price": "",
                "category": "Real estate agency",
                "open": "Closes 5:30 PM",
                "address": "6301 Gaston Ave",
                "tags": "Listing agent · New construction",
                "note": "Dallas-founded firm, 1945. Averages 99.2% of list price in East Dallas.",
                "sponsored": false,
                "thumbs": []
              },
              {
                "id": 4613,
                "name": "Keller Williams Dallas Midtown",
                "rating": 4.5,
                "reviews": "1.1k",
                "price": "",
                "category": "Real estate agency",
                "open": "Open 24 hours",
                "address": "1400 Midway Rd, Suite 200",
                "tags": "Buyer's agent · First-time buyers",
                "note": "Large agent roster, so ask to be matched by ZIP code rather than by availability.",
                "sponsored": false,
                "thumbs": []
              }
            ],
            "results": [
              {
                "id": 1,
                "title": "Dallas, TX Real Estate Agents & Realtors | Zillow",
                "url": "https://www.zillow.com/professionals/real-estate-agent-reviews/dallas-tx/",
                "displayUrl": "zillow.com › professionals › dallas-tx",
                "desc": "Browse 3,140 Dallas agents with verified client reviews, recent sales, average list-to-sale price and typical response time. Filter by price range and neighborhood.",
                "favicon": "https://www.google.com/s2/favicons?domain=zillow.com&sz=64",
                "sitelinks": [
                  "Top Rated",
                  "Sellers Agents",
                  "Buyers Agents",
                  "Recent Sales"
                ],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 0
              },
              {
                "id": 2,
                "title": "Find a Realtor in Dallas, TX - realtor.com",
                "url": "https://www.realtor.com/realestateagents/dallas_tx",
                "displayUrl": "realtor.com › realestateagents › dallas_tx",
                "desc": "Compare Dallas agents by closed transactions, price range and languages spoken. Profiles show the last 12 months of sales and whether the agent works with first-time buyers.",
                "favicon": "https://www.google.com/s2/favicons?domain=realtor.com&sz=64",
                "sitelinks": [
                  "Agent Reviews",
                  "Sold Listings",
                  "Contact"
                ],
                "isSponsored": false,
                "rating": 4.6,
                "price": "",
                "date": "",
                "thumbnail": "",
                "reviews": 1820
              },
              {
                "id": 3,
                "title": "The Best Real Estate Agents in Dallas, 2026 Edition",
                "url": "https://www.dmagazine.com/real-estate/2026/best-real-estate-agents-dallas/",
                "displayUrl": "dmagazine.com › real-estate › 2026",
                "desc": "Our annual peer-nominated list, verified against MLS closing volume. This year's ranking covers 412 agents across Park Cities, Lakewood, Oak Cliff and Frisco.",
                "favicon": "https://www.google.com/s2/favicons?domain=dmagazine.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "price": "",
                "date": "Mar 4, 2026",
                "thumbnail": "",
                "reviews": 0
              }
            ]
          },
          {
            "id": 47,
            "name": "Movie Review",
            "category": "Entertainment",
            "description": "Dune: Part Two scores and critic reviews",
            "query": "Dune Part 2 reviews Rotten Tomatoes",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "videoDefaults": true,
            "videoDate": "Feb 26, 2024",
            "aiOverview": {
              "enabled": true,
              "content": "Dune: Part Two holds a 92% Tomatometer score on Rotten Tomatoes from around 500 critic reviews, alongside a 95% audience score. Reviewers largely praised Denis Villeneuve's staging of the Arrakis battles, Greig Fraser's photography and Hans Zimmer's score, while a minority found the final act rushed. Its Metacritic score is 79, which Metacritic classifies as generally favourable. Scores shift slightly as late reviews are added."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4701,
                  "q": "Is Dune: Part Two better than the first film?",
                  "a": "Most critics thought so. Part Two's 92% Tomatometer sits above the 83% of the 2021 original, with reviews citing the larger set pieces and a clearer through-line."
                },
                {
                  "id": 4702,
                  "q": "How long is Dune: Part Two?",
                  "a": "2 hours 46 minutes, about eleven minutes longer than the first film."
                },
                {
                  "id": 4703,
                  "q": "Where can I watch Dune: Part Two?",
                  "a": "It streams on HBO Max in the US, and is available to rent or buy on Prime Video, Apple TV and YouTube."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Dune: Part Two - Rotten Tomatoes",
                "url": "https://www.rottentomatoes.com/m/dune_part_two",
                "displayUrl": "rottentomatoes.com › m › dune_part_two",
                "desc": "92% Tomatometer · 95% Popcornmeter. Critics Consensus: thunderous in scale and colder at heart than its predecessor, Villeneuve's sequel gives Paul Atreides' turn a genuine sting.",
                "favicon": "https://www.google.com/s2/favicons?domain=rottentomatoes.com&sz=64",
                "sitelinks": [
                  "Critic Reviews",
                  "Cast & Crew",
                  "Photos"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Dune: Part Two Reviews - Metacritic",
                "url": "https://www.metacritic.com/movie/dune-part-two/",
                "displayUrl": "metacritic.com › movie › dune-part-two",
                "desc": "Metascore 79 from 62 critics · User score 8.5. Read the full reviews from The Guardian, Variety, IndieWire and Empire, plus thousands of user ratings.",
                "favicon": "https://www.google.com/s2/favicons?domain=metacritic.com&sz=64",
                "sitelinks": [
                  "Critic Reviews",
                  "User Reviews"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Dune: Part Two (2024) - IMDb",
                "url": "https://www.imdb.com/title/tt15239678/",
                "displayUrl": "imdb.com › title › tt15239678",
                "desc": "8.5/10 from more than 600K users · 2h 46m · Action, Adventure, Drama. Paul Atreides joins the Fremen to wage war on House Harkonnen and avenge his family.",
                "favicon": "https://www.google.com/s2/favicons?domain=imdb.com&sz=64",
                "sitelinks": [
                  "Full Cast",
                  "User Reviews",
                  "Trivia"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 48,
            "name": "Concert Tickets",
            "category": "Entertainment",
            "description": "Ticketmaster listing with resale and ad",
            "query": "Taylor Swift tickets Ticketmaster",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "videoDefaults": true,
            "videoDate": "Dec 9, 2024",
            "aiOverview": {
              "enabled": true,
              "content": "Taylor Swift's tickets are sold through Ticketmaster, which runs major on-sales under its Verified Fan system: fans register in advance and only a portion receive a code for the presale, with the rest placed on a waiting list. The Eras Tour played its final show in Vancouver on 8 December 2024, so listings today are resale inventory on Ticketmaster's exchange or on sites such as StubHub and SeatGeek. Resale prices are set by sellers and vary widely by section."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4801,
                  "q": "How does Ticketmaster Verified Fan work?",
                  "a": "You register for a specific on-sale ahead of time, Ticketmaster filters out bots and bulk buyers, then sends unique codes to a share of registrants. A code gets you into the queue, not a guaranteed seat."
                },
                {
                  "id": 4802,
                  "q": "Are resale tickets on Ticketmaster legitimate?",
                  "a": "Tickets resold through Ticketmaster's own exchange are cancelled and reissued in the buyer's name, so they scan at the gate. Screenshots or PDFs bought privately often do not."
                },
                {
                  "id": 4803,
                  "q": "How much did Eras Tour tickets cost?",
                  "a": "US stadium face value ran from about $49 to $449, with VIP packages up to roughly $899. Resale listings frequently ran several times higher."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Taylor Swift Tickets | Official Ticketmaster Site",
                "url": "https://www.ticketmaster.com/taylor-swift-tickets/artist/1094215",
                "displayUrl": "ticketmaster.com › taylor-swift-tickets",
                "desc": "Tour dates, presale registration and Verified Resale listings. Every ticket is backed by the Ticketmaster Fan Guarantee and transfers straight to your account.",
                "favicon": "https://www.google.com/s2/favicons?domain=ticketmaster.com&sz=64",
                "sitelinks": [
                  "Tour Dates",
                  "Verified Fan",
                  "Verified Resale",
                  "Fan Guarantee"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Taylor Swift Tickets & Concert Dates | StubHub",
                "url": "https://www.stubhub.com/taylor-swift-tickets",
                "displayUrl": "stubhub.com › taylor-swift-tickets",
                "desc": "Compare resale listings from verified sellers with seat-view photos and all-in pricing. Orders are covered by the FanProtect guarantee; most tickets deliver instantly.",
                "favicon": "https://www.google.com/s2/favicons?domain=stubhub.com&sz=64",
                "sitelinks": [
                  "Seating Charts",
                  "Price Alerts"
                ],
                "isSponsored": false,
                "rating": 4.3,
                "reviews": 18400,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Taylor Swift's Eras Tour Closes at $2.07 Billion Gross",
                "url": "https://www.billboard.com/pro/taylor-swift-eras-tour-final-gross-boxscore/",
                "displayUrl": "billboard.com › pro › eras-tour-final-gross",
                "desc": "The 149-show run ended in Vancouver on December 8, selling more than 10 million tickets across five continents and becoming the first tour to pass $2 billion.",
                "favicon": "https://www.google.com/s2/favicons?domain=billboard.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Dec 9, 2024",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 49,
            "name": "Streaming Service",
            "category": "Entertainment",
            "description": "Streaming comparison with plan pricing",
            "query": "Netflix vs Hulu",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "videoDefaults": true,
            "videoDate": "Aug 12, 2026",
            "aiOverview": {
              "enabled": true,
              "content": "The practical split is catalogue against current-season TV. Netflix carries the larger overall library and far more originals, and its top tier adds 4K HDR and four simultaneous streams; Hulu's draw is next-day episodes from ABC, FX, Fox and Freeform, plus a bundle with Disney+ and ESPN+. Ad-supported plans start around $8 a month on Netflix and around $10-$12 on Hulu, with ad-free plans in the high teens on both. Both services have raised prices most years, so check the current plan page before subscribing."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 4901,
                  "q": "Can I get Netflix and Hulu in one bundle?",
                  "a": "Not from the services themselves. Hulu bundles with Disney+ and ESPN+ through Disney, while Netflix is sold on its own — though some mobile and broadband carriers include it in a plan."
                },
                {
                  "id": 4902,
                  "q": "Which has more content, Netflix or Hulu?",
                  "a": "Netflix has the bigger catalogue and a much larger slate of originals. Hulu's advantage is timing: current-season network shows land the day after they air."
                },
                {
                  "id": 4903,
                  "q": "Does Hulu have live TV?",
                  "a": "Yes. Hulu + Live TV adds roughly 95 live channels along with Disney+ and ESPN+, but it costs several times the on-demand plan."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Netflix Plans and Pricing - Netflix Help Center",
                "url": "https://help.netflix.com/en/node/24926",
                "displayUrl": "help.netflix.com › node › 24926",
                "desc": "Compare Standard with ads, Standard and Premium. Premium supports 4K HDR, spatial audio and four devices at once. Change or cancel your plan online at any time.",
                "favicon": "https://www.google.com/s2/favicons?domain=netflix.com&sz=64",
                "sitelinks": [
                  "Standard with ads",
                  "Premium",
                  "Extra member",
                  "Cancel plan"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Hulu Plans: Stream TV Shows and Movies Online",
                "url": "https://www.hulu.com/plans",
                "displayUrl": "hulu.com › plans",
                "desc": "Full seasons of exclusive series, hit movies and next-day episodes from ABC, FX and Freeform. Bundle Hulu with Disney+ and ESPN+ to cut the monthly cost.",
                "favicon": "https://www.google.com/s2/favicons?domain=hulu.com&sz=64",
                "sitelinks": [
                  "Disney+ Bundle",
                  "Hulu + Live TV",
                  "Student Discount"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Netflix vs Hulu: Which Is Worth It in 2026?",
                "url": "https://www.tomsguide.com/streaming/netflix-vs-hulu",
                "displayUrl": "tomsguide.com › streaming › netflix-vs-hulu",
                "desc": "We timed the ad loads, counted the 4K titles and priced every tier side by side. Netflix takes originals and picture quality; Hulu takes current-season television and the bundle.",
                "favicon": "https://www.google.com/s2/favicons?domain=tomsguide.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Aug 12, 2026",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 50,
            "name": "Video Game",
            "category": "Entertainment",
            "description": "Release date, trailers and delay news",
            "query": "GTA 6 release date",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "videoDefaults": true,
            "videoDate": "May 6, 2025",
            "aiOverview": {
              "enabled": true,
              "content": "Rockstar Games has Grand Theft Auto VI scheduled for 19 November 2026 on PlayStation 5 and Xbox Series X|S, after two delays from its original 2025 window. The game is set in Leonida, a fictional state modelled on Florida, with Vice City at its centre, and follows two playable leads, Jason and Lucia. Rockstar has not announced a PC version or a date for one, and has said dates can move again."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5001,
                  "q": "Has GTA 6 been delayed?",
                  "a": "Twice. It moved from a 2025 window to 26 May 2026, then to 19 November 2026, with Rockstar citing the extra months needed for polish."
                },
                {
                  "id": 5002,
                  "q": "Will GTA 6 come to PC?",
                  "a": "Only PS5 and Xbox Series X|S are confirmed. Earlier entries in the series reached PC a year or more after their console release."
                },
                {
                  "id": 5003,
                  "q": "Who are the main characters in GTA 6?",
                  "a": "Jason and Lucia — the series' first playable female lead — a couple whose story the trailers frame as a Bonnie-and-Clyde run through Leonida."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Grand Theft Auto VI - Rockstar Games",
                "url": "https://www.rockstargames.com/VI",
                "displayUrl": "rockstargames.com › VI",
                "desc": "Coming 19 November 2026 to PlayStation 5 and Xbox Series X|S. Watch Trailer 2, browse the screenshots and follow the Newswire for updates from Rockstar Games.",
                "favicon": "https://www.google.com/s2/favicons?domain=rockstargames.com&sz=64",
                "sitelinks": [
                  "Trailer 2",
                  "Screenshots",
                  "Newswire",
                  "Pre-order"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "GTA 6 Release Date, Trailers and Everything We Know",
                "url": "https://www.ign.com/wikis/gta-6/GTA_6_Release_Date",
                "displayUrl": "ign.com › wikis › gta-6",
                "desc": "Everything confirmed so far: the 19 November date, the Leonida setting, both protagonists, the returning Vice City locations and every detail spotted in the two trailers.",
                "favicon": "https://www.google.com/s2/favicons?domain=ign.com&sz=64",
                "sitelinks": [
                  "Trailer breakdown",
                  "Map",
                  "Characters"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Sep 2, 2026",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "GTA 6 Delayed Again, Now Launching November 19",
                "url": "https://www.gamespot.com/articles/gta-6-delayed-to-november-2026/1100-6531842/",
                "displayUrl": "gamespot.com › articles › gta-6-delayed",
                "desc": "Rockstar said the extra months were needed to finish the game at the level of quality it deserves, pushing the launch out of its spring window and into the holiday quarter.",
                "favicon": "https://www.google.com/s2/favicons?domain=gamespot.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Nov 6, 2025",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 51,
            "name": "Online Course",
            "category": "Education",
            "description": "Beginner Python course results",
            "query": "learn python for beginners",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Most beginner paths start with Python's own tutorial for syntax and one structured course for accountability. The University of Michigan's Python for Everybody on Coursera runs about two months at 10 hours a week and is free to audit, while freeCodeCamp's certification is free end to end. Completion rates for self-paced online courses are low, typically under 15 percent, so a course with graded assignments and deadlines is usually the better bet if you have finished nothing before."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5101,
                  "q": "How long does it take to learn Python?",
                  "a": "Enough to write useful scripts in about 6 to 8 weeks at an hour a day. Job-ready fluency with data structures, testing and a framework usually takes 6 to 12 months."
                },
                {
                  "id": 5102,
                  "q": "Is Python a good first programming language?",
                  "a": "For most people yes: the syntax reads close to English and there is no memory management to learn first. The trade-off is that it hides details you would meet earlier in C."
                },
                {
                  "id": 5103,
                  "q": "Do I need to pay for a Python course?",
                  "a": "No. The python.org tutorial, freeCodeCamp and MIT OpenCourseWare 6.0001 are all free. Paid courses mainly buy graded feedback, a certificate and someone to ask when you are stuck."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Learn Python From Scratch - Interactive Lessons",
                "url": "https://www.datacamp.com/courses/intro-to-python-for-data-science",
                "displayUrl": "datacamp.com",
                "desc": "Write real code in the browser from lesson one, with no setup. Four hours of interactive exercises per course, hints on every task, first chapter free.",
                "favicon": "https://www.google.com/s2/favicons?domain=datacamp.com&sz=64",
                "sitelinks": [
                  "Free Intro Course",
                  "Career Tracks",
                  "Pricing"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "The Python Tutorial — Python 3.13 documentation",
                "url": "https://docs.python.org/3/tutorial/index.html",
                "displayUrl": "docs.python.org › 3 › tutorial",
                "desc": "An informal introduction to the language's basic concepts and features. Covers data structures, modules, classes, errors and the standard library; assumes no prior Python.",
                "favicon": "https://www.google.com/s2/favicons?domain=python.org&sz=64",
                "sitelinks": [
                  "An Informal Introduction",
                  "Data Structures",
                  "Modules",
                  "Classes"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Python for Everybody Specialization",
                "url": "https://www.coursera.org/specializations/python",
                "displayUrl": "coursera.org › specializations › python",
                "desc": "Five-course series from the University of Michigan taught by Charles Severance. Beginner level, roughly two months at 10 hours a week. Free to audit; certificate needs a subscription.",
                "favicon": "https://www.google.com/s2/favicons?domain=coursera.org&sz=64",
                "sitelinks": [
                  "Programming for Everybody",
                  "Python Data Structures",
                  "Enrollment Options"
                ],
                "isSponsored": false,
                "rating": 4.8,
                "reviews": 223400,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 4,
                "title": "Learn Python - Full Course for Beginners",
                "url": "https://www.freecodecamp.org/news/learn-python-free-python-courses-for-beginners/",
                "displayUrl": "freecodecamp.org › news",
                "desc": "A four-hour video course covering variables, loops, functions, file handling and three small projects. Free, no signup, with the finished source on GitHub.",
                "favicon": "https://www.google.com/s2/favicons?domain=freecodecamp.org&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Jan 14, 2026",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 52,
            "name": "University Degree",
            "category": "Education",
            "description": "Accredited online MBA programs",
            "query": "online mba programs",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Online MBA programs from AACSB-accredited business schools generally run 36 to 54 credit hours and take 18 to 36 months part-time. Total tuition varies widely, from roughly $20,000 at a regional state university to well over $100,000 at a top-20 school, and many programs now waive the GMAT for applicants with several years of managerial experience. Employers usually treat an accredited online MBA the same as its on-campus version, since most diplomas do not name the delivery format. The programs that get screened out are the unaccredited ones, so check a school against the AACSB, AMBA or EQUIS directory before paying a deposit."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5201,
                  "q": "Are online MBAs respected by employers?",
                  "a": "From an AACSB- or AMBA-accredited school, generally yes; the diploma is usually identical to the on-campus one. Degrees from unaccredited providers are the ones recruiters discount."
                },
                {
                  "id": 5202,
                  "q": "How much does an online MBA cost?",
                  "a": "Most land between about $20,000 and $90,000 in total tuition. Compare cost per credit hour rather than headline price, since programs range from 30 to 54 credits."
                },
                {
                  "id": 5203,
                  "q": "Can you get an online MBA without the GMAT?",
                  "a": "Many schools waive it for applicants with roughly five years of professional experience or a strong undergraduate GPA, and some have dropped the test requirement altogether."
                },
                {
                  "id": 5204,
                  "q": "How long does an online MBA take?",
                  "a": "About 24 months at a normal pace, or three years part-time while working. Most programs allow five or six years to finish and let you pause between terms."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Online MBA - Kelley School of Business",
                "url": "https://kelley.iu.edu/programs/online-mba/index.html",
                "displayUrl": "kelley.iu.edu",
                "desc": "AACSB-accredited, 51 credit hours, finishable in as few as 24 months. Taught by the same faculty as the residential MBA, and the diploma is identical. GMAT waivers available.",
                "favicon": "https://www.google.com/s2/favicons?domain=iu.edu&sz=64",
                "sitelinks": [
                  "Curriculum",
                  "Tuition & Aid",
                  "Admissions",
                  "Request Info"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Best Online MBA Programs - US News Rankings",
                "url": "https://www.usnews.com/education/online-education/mba/rankings",
                "displayUrl": "usnews.com › online-education › mba",
                "desc": "Ranked list of accredited online MBA programs scored on engagement, faculty credentials, services and peer reputation. Each entry lists cost per credit, credit hours and average work experience.",
                "favicon": "https://www.google.com/s2/favicons?domain=usnews.com&sz=64",
                "sitelinks": [
                  "Methodology",
                  "Cheapest Programs",
                  "No-GMAT Programs"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "The Best Online MBA Programs Of 2026",
                "url": "https://poetsandquants.com/2026/03/04/best-online-mba-programs-2026/",
                "displayUrl": "poetsandquants.com › 2026 › 03",
                "desc": "Our annual ranking weighs admissions standards, career outcomes and cost. Median total tuition rose again this year, with the sharpest jumps at schools that dropped the GMAT entirely.",
                "favicon": "https://www.google.com/s2/favicons?domain=poetsandquants.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Mar 4, 2026",
                "thumbnail": ""
              },
              {
                "id": 4,
                "title": "Find an AACSB-Accredited Business School",
                "url": "https://www.aacsb.edu/accredited-schools",
                "displayUrl": "aacsb.edu › accredited-schools",
                "desc": "Searchable directory of the roughly 1,000 business schools holding AACSB accreditation worldwide, filterable by country, degree level and delivery format, with each school's accreditation date.",
                "favicon": "https://www.google.com/s2/favicons?domain=aacsb.edu&sz=64",
                "sitelinks": [
                  "Search by Country",
                  "What Accreditation Means"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 53,
            "name": "Language Learning",
            "category": "Education",
            "description": "Duolingo vs Babbel comparison",
            "query": "duolingo vs babbel",
            "theme": "dark",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Duolingo is free with ads and built around short gamified lessons and streaks; Babbel is subscription-only, cheaper per month on a longer plan, and organised around dialogue with written grammar explanations. Reviewers tend to give Babbel the edge for reaching conversational A2 to B1 in a European language, and Duolingo the edge on cost, habit-building and choice, since it offers more than 40 courses against Babbel's 14. Neither app reaches fluency on its own; both are usually paired with a tutor or immersion past the intermediate stage."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5301,
                  "q": "Is Babbel better than Duolingo?",
                  "a": "For structured grammar and conversation practice in a European language, most reviewers say so. Duolingo wins on price, daily motivation and the number of languages available."
                },
                {
                  "id": 5302,
                  "q": "Can you become fluent with Duolingo alone?",
                  "a": "No. Finishing a full course leaves most learners around A2 to B1 in reading, with speaking well behind, so conversation practice has to come from somewhere else."
                },
                {
                  "id": 5303,
                  "q": "Is a Babbel subscription worth it?",
                  "a": "A month costs less than a single hour with a tutor, so it pays off if you use it 10 to 15 minutes daily. An annual plan is only worth it once the habit has stuck."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Babbel - Learn a Language in 10 Minutes a Day",
                "url": "https://www.babbel.com/learn-spanish",
                "displayUrl": "babbel.com",
                "desc": "Lessons written by language teachers, not generated. Speech recognition, review sessions and live classes on the higher plan. First lesson free in all 14 languages.",
                "favicon": "https://www.google.com/s2/favicons?domain=babbel.com&sz=64",
                "sitelinks": [
                  "Try a Free Lesson",
                  "Live Classes",
                  "Pricing"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Babbel vs. Duolingo: Which One Should You Use?",
                "url": "https://www.pcmag.com/picks/babbel-vs-duolingo",
                "displayUrl": "pcmag.com › picks",
                "desc": "We spent three months in the Spanish course on each app. Babbel explains grammar and drills dialogue; Duolingo is shorter and stickier but leaves gaps you notice when speaking.",
                "favicon": "https://www.google.com/s2/favicons?domain=pcmag.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Jan 22, 2026",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Duolingo vs Babbel for Spanish? : r/languagelearning",
                "url": "https://www.reddit.com/r/languagelearning/comments/1c8x2qk/duolingo_vs_babbel_for_spanish/",
                "displayUrl": "reddit.com › r/languagelearning",
                "desc": "247 votes, 130 comments. Most people here used Duolingo to build the daily habit, then moved to Babbel or a tutor once they hit the intermediate wall around six months in.",
                "favicon": "https://www.google.com/s2/favicons?domain=reddit.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Apr 2026",
                "thumbnail": ""
              },
              {
                "id": 4,
                "title": "Duolingo - The world's best way to learn a language",
                "url": "https://www.duolingo.com/",
                "displayUrl": "duolingo.com",
                "desc": "Free, bite-sized lessons in more than 40 languages, with streaks and leaderboards to keep you coming back. Super removes ads and unlimited hearts; the core course stays free.",
                "favicon": "https://www.google.com/s2/favicons?domain=duolingo.com&sz=64",
                "sitelinks": [
                  "Spanish",
                  "French",
                  "Duolingo for Schools",
                  "Duolingo English Test"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 54,
            "name": "Fake Celebrity News",
            "category": "Prank",
            "description": "Fictional rapper's leaked clip goes viral",
            "query": "Kian Voss leaked video",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "videoDefaults": true,
            "videoDate": "Mar 2, 2026",
            "aiOverview": {
              "enabled": true,
              "content": "A 40-second clip labelled \"Kian Voss - unreleased\" began circulating on March 1, 2026 and has been reposted widely since. Voss's management describes it as a rough studio take from 2023 that was never cleared for release, and says the upload was unauthorised. No official version has been announced, and several early reuploads have already been removed on copyright grounds."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5401,
                  "q": "Is the Kian Voss leaked video real?",
                  "a": "The footage is genuine studio session video, but it was not released by Voss or his label. His team has called the upload unauthorised and sent takedown notices."
                },
                {
                  "id": 5402,
                  "q": "Where did the Kian Voss clip come from?",
                  "a": "The earliest uploads trace back to a private Discord server on March 1, a few hours before the clip reached X and TikTok."
                },
                {
                  "id": 5403,
                  "q": "Is the track on streaming services?",
                  "a": "No. Nothing from the 2023 sessions has been released, and the label has not confirmed a date."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Kian Voss 'Leaked' Video Is Unreleased Studio Footage",
                "url": "https://www.tmz.com/2026/03/02/kian-voss-leaked-video-studio-session/",
                "displayUrl": "tmz.com › 2026 › 03 › kian-voss-leaked-video",
                "desc": "Sources close to the rapper tell TMZ the 40-second clip going around is a rough take from a 2023 session, and that lawyers sent takedown notices within hours.",
                "favicon": "https://www.google.com/s2/favicons?domain=tmz.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Mar 2, 2026",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Kian Voss leaked clip — full breakdown : r/hiphopheads",
                "url": "https://www.reddit.com/r/hiphopheads/comments/1b2x9kq/kian_voss_leaked_clip_full_breakdown/",
                "displayUrl": "reddit.com › r/hiphopheads › comments",
                "desc": "1.4k votes, 612 comments. Same drum pattern as the Nightline sessions, and you can hear the engineer talking over the second bar. Definitely not a finished mix.",
                "favicon": "https://www.google.com/s2/favicons?domain=reddit.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "1 day ago",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Kian Voss – Unreleased Snippet (Leaked Audio)",
                "url": "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
                "displayUrl": "youtube.com › watch",
                "desc": "412K views · Reuploaded after the original was pulled. Full 40 seconds, plus a side-by-side with the 2023 tracklist in the description.",
                "favicon": "https://www.google.com/s2/favicons?domain=youtube.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Mar 2, 2026",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 55,
            "name": "Fake Virus Alert",
            "category": "Prank",
            "description": "Gaudy fake virus pop-up in the results",
            "query": "my computer says i have 5 viruses",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Full-screen pages claiming a browser has detected viruses are almost always fake. A web page cannot read the files on a computer, so it has no way to count infections. Genuine Microsoft Defender alerts appear in the Windows notification area and never include a countdown timer or a support number. Closing the tab is usually enough; if it will not close, quit the browser from Task Manager and clear that site's stored data before reopening."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5501,
                  "q": "Can a website detect a virus on my computer?",
                  "a": "No. A page can read your browser and operating system version, nothing more. Any site claiming it scanned your drive is guessing."
                },
                {
                  "id": 5502,
                  "q": "Is a security warning with a support number real?",
                  "a": "No. Microsoft and Apple never put a phone number in a security alert. Numbers shown in those pop-ups lead to tech-support scammers."
                },
                {
                  "id": 5503,
                  "q": "How do I close a pop-up that won't go away?",
                  "a": "End the browser process in Task Manager, then reopen it and decline the offer to restore the previous tabs."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "⚠ SYSTEM ALERT: 5 THREATS FOUND — SCAN NOW!!",
                "url": "https://pc-secure-alert-scan.online/warning",
                "displayUrl": "pc-secure-alert-scan.online › warning",
                "desc": "YOUR DEVICE HAS BEEN BLOCKED. 5 threats detected. Hard drive erasure in 04:59. DO NOT CLOSE THIS WINDOW. Certified PC Health Partner™ since 1998.",
                "favicon": "",
                "sitelinks": [
                  "SCAN NOW",
                  "RENEW",
                  "HELP!!"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "How to Tell If a Virus Warning Is Fake",
                "url": "https://www.malwarebytes.com/blog/news/fake-virus-warnings",
                "displayUrl": "malwarebytes.com › blog › news",
                "desc": "Real antivirus alerts come from software already installed on the machine, not from a browser tab. Look for countdown timers, all-caps text and a phone number.",
                "favicon": "https://www.google.com/s2/favicons?domain=malwarebytes.com&sz=64",
                "sitelinks": [
                  "Free Scan",
                  "Scam Guide"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Jan 14, 2026",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Protect yourself from tech support scams - Microsoft Support",
                "url": "https://support.microsoft.com/en-us/windows/protect-yourself-from-tech-support-scams",
                "displayUrl": "support.microsoft.com › windows",
                "desc": "Microsoft error and warning messages never include a phone number. Run a full scan in Windows Security, then uninstall any remote-access software you did not install yourself.",
                "favicon": "https://www.google.com/s2/favicons?domain=microsoft.com&sz=64",
                "sitelinks": [
                  "Report a scam",
                  "Windows Security"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 56,
            "name": "You Won Scam",
            "category": "Prank",
            "description": "Obvious gift card scam, plus the debunk",
            "query": "did i really win a $1000 amazon gift card",
            "theme": "light",
            "platform": "mobile",
            "browserSkin": "safari-ios",
            "aiOverview": {
              "enabled": true,
              "content": "Amazon does not run \"one millionth visitor\" giveaways and does not notify winners through pop-ups, text messages or survey pages. Pages offering a $1,000 gift card in return for completing sponsor offers are affiliate reward schemes: the card is rarely delivered, and the offers typically enrol the visitor in paid subscriptions. Genuine Amazon promotions appear in the Gift Cards section of amazon.com and in the Amazon app, and never ask for a payment to release a prize."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5601,
                  "q": "Does Amazon give away $1,000 gift cards?",
                  "a": "Not through pop-ups or surveys. Amazon runs promotions on its own site and app, and never asks winners to complete offers to claim a prize."
                },
                {
                  "id": 5602,
                  "q": "Why does the page say only 3 prizes are left?",
                  "a": "The countdown and the remaining-prize count are scripted on the page. They reset every time it loads, no matter when you visit."
                },
                {
                  "id": 5603,
                  "q": "I entered my details — what now?",
                  "a": "Change any password you reused elsewhere, watch your card statement for small recurring charges, and expect more phishing to that email address."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "🎁 CONGRATULATIONS! You Are Visitor #1,000,000!",
                "url": "https://rewards-claim-center.top/amazon-1000-gift-card",
                "displayUrl": "rewards-claim-center.top › amazon-1000",
                "desc": "You have been selected for a $1,000 Amazon Gift Card! Complete 12 sponsor offers within 09:58 to claim. Only 3 prizes remain in your area. Hurry!!",
                "favicon": "",
                "sitelinks": [
                  "CLAIM NOW",
                  "Winners",
                  "FAQ?"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Identifying Amazon Gift Card Scams - Amazon Customer Service",
                "url": "https://www.amazon.com/gp/help/customer/display.html?nodeId=GTCSMFXHPMDK6TAQ",
                "displayUrl": "amazon.com › gp › help › customer",
                "desc": "Amazon will never ask you to pay for anything with a gift card, or contact prize winners by text. Report suspicious messages through Report Something Suspicious.",
                "favicon": "https://www.google.com/s2/favicons?domain=amazon.com&sz=64",
                "sitelinks": [
                  "Report Something Suspicious",
                  "Gift Card Balance"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Gift Card Scams | Consumer Advice",
                "url": "https://consumer.ftc.gov/articles/gift-card-scams",
                "displayUrl": "consumer.ftc.gov › articles › gift-card-scams",
                "desc": "Anyone who demands payment by gift card is a scammer. Reported losses topped $200 million last year, with a median loss of about $1,000 per person.",
                "favicon": "https://www.google.com/s2/favicons?domain=ftc.gov&sz=64",
                "sitelinks": [
                  "Report fraud",
                  "Spot a scam"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 57,
            "name": "Fake Arrest Record",
            "category": "Prank",
            "description": "County booking record for a made-up name",
            "query": "Dalton Whitmore arrest records texas",
            "theme": "dark",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "aiOverview": {
              "enabled": true,
              "content": "Texas arrest records are public under the Public Information Act, but a booking entry is not a conviction. The Department of Public Safety's Computerized Criminal History search is the authoritative source; mugshot aggregators often keep entries online long after a charge has been dismissed. Class C misdemeanours that ended in dismissal can usually be sealed by filing a petition for expunction in the county that heard the case."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5701,
                  "q": "Is an arrest record the same as a conviction?",
                  "a": "No. An arrest record shows only that someone was booked. Charges are often dropped, and the entry stays public until it is expunged."
                },
                {
                  "id": 5702,
                  "q": "How do I get a Texas arrest record removed?",
                  "a": "File a petition for expunction in the county where the arrest happened. If the case was dismissed outright, there is normally no waiting period."
                },
                {
                  "id": 5703,
                  "q": "Are mugshot sites official records?",
                  "a": "No. They republish county booking feeds and are not updated when a case is dismissed, so entries there are frequently out of date."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Dalton Whitmore, 34 - Travis County Arrest Record",
                "url": "https://www.jailbase.com/en/sources/tx-tccso/dalton-whitmore/",
                "displayUrl": "jailbase.com › sources › tx-tccso",
                "desc": "Booked Feb 14, 2026 · Charge: public intoxication, Class C misdemeanor · Released on personal recognizance after 6 hours · Case dismissed Mar 3, 2026.",
                "favicon": "https://www.google.com/s2/favicons?domain=jailbase.com&sz=64",
                "sitelinks": [
                  "Travis County",
                  "Search by name"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Texas Arrest Records | StateRecords.org",
                "url": "https://texas.staterecords.org/arrest",
                "displayUrl": "texas.staterecords.org › arrest",
                "desc": "Search Texas arrest records by county. Certified copies must be requested from the arresting agency, and most sheriff's offices charge $10 per record.",
                "favicon": "https://www.google.com/s2/favicons?domain=staterecords.org&sz=64",
                "sitelinks": [
                  "Travis County",
                  "Harris County",
                  "Court Records"
                ],
                "isSponsored": true,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Criminal History Search - Texas DPS",
                "url": "https://www.dps.texas.gov/section/crime-records/criminal-history-search",
                "displayUrl": "dps.texas.gov › crime-records",
                "desc": "The Computerized Criminal History system returns convictions and deferred adjudications for $3 per name search. Third-party mugshot sites are not official records.",
                "favicon": "https://www.google.com/s2/favicons?domain=dps.texas.gov&sz=64",
                "sitelinks": [
                  "Fee schedule",
                  "Error resolution"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              }
            ]
          },
          {
            "id": 58,
            "name": "Fake lottery winner",
            "category": "Prank",
            "description": "Made-up name claims a Powerball jackpot",
            "query": "did Marcus Ellery win the powerball",
            "theme": "light",
            "platform": "desktop",
            "browserSkin": "chrome-desktop",
            "newsDefaults": true,
            "aiOverview": {
              "enabled": true,
              "content": "The Texas Lottery confirmed a single jackpot-winning Powerball ticket for the February 21, 2026 drawing, sold in Round Rock. Winners of prizes of $1 million or more may remain anonymous under Texas law, so a name is released only when the winner consents to it. Claims must be filed within 180 days of the draw date, and the cash-value option must be chosen within 60 days of claiming."
            },
            "paa": {
              "enabled": true,
              "questions": [
                {
                  "id": 5801,
                  "q": "Can Powerball winners stay anonymous in Texas?",
                  "a": "Yes, for prizes of $1 million or more. Texas law keeps the winner's name, address and city out of records released to the public."
                },
                {
                  "id": 5802,
                  "q": "How long do you have to claim a Powerball prize?",
                  "a": "180 days from the draw date in Texas. Choosing the cash option has a separate 60-day deadline after the claim is filed."
                },
                {
                  "id": 5803,
                  "q": "How much is left after taxes?",
                  "a": "Federal withholding takes 24% up front and the top bracket lifts it to 37%. Texas has no state income tax, so nothing further is deducted at state level."
                }
              ]
            },
            "results": [
              {
                "id": 1,
                "title": "Round Rock man claims $189 million Powerball jackpot",
                "url": "https://www.statesman.com/story/news/2026/03/04/round-rock-powerball-jackpot-claimed/",
                "displayUrl": "statesman.com › story › news › 2026 › 03",
                "desc": "Marcus Ellery, 41, matched all six numbers on the Feb 21 drawing with a ticket bought at a Gattis School Road convenience store. He took the $89.4 million cash option.",
                "favicon": "https://www.google.com/s2/favicons?domain=statesman.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Mar 4, 2026",
                "thumbnail": ""
              },
              {
                "id": 2,
                "title": "Powerball Winning Numbers | Texas Lottery",
                "url": "https://www.texaslottery.com/export/sites/lottery/Games/Powerball/Winning_Numbers/",
                "displayUrl": "texaslottery.com › Games › Powerball",
                "desc": "Feb 21, 2026 · 07 · 19 · 33 · 46 · 58 · PB 12 · Power Play 2x. One jackpot ticket sold in Texas. Claims must be filed within 180 days of the draw date.",
                "favicon": "https://www.google.com/s2/favicons?domain=texaslottery.com&sz=64",
                "sitelinks": [
                  "Check Your Numbers",
                  "Claim a Prize",
                  "Past Draws"
                ],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "",
                "thumbnail": ""
              },
              {
                "id": 3,
                "title": "Did a Texas Man Win the Powerball Twice in One Year?",
                "url": "https://www.snopes.com/fact-check/texas-powerball-twice/",
                "displayUrl": "snopes.com › fact-check › texas-powerball-twice",
                "desc": "A widely shared post claims Marcus Ellery hit a second jackpot in November. The Texas Lottery confirmed only one jackpot claim under that name. Rating: False.",
                "favicon": "https://www.google.com/s2/favicons?domain=snopes.com&sz=64",
                "sitelinks": [],
                "isSponsored": false,
                "rating": 0,
                "reviews": 0,
                "price": "",
                "date": "Nov 19, 2026",
                "thumbnail": ""
              }
            ]
          }

    ];

    /*
     * PER-RESULT TAB FIELDS FOR TEMPLATES.
     *
     * The tab layouts read optional fields on each result - duration, channel,
     * publisher, board, comment counts. Writing them into every result object
     * by hand would have meant editing nine nested literals for a handful of
     * strings, and the risk of mangling one is not worth it. Templates that
     * want them set a flag; this fills them in when the template is applied.
     *
     * Only ever fills a field that is EMPTY, so anything a template states
     * explicitly wins, and so re-applying a template cannot overwrite a user's
     * own edits on a result they kept.
     */
    function applyTemplateTabDefaults(tpl, state) {
        if (!tpl || !state || !state.results) return;
        if (tpl.videoDefaults) {
            const dur = ['3:33', '1:05', '4:11', '2:23'];
            state.results.forEach((r, i) => {
                if (!r.duration) r.duration = dur[i % dur.length];
                if (!r.platform) r.platform = 'YouTube';
                /* Derive the channel from the result's own domain rather than a
                   fixed list. The first version hardcoded Rick Astley, which is
                   right for exactly one template and put him on a Drake story
                   the moment a second template used this flag. */
                if (!r.channel) {
                    const host = (r.displayUrl || '').split('/')[0].replace(/^www\./, '');
                    const base = host.split('.')[0] || 'Channel';
                    r.channel = base.charAt(0).toUpperCase() + base.slice(1);
                }
                if (!r.date) r.date = tpl.videoDate || 'Oct 25, 2009';
                if (!r.moments && i === 0) r.moments = 6;
            });
        }
        if (tpl.newsDefaults) {
            const ages = ['1 week ago', '3 weeks ago', 'Apr 27, 2026', '2 days ago'];
            state.results.forEach((r, i) => {
                if (!r.age) r.age = ages[i % ages.length];
                if (!r.sourceName) {
                    const host = (r.displayUrl || '').split('/')[0].replace(/^www\./, '');
                    r.sourceName = host.split('.')[0].replace(/^./, (c) => c.toUpperCase());
                }
            });
        }
        /*
         * CATEGORY DEFAULTS.
         *
         * Five templates were given tab content by hand. There are sixty, and
         * hand-writing places for every dentist and products for every store
         * would be sixty chances to fat-finger a literal for content that is
         * derivable from what the template already says.
         *
         * So: a Local Business template with no places gets places built from
         * its own results, an E-Commerce template with no products gets
         * products, and so on. Anything a template states explicitly is left
         * alone - these only ever fill an EMPTY list.
         *
         * Nothing is invented that the copy does not support. A price is used
         * only if one actually appears in the result's description; a card with
         * a made-up price would be worse than a card with none, because the
         * user would have to notice it was wrong before fixing it.
         */
        const cat = tpl.category || '';
        /*
         * DO NOT DERIVE FROM PLACEHOLDER RESULTS.
         *
         * About fifty of the templates are filler - titles of the form
         * "Official Site for <query>" pointing at example.com. Deriving places
         * from those produces a Maps tab listing "Official Site for Emergency
         * plumber Chicago" as a business name, which looks broken rather than
         * empty and is worse than showing nothing. The empty state at least
         * says where to add content.
         *
         * This is a guard, not a fix: the underlying problem is the filler
         * itself, and it is written up in UNFINISHED-2026-09-08.md.
         */
        const isFiller = (r) =>
            /^Official Site for /.test(r.title || '') ||
            /(^|\.)example\.com/.test(r.displayUrl || '');
        /* Filter per RESULT, not per template. These templates mix one filler
           result with one real one, so an every() test never fired and the junk
           came through anyway - which is what the probe caught. Derive from the
           real ones and drop the rest; if none are real, derive nothing. */
        const usable = (state.results || []).filter((r) => !isFiller(r));

        /*
         * The filler templates, identified STRUCTURALLY.
         *
         * Chasing result text was a losing game: filtering "Official Site for"
         * just exposed the second filler shape underneath it, "Top 10 X
         * Reviews" at reviews.com, and the derived merchant came out as
         * "Reviews". There would have been a third.
         *
         * All 51 generated templates share one exact marker - an AI Overview
         * that begins "This is an AI generated overview for". One condition,
         * no pattern-chasing, and it identifies the template rather than
         * guessing at its parts. Those templates derive nothing, so their tabs
         * show an honest empty state instead of laundering filler into a
         * surface that looks authoritative.
         *
         * The filler itself is a content problem, not a code one. See
         * rebuild/docs/TEMPLATE-QUALITY-2026-09-08.md.
         */
        const generated = /^This is an AI generated overview for/
            .test(((tpl.aiOverview || {}).content) || '');

        const PLACE_CATS = ['Local Business', 'Food & Hospitality', 'Medical', 'Real Estate', 'Food'];
        const SHOP_CATS = ['E-Commerce'];
        const VIDEO_CATS = ['Entertainment', 'Prank'];

        if (!generated && usable.length && PLACE_CATS.indexOf(cat) !== -1 && !(state.places || []).length) {
            /* Ratings and review counts often already live in the result copy
               ("4.2 (1.2k)"), because these templates were written to look like
               local results. Reuse them rather than making numbers up. */
            state.places = usable.slice(0, 3).map((r, i) => {
                const desc = r.desc || '';
                const rate = (desc.match(/(\d\.\d)\s*[\u2605*]?/) || [])[1];
                const revs = (desc.match(/\(([\d.]+k?\+?)\)/i) || [])[1];
                const host = (r.displayUrl || '').split('/')[0].replace(/^www\./, '');
                return {
                    id: Date.now() + Math.random(),
                    name: (r.title || host).split(/\s[-\u2013|]\s/)[0].slice(0, 44),
                    rating: rate ? parseFloat(rate) : '',
                    reviews: revs || '',
                    price: (desc.match(/\$\$+/) || [])[0] || '',
                    category: cat === 'Medical' ? 'Clinic' : (cat === 'Real Estate' ? 'Estate agent' : ''),
                    open: /open/i.test(desc) ? 'Open' : '',
                    address: '',
                    tags: '',
                    note: desc.slice(0, 110),
                    sponsored: !!r.isSponsored,
                    thumbs: r.thumbnail ? [r.thumbnail] : []
                };
            });
        }

        if (!generated && usable.length && SHOP_CATS.indexOf(cat) !== -1 && !(state.products || []).length) {
            state.products = usable.slice(0, 4).map((r) => {
                const desc = r.desc || '';
                /* Only a price the copy actually contains. */
                const prices = desc.match(/\$[\d,]+(?:\.\d{2})?/g) || [];
                const host = (r.displayUrl || '').split('/')[0].replace(/^www\./, '');
                const merchant = r.sourceName ||
                    host.split('.')[0].replace(/^./, (c) => c.toUpperCase());
                return {
                    id: Date.now() + Math.random(),
                    title: r.title || '',
                    price: prices[0] || '',
                    was: prices[1] || '',
                    merchant: merchant,
                    rating: r.rating || '',
                    reviews: (desc.match(/\(([\d.]+k?\+?)\)/i) || [])[1] || '',
                    specs: desc.slice(0, 90),
                    place: '',
                    sale: prices.length > 1,
                    image: r.thumbnail || ''
                };
            });
        }

        if (VIDEO_CATS.indexOf(cat) !== -1) {
            const dur = ['3:33', '1:05', '4:11', '2:23'];
            state.results.forEach((r, i) => {
                if (!r.duration) r.duration = dur[i % dur.length];
                if (!r.platform) r.platform = 'YouTube';
            });
        }

        /* Forums reads a board and a comment count off the lead result. Derived
           from the query rather than stated, so it stays sensible whatever the
           template is about. */
        state.results.forEach((r, i) => {
            if (!r.board) {
                const word = (tpl.query || 'all').split(/\s+/)[0].toLowerCase().replace(/[^a-z0-9]/g, '');
                r.board = 'r/' + (word || 'all');
            }
            if (!r.comments) r.comments = ['70+ comments', '40+ comments', '30+ comments'][i % 3];
            if (!r.age) r.age = ['1 year ago', '6mo', '8mo'][i % 3];
        });
    }

    function getDefaultState() {
        return {
            advancedMode: false,
            query: 'iTechVista Services',
            location: 'New York, NY',
            platform: 'mobile', 
            theme: 'light',             
            browserSkin: 'safari-ios',
            editorTheme: 'dark',
            time: '9:41',
            battery: 100,
            textSize: 'md',
            hideExitButton: false,
            hideStatusIcons: false, 
            hideTime: false, 
            aiOverview: { enabled: false, content: 'Based on search results, iTechVista offers comprehensive web tools and simulation services.' },
            paa: { enabled: false, questions: [{id: 1, q: "Is this tool free?", a: "Yes, basic features are free."}] },
            knowledgePanel: { enabled: false, title: 'iTechVista', subtitle: 'Technology Company', desc: 'iTechVista is an enterprise technology solutions provider.', url: '', logo: '' },
            localPack: { enabled: false, query: 'Tech companies near me' },
            /* Which tab the preview is showing. Saved, so reopening a project
               lands you back where you left it. */
            activeTab: 'All',
            /* Products drive the Shopping tab. Same reasoning as places: a
               product has a price, a merchant and a discount and no URL, so it
               is not a web result wearing a hat. */
            products: [
                {
                    id: 1, title: 'Apple AirPods Max 2 - Blue', price: '$449.99', was: '$550',
                    merchant: 'Target', rating: 4.6, reviews: '1k+',
                    specs: 'On-ear \u00b7 Bluetooth \u00b7 20 hours', place: 'Charlotte',
                    sale: true, image: ''
                }
            ],
            /* Places drive the Maps tab. They are NOT web results - a place has
               a rating, an address and opening hours and no URL - so forcing
               them through `results` would have meant a row of blank fields on
               every other tab. */
            places: [
                {
                    id: 1,
                    name: 'Qahwah House Coffee',
                    rating: 4.9, reviews: 745, price: '$10-20', category: 'Coffee shop',
                    open: 'Open', address: '1318 Pecan Avenue',
                    tags: 'Dine-in \u00b7 Takeout \u00b7 No delivery',
                    note: 'Yemeni coffee - highest quality coffee from our own family.',
                    sponsored: false, thumbs: []
                }
            ],
            topStories: { enabled: false, query: 'Technology News' },
            branding: { url: '', opacity: 0.5 },
            results: [
                {
                    id: 1,
                    title: 'iTechVista | Enterprise Technology Solutions',
                    url: 'https://itechvista.com',
                    displayUrl: 'itechvista.com',
                    desc: 'Leading provider of digital transformation services. We specialize in web development, cloud infrastructure, and AI integration for modern businesses.',
                    favicon: '', 
                    sitelinks: ['About Us', 'Services', 'Contact', 'Blog'],
                    isSponsored: false,
                    rating: 0,
                    reviews: 0,
                    date: '',
                    thumbnail: ''
                }
            ]
        };
    }